/* tslint:disable */
/* eslint-disable */
/**
 * MWS.FinanceService.WebApp | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddressDto {
    'name'?: string | null;
    'companyName'?: string | null;
    'phoneNumber'?: string | null;
    'vatNumber'?: string | null;
    'cpfNumber'?: string | null;
    'rgNumber'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'selectedState'?: StateResponse | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'companyRegistrationNumber'?: string | null;
    'vatNumberCheckStatus'?: PublicVatNumberCheckStatus | null;
}


export interface AddressEntity {
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'id': string;
    'dateCreated': Date;
    'createdBy': string;
    'dateModified': Date;
    'modifiedBy': string;
}
export interface AddressRequestDto {
    'name'?: string | null;
    'phoneNumber'?: string | null;
    'phoneNumberCountryCode'?: string | null;
    'companyName'?: string | null;
    'vatNumber'?: string | null;
    'cpfNumber'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
}
export interface AdminAdyenMerchantResponse {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'name': string;
}
export interface AdminCheckoutCustomerResponse {
    'id': string;
    'userId'?: string | null;
    'emailAddress'?: string | null;
    'firstName'?: string | null;
    'lastName'?: string | null;
}
export interface AdminCheckoutOrderResponse {
    'id': string;
    'orderNumber': string;
    'dateCreated': Date;
    'datePaid'?: Date | null;
    'paymentStatus': OrderPaymentStatus;
    'itemsTotal': PriceResponse;
    'isFramingOrder': boolean;
    'dateShipped'?: Date | null;
}


export interface AdminCheckoutResponse {
    'id': string;
    'dateCreated': Date;
    'customer': AdminCheckoutCustomerResponse;
    'orders': Array<AdminCheckoutOrderResponse>;
    'transactions': Array<TransactionResponse>;
}
export interface AdminCountryResponse {
    'id': string;
    'countryCode'?: string | null;
    'name'?: string | null;
    'localVatPercentage': number;
    'flag'?: string | null;
    'continentCode'?: string | null;
    'europeanUnion': boolean;
    'paymentVerificationAlwaysRequired'?: boolean | null;
    'states'?: Array<AdminStateResponse> | null;
}
export interface AdminCustomerAddressResponse {
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'id': string;
    'name': string;
    'phoneNumber': string;
    'phoneNumberCountryCode': string;
    'companyName': string;
    'vatNumber': string;
    'cpfNumber': string;
    'rgNumber': string;
    'isBillingAddress': boolean;
    'isShippingAddress': boolean;
    'addressLine1': string;
    'addressLine2': string;
    'city': string;
    'state': string;
    'zipCode': string;
    'countryCode': string;
    'vatNumberCheckStatus': PublicVatNumberCheckStatus;
}


export interface AdminCustomerResponse {
    'dateCreated': Date;
    'createdBy': string;
    'addressReminderSent': boolean;
    'trustProfile': AdminTrustProfileResponse;
    'id': string;
    'userId': string;
    'emailAddress': string;
    'firstName': string;
    'lastName': string;
    'phoneNumber': string;
    'countryCode': string;
    'accountName': string;
    'platformId'?: string | null;
    'modifiedBy': string;
    'dateModified': Date;
    'addresses': Array<CustomerAddressDto>;
    'businessIdentifiers': BusinessIdentifiersDto;
    'shippingBlocked': boolean;
}
export interface AdminEventSettingsResponse {
    'id': string;
    'name': string;
    'legalOrganisationId': string;
    'vendorId': string;
    'adyenMerchantId': string;
    'defaultShippingOfficeId': string;
    'isArchived': boolean;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface AdminFramingOrderDto {
    'orderItems': Array<AdminOrderItemDto>;
    'modifiedBy': string;
    'createdBy': string;
    'shippingOfficeId': string;
    'originalOrderId'?: string | null;
    'originalOrder': AdminOrderDto;
    'framingStatus': FramingStatus;
    'isFramingOrder': boolean;
    'notesForCustomer': Array<NoteDto>;
    'notesForOrder': Array<NoteDto>;
    'manualShipped': boolean;
    'id': string;
    'orderNumber': string;
    'dateCreated': Date;
    'dateModified': Date;
    'framingWindowExpiresAt'?: Date | null;
    'customerId'?: string | null;
    'contractId': string;
    'currentInvoiceId': string;
    'status': OrderPaymentStatus;
    'invoiceDisabled': boolean;
    'parcel'?: ParcelDto | null;
    'customer'?: CustomerDto | null;
    'shippingAddress'?: AddressDto | null;
    'awaitingFraming': boolean;
}


export interface AdminGlobalShippingConfigDto {
    'id': string;
    'platformId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'name'?: string | null;
    'dhlFuelPercentage': number;
    'shippingInsurancePercentage': number;
    'mwsShipmentProcessingPercentage': number;
}
export interface AdminInvoiceItemDto {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'customerInvoiceId': string;
    'vendorInvoiceId': string;
    'orderItemId': string;
    'value': number;
    'vatValue': number;
    'totalValue': number;
}
export interface AdminLegalOrganisationDto {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'name'?: string | null;
    'abbreviation'?: string | null;
    'vatNumber'?: string | null;
    'eoriNumber'?: string | null;
    'kvk'?: string | null;
    'iban'?: string | null;
    'bic'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'selectedState'?: StateResponse | null;
    'invoiceBrandType': InvoiceBrandType;
}


export interface AdminOrderDocumentDto {
    'id': string;
    'orderId': string;
    'customerId': string;
    'vendorId': string;
    'modifiedBy': string;
    'createdBy': string;
    'order'?: OrderDto | null;
    'documentType': OrderDocumentType;
    'customer'?: AdminCustomerResponse | null;
    'dateCreated': Date;
    'dateModified': Date;
    'invoiceItems'?: Array<AdminInvoiceItemDto> | null;
    'reference'?: string | null;
    'total': number;
}


export interface AdminOrderDto {
    'platformId': string;
    'orderItems': Array<AdminOrderItemDto>;
    'modifiedBy': string;
    'createdBy': string;
    'shippingOfficeId': string;
    'originalOrderId'?: string | null;
    'framingOrder'?: AdminOrderDto | null;
    'originalOrder'?: AdminOrderDto | null;
    'framingStatus': FramingStatus;
    'pendingFtgPayment': boolean;
    'isFramingOrder': boolean;
    'notesForCustomer': Array<NoteDto>;
    'notesForProducts': Array<NoteDto>;
    'notesForOrder': Array<NoteDto>;
    'manualShipped': boolean;
    'paymentReminders': Array<PaymentReminderDto>;
    'paymentFee': number;
    'customerEmailAddress': string;
    'datePaid'?: Date | null;
    'dateShipped'?: Date | null;
    'businessUnit': BusinessUnit;
    'shippingBlocked': boolean;
    'customerShippingBlocked': boolean;
    'ftgOdooOrderUrl'?: string | null;
    'mwsOdooOrderUrl'?: string | null;
    'id': string;
    'orderNumber': string;
    'dateCreated': Date;
    'dateModified': Date;
    'framingWindowExpiresAt'?: Date | null;
    'customerId'?: string | null;
    'contractId': string;
    'currentInvoiceId': string;
    'status': OrderPaymentStatus;
    'invoiceDisabled': boolean;
    'parcel'?: ParcelDto | null;
    'customer'?: CustomerDto | null;
    'shippingAddress'?: AddressDto | null;
    'awaitingFraming': boolean;
}


export interface AdminOrderItemDto {
    'modifiedBy': string;
    'createdBy': string;
    'certificateNumber'?: string | null;
    'fabricksTrackableProductId'?: string | null;
    'isFabricksAuthenticated': boolean;
    'inventoryLocationCode'?: string | null;
    'id': string;
    'eventId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'orderId': string;
    'externalId': string;
    'productId'?: string | null;
    'orderItemType': OrderItemType;
    'values': { [key: string]: number; };
    'currencyCode': string;
    'eventName': string;
    'productName': string;
    'productDescription': string;
    'quantity': number;
    'displayName': string;
    'productImageUrl': string;
    'shippingType': ShippingType;
    'specifications': Array<OrderItemSpecificationDto>;
}


export interface AdminOrderWithPlatformNameDto {
    'platformName'?: string | null;
    'platformId': string;
    'orderItems': Array<AdminOrderItemDto>;
    'modifiedBy': string;
    'createdBy': string;
    'shippingOfficeId': string;
    'originalOrderId'?: string | null;
    'framingOrder'?: AdminOrderDto | null;
    'originalOrder'?: AdminOrderDto | null;
    'framingStatus': FramingStatus;
    'pendingFtgPayment': boolean;
    'isFramingOrder': boolean;
    'notesForCustomer': Array<NoteDto>;
    'notesForProducts': Array<NoteDto>;
    'notesForOrder': Array<NoteDto>;
    'manualShipped': boolean;
    'paymentReminders': Array<PaymentReminderDto>;
    'paymentFee': number;
    'customerEmailAddress': string;
    'datePaid'?: Date | null;
    'dateShipped'?: Date | null;
    'businessUnit': BusinessUnit;
    'shippingBlocked': boolean;
    'customerShippingBlocked': boolean;
    'ftgOdooOrderUrl'?: string | null;
    'mwsOdooOrderUrl'?: string | null;
    'id': string;
    'orderNumber': string;
    'dateCreated': Date;
    'dateModified': Date;
    'framingWindowExpiresAt'?: Date | null;
    'customerId'?: string | null;
    'contractId': string;
    'currentInvoiceId': string;
    'status': OrderPaymentStatus;
    'invoiceDisabled': boolean;
    'parcel'?: ParcelDto | null;
    'customer'?: CustomerDto | null;
    'shippingAddress'?: AddressDto | null;
    'awaitingFraming': boolean;
}


export interface AdminPaymentTokenResponse {
    'id': string;
    'lastFourDigits'?: string | null;
    'brand'?: string | null;
    'expirationDate'?: string | null;
    'cardAddedDate': Date;
    'isDefault': boolean;
    'isProcessing': boolean;
}
export interface AdminPreAuthorisationResponse {
    'id': string;
    'dateCreated': Date;
    'status': PreAuthorisationStatus;
    'releasedAt'?: Date | null;
    'capturedAt'?: Date | null;
    'cancelledByBankAt'?: Date | null;
    'pspReference'?: string | null;
    'paymentToken'?: AdminPaymentTokenResponse | null;
    'amount': PriceResponse;
}


export interface AdminStateResponse {
    'id': string;
    'isoCode'?: string | null;
    'name'?: string | null;
}
export interface AdminTrustProfileResponse {
    'waiveEscalatedPaymentReminders': boolean;
    'waiveSuspensionOnUnpaidOrder': boolean;
    'waiveSuspiciousBidAlerts': boolean;
    'waiveSuspensionOnMaliciousPhoneNumber': boolean;
    'waiveBidLimitVerification': boolean;
    'preAuthorisationExemptionInEuroCents': number;
}
export interface AdminVendorInvoiceDto {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'reference'?: string | null;
    'invoiceItems'?: Array<AdminInvoiceItemDto> | null;
    'vendorId': string;
    'eventId': string;
    'totalShippingCost': number;
    'totalPaymentFee': number;
    'totalCosts': number;
    'isFinal': boolean;
    'mwsTotal': number;
    'vendorTotal': number;
}
export interface AdyenMerchantEntity {
    'name'?: string | null;
    'id': string;
    'dateCreated': Date;
    'createdBy': string;
    'dateModified': Date;
    'modifiedBy': string;
}

export enum AppliesPer {
    Event = 'event',
    Season = 'season'
}


export interface ArchiveRequest {
    'isArchived': boolean;
}

export enum AuthenticatedByFabricksFilterType {
    ShowAll = 'showAll',
    Yes = 'yes',
    No = 'no'
}


export interface BidCostsResponse {
    'bid': PriceResponse;
    'bidInEuro': PriceResponse;
    'buyersPremium'?: PriceResponse | null;
    'buyersPremiumPercentage'?: number | null;
    'estimatedShippingCost'?: PriceResponse | null;
    'vat'?: PriceResponse | null;
    'vatPercentage'?: number | null;
    'handlingVatPercentage'?: number | null;
    'totalPrice': PriceResponse;
    'shippingOfficeName': string;
    'vatNumberCheckStatus': PublicVatNumberCheckStatus;
    'salesTaxType': PublicSalesTaxType;
    'itemVatExplanationResponse': VatExplanationResponse;
    'handlingVatExplanationResponse': VatExplanationResponse;
    'biddingBlocked': boolean;
    'biddingBlockedReason'?: PublicBiddingBlockedReason | null;
    'shippingOfficeCountryCode'?: string | null;
    'estimatedLandedCosts'?: EstimatedLandedCostsResponse | null;
}


export interface BlockInstallmentRequest {
    'comment': string;
}
export interface Breakdown {
    'name'?: string | null;
    'price': number;
    'priceBreakdown'?: Array<PriceBreakdown> | null;
    'serviceCode'?: string | null;
    'localServiceCode'?: string | null;
    'serviceTypeCode'?: string | null;
    'isCustomerAgreement'?: boolean | null;
    'isMarketedService'?: boolean | null;
}
export interface BundledOrdersResponse {
    'id': string;
    'orderNumber': string;
}
export interface BusinessIdentifierRequestDto {
    'cpf'?: string | null;
    'vat'?: string | null;
    'eori'?: string | null;
    'rg'?: string | null;
}

export enum BusinessIdentifierType {
    Cpf = 'cpf',
    Vat = 'vat',
    Eori = 'eori',
    Rg = 'rg'
}


export interface BusinessIdentifiersDto {
    'cpf': string;
    'vat': string;
    'eori': string;
    'rg': string;
}

export enum BusinessUnit {
    Mws = 'mws',
    Ftg = 'ftg'
}


export interface ContactInformation {
    'companyName'?: string | null;
    'fullName'?: string | null;
}
export interface ContractCostDto {
    'description': string;
    'type': CostType;
    'amount': number;
    'deductionSource': DeductionSourceType;
    'deductFrom'?: DeductFromType | null;
    'productTypeId'?: string | null;
    'excludeFromReporting': boolean;
}


export interface ContractDto {
    'id': string;
    'defaultEventSettingsId'?: string | null;
    'contractType': ContractType;
    'locked': boolean;
    'partnerId': string;
    'partner'?: PartnerDto | null;
    'season'?: ContractSeasonDto | null;
    'name': string;
    'ourPaymentFeePercentage': number;
    'ourShippingCostPercentage': number;
    'ourVatPercentage': number;
    'buyersPremiumFeePercentage': number;
    'setupFee': number;
    'setupFeeAppliesPer': AppliesPer;
    'remainingSponsorshipReserve': number;
    'certificationFee': number;
    'createdBy': string;
    'modifiedBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'partnership0PercentThreshold': number;
    'partnership25PercentThreshold': number;
    'protectionClause'?: number | null;
    'costs': Array<ContractCostDto>;
    'status': ContractStatus;
    'activatedProtectionClauseOn'?: Date | null;
    'minimumProductPrice': number;
    'buyInPrice': number;
    'currencyCode': string;
    'ourSalesPercentage': number;
    'proceedBrackets': Array<ContractProceedBracketDto>;
    'payoutInstallmentPerEvent': boolean;
    'installmentBrackets': Array<ContractInstallmentBracketDto>;
    'variableFeeGuarantee': number;
    'variableFeeGuaranteeAppliesPer': AppliesPer;
    'fixedFee': number;
    'fixedFeeAppliesPer': AppliesPer;
    'numberOfEvents'?: number | null;
    'effectiveDate'?: Date | null;
    'expiryDate'?: Date | null;
    'recipientAddress'?: AddressDto | null;
    'grossMinimumProceeds': number;
    'grossMinimumProceedsPercentage'?: number | null;
    'netMinimumProceedsPercentage'?: number | null;
    'contractProgress'?: ContractProgressResponse | null;
}


export interface ContractInstallmentBracketDto {
    'id'?: string | null;
    'name': string;
    'dueDate': Date;
    'amount': number;
    'payoutSource': ContractPayoutSource;
}


export interface ContractPayoutInstallmentResponse {
    'id': string;
    'name': string;
    'dueDate': Date;
    'initialDueDate'?: Date | null;
    'amount': number;
    'paidOn'?: Date | null;
    'payoutStatus': ContractPayoutStatus;
    'invoiceDocumentUrl'?: string | null;
    'proofOfPaymentDocumentUrl'?: string | null;
    'comment'?: string | null;
    'payoutSource': ContractPayoutSource;
}


export interface ContractPayoutResponse {
    'installments': Array<ContractPayoutInstallmentResponse>;
}

export enum ContractPayoutSource {
    Manual = 'manual',
    VariablePayout = 'variablePayout',
    EventsPredictedPayout = 'eventsPredictedPayout',
    EventsProformaFinancaialReportPayout = 'eventsProformaFinancaialReportPayout',
    EventsFinalFinancialReportPayout = 'eventsFinalFinancialReportPayout'
}



export enum ContractPayoutStatus {
    Open = 'open',
    Blocked = 'blocked',
    Paid = 'paid',
    Postponed = 'postponed'
}


export interface ContractProceedBracketDto {
    'totalProceedThreshold': number;
    'percentage': number;
}
export interface ContractProgressBreakdownResponse {
    'totalGrossProceeds': number;
    'totalNetProceeds': number;
    'totalGrossCosts': number;
    'totalPartnerCosts': number;
    'totalMwsCosts': number;
    'totalMwsShare': number;
    'totalMwsPayout': number;
    'totalPartnerPayout': number;
    'grossMwsSharePercentage'?: number | null;
    'grossMwsPayoutPercentage'?: number | null;
    'grossPartnerPayoutPercentage'?: number | null;
    'netMwsSharePercentage'?: number | null;
    'netMwsPayoutPercentage'?: number | null;
    'netPartnerPayoutPercentage'?: number | null;
    'numberOfEvents': number;
    'averageGrossProceedsPerEvent'?: number | null;
    'averageNetProceedsPerEvent'?: number | null;
    'averageGrossCostsPerEvent'?: number | null;
    'averagePartnerCostsPerEvent'?: number | null;
    'averageMwsCostsPerEvent'?: number | null;
    'averageMwsSharePerEvent'?: number | null;
    'averagePartnerPayoutPerEvent'?: number | null;
    'averageMwsPayoutPerEvent'?: number | null;
}
export interface ContractProgressResponse {
    'additionalEvents': number;
    'contractCurrencyExchangeRate': number;
    'currencyCode'?: string | null;
    'minimum'?: ContractProgressBreakdownResponse | null;
    'current': ContractProgressBreakdownResponse;
    'expected': ContractProgressBreakdownResponse;
    'target'?: ContractProgressBreakdownResponse | null;
    'totalAmountPaidOutToPartner': number;
    'lastCalculatedDate': Date;
}
export interface ContractProgressSummaryResponse {
    'grossMinimumProceeds'?: number | null;
    'grossTargetProceeds'?: number | null;
    'grossExpectedProceeds': number;
    'grossCurrentProceeds': number;
    'partnerPayoutMinimumProceeds'?: number | null;
    'partnerPayoutTargetProceeds'?: number | null;
    'partnerPayoutExpectedProceeds': number;
    'partnerPayoutCurrentProceeds': number;
    'actualEventsCount': number;
    'expectedEventsCount': number;
    'additionalEventsCount': number;
    'minimumEventsCount': number;
    'netCurrentProceeds': number;
    'netExpectedProceeds': number;
    'actualCurrentPartnerPayout': number;
    'mwsShare': number;
    'totalExpectedCosts': number;
    'totalExpectedPartnerCosts': number;
    'totalExpectedMwsCosts': number;
    'weightedAveragePartnerExpectedProceedsPercentage': number;
    'weightedAverageNetExpectedProceedsPercentage': number;
}
export interface ContractSeasonDto {
    'id': string;
    'name': string;
    'isCurrent': boolean;
}
export interface ContractSeasonResponse {
    'id': string;
    'name': string;
    'isCurrent': boolean;
}

export enum ContractStatus {
    Active = 'active',
    Archived = 'archived',
    Deleted = 'deleted'
}



export enum ContractType {
    Collaboration = 'collaboration',
    Partnership = 'partnership',
    Pilot = 'pilot'
}


export interface CostEstimateResponse {
    'basePriceExclVat': number;
    'shippingCosts': number;
    'vatMultiplier': number;
    'vatAmount': number;
    'insufficientDataProvided': boolean;
    'totalPrice': number;
    'discountPercentage': number;
    'shippingOfficeName': string;
    'shippingOfficeCountryCode': string;
}

export enum CostType {
    CostDeductionPerProduct = 'costDeductionPerProduct',
    CostDeductionPerEvent = 'costDeductionPerEvent',
    PercentageCostPerProduct = 'percentageCostPerProduct',
    PercentageCostPerEvent = 'percentageCostPerEvent',
    CostDeductionPerProductType = 'costDeductionPerProductType',
    PercentageCostPerProductType = 'percentageCostPerProductType',
    CostDeductionPerSeason = 'costDeductionPerSeason'
}


export interface CreateContractRequestDto {
    'seasonId'?: string | null;
    'defaultEventSettingsId'?: string | null;
    'partnerId': string;
    'name'?: string | null;
    'ourShippingCostPercentage': number;
    'ourPaymentFeePercentage': number;
    'ourVatPercentage': number;
    'buyersPremiumFeePercentage': number;
    'setupFee': number;
    'setupFeeAppliesPer': AppliesPer;
    'certificationFee': number;
    'partnership0PercentThreshold': number;
    'partnership25PercentThreshold': number;
    'protectionClause'?: number | null;
    'currencyCode'?: string | null;
    'minimumProductPrice': number;
    'buyInPrice': number;
    'fixedFee': number;
    'fixedFeeAppliesPer': AppliesPer;
    'ourSalesPercentage': number;
    'variableFeeGuarantee': number;
    'variableFeeGuaranteeAppliesPer': AppliesPer;
    'numberOfEvents': number;
    'effectiveDate': Date;
    'expiryDate': Date;
}


export interface CreateEventSettingsRequest {
    'name': string;
    'legalOrganisationId': string;
    'vendorId': string;
    'adyenMerchantId': string;
    'defaultShippingOfficeId': string;
}
export interface CreateGlobalShippingConfigRequest {
    'name'?: string | null;
    'platformId': string;
    'dhlFuelPercentage': number;
    'shippingInsurancePercentage': number;
    'mwsShipmentProcessingPercentage': number;
}
export interface CreateLegalOrganisationRequestDto {
    'name'?: string | null;
    'abbreviation'?: string | null;
    'vatNumber'?: string | null;
    'eoriNumber'?: string | null;
    'kvk'?: string | null;
    'iban'?: string | null;
    'bic'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'invoiceBrandType': InvoiceBrandType;
}


export interface CreateNoteRequest {
    'content'?: string | null;
    'entityType': PublicEntityType;
}


export interface CreateOrUpdateCustomerRequest {
    'accountName'?: string | null;
    'emailAddress'?: string | null;
    'phoneNumber'?: string | null;
    'countryCode'?: string | null;
    'customerId'?: string | null;
}
export interface CreateOrUpdateDiscountRequest {
    'platformId': string;
    'discountType': DiscountTypeDto;
    'versionType': VersionTypeDto;
    'priceRangeMinValue': number;
    'priceRangeMaxValue': number;
    'percentage': number;
    'tier'?: number | null;
    'countryCode'?: string | null;
    'categoryId'?: string | null;
    'eventId'?: string | null;
    'isActive': boolean;
}


export interface CreateOrUpdateFramingOrderRequest {
    'specifications'?: Array<OrderItemSpecificationRequest> | null;
    'values'?: { [key: string]: number; } | null;
    'shippingType': ShippingType;
    'type'?: string | null;
    'description'?: string | null;
    'externalId': string;
    'frameImageUrl'?: string | null;
    'productTypeId': string;
    'currencyCode': string;
    'platformId'?: string | null;
    'orderId'?: string | null;
    'unsetImageUrl': boolean;
}


export interface CreateOrderItemRequestDto {
    'type': OrderItemType;
    'salesMethod': PublicSalesMethod;
    'externalId': string;
    'productId'?: string | null;
    'productListingId'?: string | null;
    'valueInEuroCents'?: number | null;
    'values'?: { [key: string]: number; } | null;
    'currencyCode'?: string | null;
    'certificateNumber'?: string | null;
    'productName'?: string | null;
    'quantity'?: number | null;
    'eventName'?: string | null;
    'eventId'?: string | null;
    'shippingType': ShippingType;
    'framingType'?: FramingType | null;
    'productDescription'?: string | null;
    'productImageUrl'?: string | null;
    'productTypeId'?: string | null;
    'fabricksTrackableProductId'?: string | null;
    'inventoryLocationCode'?: string | null;
    'specificationsToCreate'?: Array<OrderItemSpecificationRequest> | null;
}


export interface CreateOrderRequestDto {
    'contractId': string;
    'useDefaultFtgContract': boolean;
    'shippingOfficeId': string;
    'isFramingOrder': boolean;
    'orderItemsToCreate'?: Array<CreateOrderItemRequestDto> | null;
    'skipCustomerInvoice': boolean;
    'itemPricesIncludeVat': boolean;
}
export interface CreateParcelTypeRequestDto {
    'name'?: string | null;
    'height': number;
    'width': number;
    'depth': number;
    'weight': number;
    'maxNumberOfProducts': number;
}
export interface CreatePartnerDocumentRequest {
    'name': string;
    'documentUrl': string;
}
export interface CreatePartnerPickupAddressRequest {
    'name': string;
    'street': string;
    'street2'?: string | null;
    'zip': string;
    'city': string;
    'countryCode': string;
    'phone': string;
    'email'?: string | null;
    'stateId'?: number | null;
    'companyName'?: string | null;
    'instructions'?: string | null;
}
export interface CreatePartnerRequestDto {
    'name': string;
    'description'?: string | null;
    'note'?: string | null;
    'defaultContractType'?: ContractType | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
    'breakClauseDate'?: string | null;
    'breakClauseExpiryDate'?: string | null;
    'seasonTimelineStart'?: Months | null;
    'seasonTimelineEnd'?: Months | null;
    'defaultPartnerManagerUserId': string;
    'region': PartnerRegion;
    'partnerPlatforms': Array<string>;
}


export interface CreateProductTypeRequest {
    'name'?: string | null;
    'condition'?: string | null;
    'hsCodeDescription'?: string | null;
    'hsCode'?: string | null;
    'shortCode'?: string | null;
    'commercialInvoiceDescription'?: string | null;
    'isSigned': boolean;
    'isTangible': boolean;
    'isService': boolean;
    'isActive': boolean;
    'isBundleable': boolean;
    'applyFrontMockup': boolean;
    'framingType': FramingType;
    'framingTier'?: FramingTier | null;
    'defaultProductDescription'?: string | null;
    'defaultProductPrice'?: number | null;
    'displayNameSource': DisplayNameSource;
    'odooVariantCode'?: string | null;
    'avalaraItemId': number;
}


export interface CreateShipmentRequestDto {
    'orderIds': Array<string>;
    'extraOrderItemInfo': Array<ExtraOrderItemInfoDto>;
    'shippingOfficeId': string;
    'pickupTime': Date;
    'parcelTypeId'?: string | null;
    'height': number;
    'width': number;
    'depth': number;
    'weight': number;
    'numberOfItems': number;
    'dhlProductCode': string;
}
export interface CreateShipmentResponse {
    'url'?: string | null;
    'shipmentTrackingNumber'?: string | null;
    'cancelPickupUrl'?: string | null;
    'trackingUrl'?: string | null;
    'dispatchConfirmationNumber'?: string | null;
    'packages'?: Array<Package> | null;
    'documents'?: Array<Document> | null;
    'onDemandDeliveryURL'?: string | null;
    'shipmentDetails'?: Array<ShipmentDetail> | null;
    'shipmentCharges'?: Array<ShipmentCharge> | null;
    'warnings'?: Array<string> | null;
    'labelDocument': Document;
    'commercialInvoiceDocument': Document;
}
export interface CreateShippingOfficeRequestDto {
    'name'?: string | null;
    'address'?: AddressEntity | null;
    'dhlAccountNumber': number;
    'contactName'?: string | null;
    'contactPhoneNumber'?: string | null;
    'contactEmail'?: string | null;
    'contactCompanyName'?: string | null;
    'pickupLocation'?: string | null;
    'closeTime': Date;
    'pickupInstructions'?: string | null;
}
export interface CreateVendorRequestDto {
    'partnerId': string;
    'name'?: string | null;
    'website'?: string | null;
    'email'?: string | null;
    'vatNumber'?: string | null;
    'isVatExempt': boolean;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'invoicePrefix'?: string | null;
    'isGlobal': boolean;
    'isMwsVendor': boolean;
}
export interface CurrencyDto {
    'id': string;
    'code'?: string | null;
    'name'?: string | null;
    'symbol'?: string | null;
}
export interface CurrentExchangeRatesResponse {
    'isCurrent': boolean;
    'date': Date;
    'fromEur': { [key: string]: number; };
}
export interface CustomerAddressDeletedDto {
    'addressId': string;
}
export interface CustomerAddressDto {
    'id': string;
    'name': string;
    'phoneNumber': string;
    'phoneNumberCountryCode': string;
    'companyName': string;
    'vatNumber': string;
    'cpfNumber': string;
    'rgNumber': string;
    'isBillingAddress': boolean;
    'isShippingAddress': boolean;
    'addressLine1': string;
    'addressLine2': string;
    'city': string;
    'state': string;
    'zipCode': string;
    'countryCode': string;
    'vatNumberCheckStatus': PublicVatNumberCheckStatus;
}


export interface CustomerDetails {
    'shipperDetails'?: ShipperDetails | null;
    'receiverDetails'?: ReceiverDetails | null;
}
export interface CustomerDto {
    'id': string;
    'userId': string;
    'emailAddress': string;
    'firstName': string;
    'lastName': string;
    'phoneNumber': string;
    'countryCode': string;
    'accountName': string;
    'platformId'?: string | null;
    'modifiedBy': string;
    'dateModified': Date;
    'addresses': Array<CustomerAddressDto>;
    'businessIdentifiers': BusinessIdentifiersDto;
    'shippingBlocked': boolean;
}

export enum DeductFromType {
    Mws = 'mws',
    Partner = 'partner'
}



export enum DeductionSourceType {
    Gross = 'gross',
    Net = 'net'
}


export interface DeliveryCapabilities {
    'deliveryTypeCode'?: string | null;
    'estimatedDeliveryDateAndTime': Date;
    'destinationServiceAreaCode'?: string | null;
    'destinationFacilityAreaCode'?: string | null;
    'deliveryAdditionalDays': number;
    'deliveryDayOfWeek': number;
    'totalTransitDays': number;
}
export interface DetailedPriceBreakdown {
    'currencyType'?: string | null;
    'priceCurrency'?: string | null;
    'breakdown'?: Array<Breakdown> | null;
}
export interface DiscountResponse {
    'platformId': string;
    'discountType': DiscountTypeDto;
    'versionType': VersionTypeDto;
    'priceRangeMinValue': number;
    'priceRangeMaxValue': number;
    'percentage': number;
    'tier'?: number | null;
    'countryCode'?: string | null;
    'categoryId'?: string | null;
    'eventId'?: string | null;
    'isActive': boolean;
}



export enum DiscountTypeDto {
    NotAttributed = 'notAttributed',
    All = 'all',
    Upsell = 'upsell'
}



export enum DisplayNameSource {
    None = 'none',
    Athlete = 'athlete'
}


export interface Document {
    'imageFormat'?: string | null;
    'content'?: string | null;
    'typeCode': DocumentTypeCode;
}



export enum DocumentTypeCode {
    Label = 'label',
    Invoice = 'invoice',
    Receipt = 'receipt'
}


export interface EstimatedLandedCostChargeResponse {
    'type': string;
    'name': string;
    'amount': PriceResponse;
}
export interface EstimatedLandedCostsResponse {
    'total': PriceResponse;
    'breakdown': Array<EstimatedLandedCostChargeResponse>;
    'isEstimate': boolean;
}
export interface ExtraOrderItemInfoDto {
    'orderItemId': string;
    'countryIso'?: string | null;
    'nfeKey'?: string | null;
}
export interface FinancialReportResponse {
    'id': string;
    'eventName': string;
    'eventEndDate': Date;
    'eventId': string;
    'contractId': string;
    'numberOfItems': number;
    'type': FinancialReportType;
    'dateCreated': Date;
    'createdBy': string;
    'dateModified': Date;
    'modifiedBy': string;
    'currencyCode': string;
    'referenceNumber': number;
    'isFinal': boolean;
    'pdfUrl'?: string | null;
    'eventNetProceeds': number;
    'eventGrossProceeds': number;
    'eventGrossCosts': number;
    'totalMwsShare'?: number | null;
    'totalPartnerPayout'?: number | null;
}



export enum FinancialReportType {
    Settlement = 'settlement',
    Invoice = 'invoice'
}


export interface FramingSessionDto {
    'cartId': string;
    'shippingCountryCode'?: string | null;
    'shippingStateCode'?: string | null;
}

export enum FramingStatus {
    ReadyForConfiguration = 'readyForConfiguration',
    Configured = 'configured',
    Closed = 'closed',
    Configuring = 'configuring'
}



export enum FramingTier {
    Classic = 'classic',
    Limited = 'limited'
}



export enum FramingType {
    NotFrameable = 'notFrameable',
    Frameable = 'frameable',
    Framed = 'framed'
}


export interface GenerateFinancialReportRequest {
    'isFinal': boolean;
    'save': boolean;
}
export interface GenerateSeasonFinancialReportRequest {
    'isFinal': boolean;
    'save': boolean;
}
export interface GetShipmentRatesResponse {
    'products'?: Array<ShipmentProduct> | null;
}

export enum InvoiceBrandType {
    MatchWornShirt = 'matchWornShirt',
    FrameTheGame = 'frameTheGame'
}



export enum Months {
    January = 'january',
    February = 'february',
    March = 'march',
    April = 'april',
    May = 'may',
    June = 'june',
    July = 'july',
    August = 'august',
    September = 'september',
    October = 'october',
    November = 'november',
    December = 'december'
}


export interface NoContentResult {
    'statusCode': number;
}
export interface NoteDto {
    'id': string;
    'content': string;
    'entityType': PublicEntityType;
    'entityReferenceId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}



export enum OrderDocumentType {
    Invoice = 'invoice',
    CreditNote = 'creditNote'
}


export interface OrderDto {
    'id': string;
    'orderNumber': string;
    'dateCreated': Date;
    'dateModified': Date;
    'framingWindowExpiresAt'?: Date | null;
    'customerId'?: string | null;
    'contractId': string;
    'currentInvoiceId': string;
    'status': OrderPaymentStatus;
    'invoiceDisabled': boolean;
    'orderItems'?: Array<OrderItemDto> | null;
    'parcel'?: ParcelDto | null;
    'customer'?: CustomerDto | null;
    'shippingAddress'?: AddressDto | null;
    'awaitingFraming': boolean;
}


export interface OrderItemDto {
    'id': string;
    'eventId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'orderId': string;
    'externalId': string;
    'productId'?: string | null;
    'orderItemType': OrderItemType;
    'values': { [key: string]: number; };
    'currencyCode': string;
    'eventName': string;
    'productName': string;
    'productDescription': string;
    'quantity': number;
    'displayName': string;
    'productImageUrl': string;
    'shippingType': ShippingType;
    'specifications': Array<OrderItemSpecificationDto>;
}


export interface OrderItemSpecificationDto {
    'description': string;
    'price': { [key: string]: number; };
}
export interface OrderItemSpecificationRequest {
    'externalId': string;
    'type'?: string | null;
    'name'?: string | null;
    'price'?: { [key: string]: number; } | null;
    'properties'?: { [key: string]: string; } | null;
}

export enum OrderItemType {
    Sku = 'sku',
    VirtualTicket = 'virtualTicket',
    Frame = 'frame',
    Refund = 'refund'
}



export enum OrderPaymentStatus {
    Open = 'open',
    Processing = 'processing',
    Paid = 'paid',
    Closed = 'closed',
    AwaitingPayment = 'awaitingPayment',
    Unpaid = 'unpaid',
    Pending = 'pending'
}



export enum OrdersFilterType {
    All = 'all',
    Frames = 'frames',
    Products = 'products',
    Tickets = 'tickets'
}


export interface Package {
    'referenceNumber': number;
    'trackingNumber'?: string | null;
    'trackingUrl'?: string | null;
    'volumetricWeight': number;
    'documents'?: Array<Document> | null;
}
export interface PaginatedListOfAdminAdyenMerchantResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminAdyenMerchantResponse>;
}
export interface PaginatedListOfAdminCountryResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminCountryResponse>;
}
export interface PaginatedListOfAdminCustomerResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminCustomerResponse>;
}
export interface PaginatedListOfAdminEventSettingsResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminEventSettingsResponse>;
}
export interface PaginatedListOfAdminFramingOrderDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminFramingOrderDto>;
}
export interface PaginatedListOfAdminGlobalShippingConfigDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminGlobalShippingConfigDto>;
}
export interface PaginatedListOfAdminLegalOrganisationDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminLegalOrganisationDto>;
}
export interface PaginatedListOfAdminOrderDocumentDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminOrderDocumentDto>;
}
export interface PaginatedListOfAdminOrderDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminOrderDto>;
}
export interface PaginatedListOfAdminPaymentTokenResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminPaymentTokenResponse>;
}
export interface PaginatedListOfAdminPreAuthorisationResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminPreAuthorisationResponse>;
}
export interface PaginatedListOfAdminVendorInvoiceDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminVendorInvoiceDto>;
}
export interface PaginatedListOfContractDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ContractDto>;
}
export interface PaginatedListOfContractSeasonResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ContractSeasonResponse>;
}
export interface PaginatedListOfFinancialReportResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<FinancialReportResponse>;
}
export interface PaginatedListOfOrderDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<OrderDto>;
}
export interface PaginatedListOfParcelTypeDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ParcelTypeDto>;
}
export interface PaginatedListOfPartnerDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<PartnerDto>;
}
export interface PaginatedListOfPartnerPickupAddressResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<PartnerPickupAddressResponse>;
}
export interface PaginatedListOfPayoutOverviewResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<PayoutOverviewResponse>;
}
export interface PaginatedListOfPickListItem {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<PickListItem>;
}
export interface PaginatedListOfPickupDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<PickupDto>;
}
export interface PaginatedListOfProductTypeDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ProductTypeDto>;
}
export interface PaginatedListOfShippingOfficeDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<ShippingOfficeDto>;
}
export interface PaginatedListOfVendorDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<VendorDto>;
}
export interface ParcelDto {
    'id': string;
    'pickupId': string;
    'orderId': string;
    'height': number;
    'width': number;
    'depth': number;
    'weight': number;
    'noOfItems': number;
    'shippingLabelUrl': string;
    'commercialInvoiceUrl': string;
    'trackingUrl': string;
    'shipmentStatus': ShipmentStatus;
    'identificationNumber': string;
}


export interface ParcelTypeDto {
    'id': string;
    'name'?: string | null;
    'height': number;
    'width': number;
    'depth': number;
    'weight': number;
    'maxNumberOfProducts': number;
    'productTypes'?: Array<ProductTypeDto> | null;
}
export interface PartnerDocumentDto {
    'id': string;
    'partnerId': string;
    'name': string;
    'dateUploaded': Date;
    'uploadedBy': string;
    'documentUrl': string;
}
export interface PartnerDto {
    'id': string;
    'name': string;
    'description'?: string | null;
    'note'?: string | null;
    'defaultContractType'?: ContractType | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
    'breakClauseDate'?: string | null;
    'breakClauseExpiryDate'?: string | null;
    'seasonTimelineStart'?: Months | null;
    'seasonTimelineEnd'?: Months | null;
    'createdBy': string;
    'modifiedBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'customers': Array<CustomerDto>;
    'contracts': Array<ContractDto>;
    'documents': Array<PartnerDocumentDto>;
    'partnerPlatforms': Array<string>;
    'defaultPartnerManagerUserId'?: string | null;
    'region'?: PartnerRegion | null;
    'odooPartnerId'?: number | null;
    'odooPartnerUrl'?: string | null;
}


export interface PartnerPickupAddressResponse {
    'id': number;
    'name': string;
    'street'?: string | null;
    'street2'?: string | null;
    'zip'?: string | null;
    'city'?: string | null;
    'countryCode': string;
    'phone'?: string | null;
    'email'?: string | null;
    'companyName'?: string | null;
    'state'?: PartnerPickupAddressStateResponse | null;
    'instructions'?: string | null;
}
export interface PartnerPickupAddressStateResponse {
    'id': number;
    'name': string;
}

export enum PartnerRegion {
    France = 'france',
    Belgium = 'belgium',
    Italy = 'italy',
    Netherlands = 'netherlands',
    UnitedKingdom = 'unitedKingdom',
    Turkey = 'turkey',
    EasternEurope = 'easternEurope',
    Nordics = 'nordics',
    Spain = 'spain',
    Portugal = 'portugal',
    MexicoSouthAmerica = 'mexicoSouthAmerica',
    Brazil = 'brazil',
    Germany = 'germany',
    AustraliaNewZealand = 'australiaNewZealand',
    SouthEastAsia = 'southEastAsia',
    MiddleEast = 'middleEast',
    NorthAmerica = 'northAmerica',
    AustraliaAmsterdam = 'australiaAmsterdam',
    Cycling = 'cycling',
    Legends = 'legends',
    Resales = 'resales',
    FramingProjects = 'framingProjects',
    Africa = 'africa'
}



export enum PartnerSortAttribute {
    StartDate = 'startDate',
    EndDate = 'endDate'
}


export interface PaymentFeeDto {
    'paymentMethod'?: string | null;
    'productPrice': number;
    'fee': number;
}

export enum PaymentProviderType {
    Adyen = 'adyen',
    Socios = 'socios'
}


export interface PaymentReminderDto {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'orderId': string;
    'type': PaymentReminderType;
}



export enum PaymentReminderType {
    Ultimatum = 'ultimatum',
    Warning = 'warning',
    FormalRequest = 'formalRequest',
    KindReminder = 'kindReminder'
}



export enum PaymentTransactionType {
    Refund = 'refund',
    Payment = 'payment'
}


export interface PayoutInstallmentRequest {
    'paidOn': Date;
}
export interface PayoutOverviewResponse {
    'id': string;
    'contractId': string;
    'currencyCode': string;
    'partnerName'?: string | null;
    'name': string;
    'dueDate': Date;
    'amount': number;
    'payoutStatus': ContractPayoutStatus;
    'comment'?: string | null;
    'paidOn'?: Date | null;
    'payoutSource': ContractPayoutSource;
}


export interface PickListItem {
    'productId'?: string | null;
    'productListingId'?: string | null;
    'productName': string;
    'teamName': string;
    'eventName': string;
    'customerName': string;
    'shippingCountryCode': string;
    'orderId': string;
    'orderNumber': string;
    'datePaid'?: Date | null;
    'location': string;
    'orderItemValues'?: { [key: string]: number; } | null;
    'shippingExceptions'?: string | null;
}
export interface PickOrderRequest {
    'destination': PublicOrderPickDestination;
}


export interface PickupCapabilities {
    'nextBusinessDay': boolean;
    'localCutoffDateAndTime': Date;
    'GMTCutoffTime'?: string | null;
    'pickupEarliest'?: string | null;
    'pickupLatest'?: string | null;
    'originServiceAreaCode'?: string | null;
    'originFacilityAreaCode'?: string | null;
    'pickupAdditionalDays': number;
    'pickupDayOfWeek': number;
}
export interface PickupDto {
    'id': string;
    'dateTime': Date;
}
export interface PostalAddress {
    'postalCode'?: string | null;
    'cityName'?: string | null;
    'countryCode'?: string | null;
    'provinceCode'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'addressLine3'?: string | null;
    'cityDistrictName'?: string | null;
}
export interface PostponeInstallmentRequest {
    'comment': string;
    'dueDate': Date;
}

export enum PreAuthorisationStatus {
    Active = 'active',
    Released = 'released',
    Captured = 'captured',
    CancelledByBank = 'cancelledByBank'
}


export interface PriceBreakdown {
    'typeCode'?: string | null;
    'price': number;
    'priceType'?: string | null;
    'rate': number;
    'basePrice': number;
}
export interface PriceResponse {
    'currency': string;
    'price': number;
}
export interface ProblemDetails {
    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}
export interface ProductTypeDto {
    'id': string;
    'name'?: string | null;
    'condition'?: string | null;
    'hsCode'?: string | null;
    'shortCode'?: string | null;
    'hsCodeDescription'?: string | null;
    'commercialInvoiceDescription'?: string | null;
    'isSigned': boolean;
    'isTangible': boolean;
    'isService': boolean;
    'isActive': boolean;
    'isBundleable': boolean;
    'applyFrontMockup': boolean;
    'framingType': FramingType;
    'framingTier'?: FramingTier | null;
    'defaultProductDescription'?: string | null;
    'defaultProductPrice'?: number | null;
    'displayNameSource': DisplayNameSource;
    'parcelTypes'?: Array<ParcelTypeDto> | null;
    'odooVariantCode'?: string | null;
    'avalaraItemCode'?: string | null;
    'avalaraItemId'?: number | null;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}


export interface ProtectedUrlDto {
    'protectedUrl'?: string | null;
}

export enum PublicBiddingBlockedReason {
    NoShipmentToTurkey = 'noShipmentToTurkey'
}



export enum PublicBoxType {
    Shirt = 'shirt',
    Ball = 'ball',
    Frame = 'frame'
}



export enum PublicEntityType {
    Product = 'product',
    Customer = 'customer',
    Order = 'order',
    Event = 'event'
}



export enum PublicOrderPickDestination {
    Framing = 'framing',
    Shipping = 'shipping',
    LongStorage = 'longStorage'
}



export enum PublicSalesMethod {
    Sweepstakes = 'sweepstakes',
    Bidding = 'bidding',
    FixedPrice = 'fixedPrice',
    Resale = 'resale',
    AddOn = 'addOn'
}



export enum PublicSalesTaxType {
    Unknown = 'unknown',
    NoSalesTax = 'noSalesTax',
    Vat = 'vat',
    UsSalesTax = 'usSalesTax',
    BrazilSalesTax = 'brazilSalesTax'
}



export enum PublicVatNumberCheckStatus {
    NoVatNumberSet = 'noVatNumberSet',
    NotChecked = 'notChecked',
    CheckedNotValid = 'checkedNotValid',
    CheckedAndValid = 'checkedAndValid',
    NonEuNumber = 'nonEuNumber'
}


export interface ReceiverDetails {
    'postalAddress'?: PostalAddress | null;
    'contactInformation'?: ContactInformation | null;
}
export interface RefundCalculationResponse {
    'amount': number;
    'currency'?: string | null;
    'adyenMerchant'?: string | null;
}
export interface RefundRequest {
    'percentage': number;
    'refundType': RefundType;
}



export enum RefundType {
    ShippingAmount = 'shippingAmount',
    VatAmount = 'vatAmount',
    ItemAmount = 'itemAmount',
    TotalAmount = 'totalAmount'
}


export interface ReportOrderDto {
    'id': string;
    'dateCreated': Date;
    'dateModified': Date;
    'skuId': string;
    'status': OrderPaymentStatus;
    'isFramingOrder': boolean;
    'contractId': string;
    'variableFeePercentage': number;
    'ourShippingPaymentPercentage': number;
    'values'?: { [key: string]: number; } | null;
    'currencyCode'?: string | null;
    'userId': string;
    'customerEmailAddress'?: string | null;
    'customerPhoneNumber'?: string | null;
    'customerName'?: string | null;
    'customerCountryCode'?: string | null;
    'address'?: AddressEntity | null;
}


export interface SendPaymentReminderRequestDto {
    'paymentReminderType'?: string | null;
}
export interface ServiceBreakdown {
    'name'?: string | null;
    'price': number;
    'typeCode'?: string | null;
}
export interface ShipmentCharge {
    'currencyType'?: string | null;
    'priceCurrency'?: string | null;
    'price': number;
    'serviceBreakdown'?: Array<ServiceBreakdown> | null;
}
export interface ShipmentDetail {
    'serviceHandlingFeatureCodes'?: Array<string> | null;
    'volumetricWeight': number;
    'billingCode'?: string | null;
    'serviceContentCode'?: string | null;
    'customerDetails'?: CustomerDetails | null;
}
export interface ShipmentDetailsResponse {
    'originCountryCode'?: string | null;
    'destinationCountryCode'?: string | null;
    'isShipmentInternational': boolean;
    'isShipmentWithinEU': boolean;
}
export interface ShipmentProduct {
    'productName'?: string | null;
    'productCode'?: string | null;
    'localProductCountryCode'?: string | null;
    'networkTypeCode'?: string | null;
    'isCustomerAgreement': boolean;
    'weight'?: Weight | null;
    'totalPrice'?: Array<TotalPrice> | null;
    'totalPriceBreakdown'?: Array<TotalPriceBreakdown> | null;
    'detailedPriceBreakdown'?: Array<DetailedPriceBreakdown> | null;
    'pickupCapabilities'?: PickupCapabilities | null;
    'deliveryCapabilities'?: DeliveryCapabilities | null;
    'pricingDate'?: string | null;
}

export enum ShipmentStatus {
    PickupPlanned = 'pickupPlanned',
    PickedUp = 'pickedUp'
}


export interface ShipperDetails {
    'postalAddress'?: PostalAddress | null;
    'contactInformation'?: ContactInformation | null;
}
export interface ShippingOfficeDto {
    'id': string;
    'name': string;
    'address': AddressEntity;
    'dhlAccountNumber': number;
    'contactName': string;
    'contactPhoneNumber': string;
    'contactEmail': string;
    'contactCompanyName': string;
    'pickupLocation': string;
    'closeTime': Date;
    'pickupInstructions': string;
    'createdBy': string;
    'modifiedBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'isFtg': boolean;
    'areProductsFrameable': boolean;
    'isLandedCostsEnabled': boolean;
    'odooCompanyId'?: number | null;
    'vatNumber'?: string | null;
    'eoriNumber'?: string | null;
    'easypostCarrierAccountId'?: string | null;
}

export enum ShippingType {
    PaidShipping = 'paidShipping',
    FreeShipping = 'freeShipping',
    NoShipping = 'noShipping',
    FreeDomesticShipping = 'freeDomesticShipping'
}



export enum SortContractOn {
    GrossProceeds = 'grossProceeds',
    NetProceeds = 'netProceeds',
    NetProceedsPercentage = 'netProceedsPercentage',
    DateCreated = 'dateCreated',
    MwsShare = 'mwsShare'
}



export enum SortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}


export interface StateResponse {
    'id': string;
    'isoCode'?: string | null;
    'name'?: string | null;
}
export interface TotalPrice {
    'currencyType'?: string | null;
    'priceCurrency'?: string | null;
    'price': number;
}
export interface TotalPriceBreakdown {
    'currencyType'?: string | null;
    'priceCurrency'?: string | null;
    'priceBreakdown'?: Array<PriceBreakdown> | null;
}
export interface TrackingParcelDto {
    'parcelId': string;
    'orderIds'?: Array<string> | null;
    'trackingUrl'?: string | null;
    'shipmentStatus': ShipmentStatus;
}


export interface TransactionResponse {
    'id': string;
    'dateCreated': Date;
    'createdBy': string;
    'dateModified': Date;
    'modifiedBy': string;
    'price'?: PriceResponse | null;
    'type': PaymentTransactionType;
    'success': boolean;
    'customerId'?: string | null;
    'orderId'?: string | null;
    'merchantAccount'?: string | null;
    'currency'?: string | null;
    'expiryTime'?: Date | null;
    'webhookContent'?: string | null;
    'pspReference'?: string | null;
    'paymentMethod'?: string | null;
    'priceInCents': number;
    'priceAsDecimal': number;
    'paymentProvider': PaymentProviderType;
    'paymentProviderIdentifier'?: string | null;
    'channel'?: string | null;
    'checkoutId'?: string | null;
}



export enum UnitOfMeasurement {
    Metric = 'metric',
    Imperial = 'imperial'
}


export interface UpdateContractRequestDto {
    'id': string;
    'defaultEventSettingsId'?: string | null;
    'partnerId'?: string | null;
    'seasonId'?: string | null;
    'name'?: string | null;
    'ourShippingCostPercentage'?: number | null;
    'ourPaymentFeePercentage'?: number | null;
    'ourVatPercentage'?: number | null;
    'buyersPremiumFeePercentage'?: number | null;
    'contractType'?: ContractType | null;
    'setupFee'?: number | null;
    'setupFeeAppliesPer'?: AppliesPer | null;
    'certificationFee'?: number | null;
    'partnership0PercentThreshold'?: number | null;
    'partnership25PercentThreshold'?: number | null;
    'protectionClause'?: number | null;
    'costs'?: Array<ContractCostDto> | null;
    'proceedBrackets'?: Array<ContractProceedBracketDto> | null;
    'installmentBrackets'?: Array<ContractInstallmentBracketDto> | null;
    'payoutInstallmentPerEvent': boolean;
    'currencyCode'?: string | null;
    'minimumProductPrice'?: number | null;
    'buyInPrice': number;
    'fixedFee'?: number | null;
    'fixedFeeAppliesPer'?: AppliesPer | null;
    'sponsorshipReserveDebited'?: number | null;
    'ourSalesPercentage'?: number | null;
    'variableFeeGuarantee'?: number | null;
    'variableFeeGuaranteeAppliesPer'?: AppliesPer | null;
    'numberOfEvents'?: number | null;
    'effectiveDate'?: Date | null;
    'expiryDate'?: Date | null;
    'recipientAddress'?: AddressDto | null;
    'grossMinimumProceeds': number;
}


export interface UpdateEventSettingsRequest {
    'name': string;
    'legalOrganisationId': string;
    'vendorId': string;
    'adyenMerchantId': string;
    'defaultShippingOfficeId': string;
}
export interface UpdateGlobalShippingConfigRequest {
    'id': string;
    'name'?: string | null;
    'dhlFuelPercentage'?: number | null;
    'shippingInsurancePercentage'?: number | null;
    'mwsShipmentProcessingPercentage'?: number | null;
}
export interface UpdateLegalOrgnisationRequestDto {
    'name'?: string | null;
    'abbreviation'?: string | null;
    'vatNumber'?: string | null;
    'eoriNumber'?: string | null;
    'kvk'?: string | null;
    'iban'?: string | null;
    'bic'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'invoiceBrandType': InvoiceBrandType;
}


export interface UpdateNoteRequest {
    'content'?: string | null;
}
export interface UpdateOrderAddressRequest {
    'name'?: string | null;
    'companyName'?: string | null;
    'phoneNumber'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'companyRegistrationNumber'?: string | null;
    'vatNumber'?: string | null;
}
export interface UpdateOrderManualShippedRequest {
    'manualShipped': boolean;
}
export interface UpdateOrderRequestDto {
    'isFramingOrder'?: boolean | null;
    'framingWindowExpiresAt'?: Date | null;
    'status'?: OrderPaymentStatus | null;
    'manualShipped'?: boolean | null;
    'shippingAddress'?: AddressDto | null;
    'shippingOfficeId'?: string | null;
    'framingStatus'?: FramingStatus | null;
    'currencyCode'?: string | null;
}


export interface UpdateParcelShipmentStatusRequest {
    'shipmentStatus': ShipmentStatus;
}


export interface UpdatePartnerPickupAddressRequest {
    'name': string;
    'street': string;
    'street2'?: string | null;
    'zip': string;
    'city': string;
    'countryCode': string;
    'phone': string;
    'email'?: string | null;
    'stateId'?: number | null;
    'companyName'?: string | null;
    'instructions'?: string | null;
}
export interface UpdatePartnerRequestDto {
    'name'?: string | null;
    'description'?: string | null;
    'note'?: string | null;
    'defaultContractType'?: ContractType | null;
    'startDate'?: string | null;
    'endDate'?: string | null;
    'breakClauseDate'?: string | null;
    'breakClauseExpiryDate'?: string | null;
    'seasonTimelineStart'?: Months | null;
    'seasonTimelineEnd'?: Months | null;
    'defaultPartnerManagerUserId'?: string | null;
    'region': PartnerRegion;
    'partnerPlatforms': Array<string>;
}


export interface UpdatePayoutDocumentsRequest {
    'invoiceDocumentUrl'?: string | null;
    'proofOfPaymentDocumentUrl'?: string | null;
}
export interface UpdateProductTypeRequest {
    'id': string;
    'name'?: string | null;
    'condition'?: string | null;
    'hsCodeDescription'?: string | null;
    'commercialInvoiceDescription'?: string | null;
    'hsCode'?: string | null;
    'shortCode'?: string | null;
    'isSigned': boolean;
    'isTangible': boolean;
    'isService': boolean;
    'isActive': boolean;
    'isBundleable': boolean;
    'applyFrontMockup': boolean;
    'framingType': FramingType;
    'framingTier'?: FramingTier | null;
    'defaultProductDescription'?: string | null;
    'defaultProductPrice'?: number | null;
    'displayNameSource': DisplayNameSource;
    'odooVariantCode'?: string | null;
    'avalaraItemId': number;
}


export interface UpdateShippingOfficeRequestDto {
    'id': string;
    'name'?: string | null;
    'address'?: AddressEntity | null;
    'dhlAccountNumber': number;
    'isLandedCostsEnabled'?: boolean | null;
}
export interface UpdateTrustProfileRequest {
    'waiveEscalatedPaymentReminders': boolean;
    'waiveSuspensionOnUnpaidOrder': boolean;
    'waiveSuspiciousBidAlerts': boolean;
    'waiveSuspensionOnMaliciousPhoneNumber': boolean;
    'waiveBidLimitVerification': boolean;
    'preAuthorisationExemptionInEuroCents': number;
}
export interface UpdateVendorRequestDto {
    'id': string;
    'partnerId': string;
    'name'?: string | null;
    'website'?: string | null;
    'email'?: string | null;
    'vatNumber'?: string | null;
    'isVatExempt': boolean;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'invoicePrefix'?: string | null;
    'lastVendorInvoiceNumber'?: number | null;
    'lastCustomerInvoiceNumber'?: number | null;
    'isMwsVendor'?: boolean | null;
    'isGlobal'?: boolean | null;
}
export interface ValidationFailure {
    'errorCode'?: string | null;
    'errorMessage'?: string | null;
    'propertyName'?: string | null;
}

export enum VatExemptionReason {
    NotExempted = 'notExempted',
    IsVatReversed = 'isVatReversed',
    IsExport = 'isExport',
    IsVatExempt = 'isVatExempt',
    UsSalesTaxApplies = 'usSalesTaxApplies'
}


export interface VatExplanationResponse {
    'hasVat': boolean;
    'reason': VatExemptionReason;
}


export interface VendorDto {
    'id': string;
    'partnerId': string;
    'name'?: string | null;
    'website'?: string | null;
    'email'?: string | null;
    'vatNumber'?: string | null;
    'isVatExempt': boolean;
    'isMwsVendor': boolean;
    'lastVendorInvoiceNumber': number;
    'lastCustomerInvoiceNumber': number;
    'invoicePrefix'?: string | null;
    'addressLine1'?: string | null;
    'addressLine2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zipCode'?: string | null;
    'countryCode'?: string | null;
    'createdBy': string;
    'modifiedBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'isDeleted': boolean;
    'isGlobal': boolean;
    'selectedState'?: StateResponse | null;
}

export enum VersionTypeDto {
    Control = 'control',
    A = 'a',
    B = 'b',
    C = 'c'
}


export interface Weight {
    'volumetric': number;
    'provided': number;
    'unitOfMeasurement': UnitOfMeasurement;
}



/**
 * AdminAdyenMerchantsApi - axios parameter creator
 */
export const AdminAdyenMerchantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/adyen-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {string} [name] The name of the Adyen Merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsPost: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/adyen-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAdyenMerchantsApi - functional programming interface
 */
export const AdminAdyenMerchantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAdyenMerchantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAdyenMerchantsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminAdyenMerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAdyenMerchantsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAdyenMerchantsApi.adminAdyenMerchantsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {string} [name] The name of the Adyen Merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAdyenMerchantsPost(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdyenMerchantEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAdyenMerchantsPost(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAdyenMerchantsApi.adminAdyenMerchantsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAdyenMerchantsApi - factory interface
 */
export const AdminAdyenMerchantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAdyenMerchantsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsGet(options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminAdyenMerchantResponse> {
            return localVarFp.adminAdyenMerchantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsPost(requestParameters: AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdyenMerchantEntity> {
            return localVarFp.adminAdyenMerchantsPost(requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminAdyenMerchantsPost operation in AdminAdyenMerchantsApi.
 */
export interface AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest {
    /**
     * The name of the Adyen Merchant
     */
    readonly name?: string
}

/**
 * AdminAdyenMerchantsApi - object-oriented interface
 */
export class AdminAdyenMerchantsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get all Adyen Merchants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAdyenMerchantsGet(options?: RawAxiosRequestConfig) {
        return AdminAdyenMerchantsApiFp(this.configuration).adminAdyenMerchantsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [FinanceManager and Admin] Create an Adyen merchant
     * @param {AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAdyenMerchantsPost(requestParameters: AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAdyenMerchantsApiFp(this.configuration).adminAdyenMerchantsPost(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCheckoutsApi - axios parameter creator
 */
export const AdminCheckoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} checkoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCheckoutsCheckoutIdGet: async (checkoutId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutId' is not null or undefined
            assertParamExists('adminCheckoutsCheckoutIdGet', 'checkoutId', checkoutId)
            const localVarPath = `/admin/checkouts/{checkoutId}`
                .replace('{checkoutId}', encodeURIComponent(String(checkoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCheckoutsApi - functional programming interface
 */
export const AdminCheckoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCheckoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} checkoutId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCheckoutsCheckoutIdGet(checkoutId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCheckoutsCheckoutIdGet(checkoutId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCheckoutsApi.adminCheckoutsCheckoutIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCheckoutsApi - factory interface
 */
export const AdminCheckoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCheckoutsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminCheckoutsApiAdminCheckoutsCheckoutIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCheckoutsCheckoutIdGet(requestParameters: AdminCheckoutsApiAdminCheckoutsCheckoutIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCheckoutResponse> {
            return localVarFp.adminCheckoutsCheckoutIdGet(requestParameters.checkoutId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCheckoutsCheckoutIdGet operation in AdminCheckoutsApi.
 */
export interface AdminCheckoutsApiAdminCheckoutsCheckoutIdGetRequest {
    readonly checkoutId: string
}

/**
 * AdminCheckoutsApi - object-oriented interface
 */
export class AdminCheckoutsApi extends BaseAPI {
    /**
     * 
     * @param {AdminCheckoutsApiAdminCheckoutsCheckoutIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCheckoutsCheckoutIdGet(requestParameters: AdminCheckoutsApiAdminCheckoutsCheckoutIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCheckoutsApiFp(this.configuration).adminCheckoutsCheckoutIdGet(requestParameters.checkoutId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminContractPayoutsApi - axios parameter creator
 */
export const AdminContractPayoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contract payouts
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsGet', 'contractId', contractId)
            const localVarPath = `/admin/contracts/{contractId}/payouts`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Block a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {BlockInstallmentRequest} blockInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdBlockPut: async (contractId: string, installmentId: string, blockInstallmentRequest: BlockInstallmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdBlockPut', 'contractId', contractId)
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdBlockPut', 'installmentId', installmentId)
            // verify required parameter 'blockInstallmentRequest' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdBlockPut', 'blockInstallmentRequest', blockInstallmentRequest)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/block`
                .replace('{contractId}', encodeURIComponent(String(contractId)))
                .replace('{installmentId}', encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockInstallmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a contract payouts documents
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {UpdatePayoutDocumentsRequest} updatePayoutDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdDocumentsPut: async (installmentId: string, contractId: string, updatePayoutDocumentsRequest: UpdatePayoutDocumentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdDocumentsPut', 'installmentId', installmentId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdDocumentsPut', 'contractId', contractId)
            // verify required parameter 'updatePayoutDocumentsRequest' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdDocumentsPut', 'updatePayoutDocumentsRequest', updatePayoutDocumentsRequest)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/documents`
                .replace('{installmentId}', encodeURIComponent(String(installmentId)))
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePayoutDocumentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Open a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdOpenPut: async (contractId: string, installmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdOpenPut', 'contractId', contractId)
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdOpenPut', 'installmentId', installmentId)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/open`
                .replace('{contractId}', encodeURIComponent(String(contractId)))
                .replace('{installmentId}', encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Payout a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {PayoutInstallmentRequest} payoutInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPayPut: async (contractId: string, installmentId: string, payoutInstallmentRequest: PayoutInstallmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPayPut', 'contractId', contractId)
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPayPut', 'installmentId', installmentId)
            // verify required parameter 'payoutInstallmentRequest' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPayPut', 'payoutInstallmentRequest', payoutInstallmentRequest)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/pay`
                .replace('{contractId}', encodeURIComponent(String(contractId)))
                .replace('{installmentId}', encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payoutInstallmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Postpone a contract installment
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {PostponeInstallmentRequest} postponeInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPostponePut: async (installmentId: string, contractId: string, postponeInstallmentRequest: PostponeInstallmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPostponePut', 'installmentId', installmentId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPostponePut', 'contractId', contractId)
            // verify required parameter 'postponeInstallmentRequest' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPostponePut', 'postponeInstallmentRequest', postponeInstallmentRequest)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/postpone`
                .replace('{installmentId}', encodeURIComponent(String(installmentId)))
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postponeInstallmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unblock a blocked contract installment
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdUnblockPut: async (installmentId: string, contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdUnblockPut', 'installmentId', installmentId)
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdUnblockPut', 'contractId', contractId)
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/unblock`
                .replace('{installmentId}', encodeURIComponent(String(installmentId)))
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payouts for all contracts
         * @param {string} [partnerId] 
         * @param {ContractPayoutStatus} [payoutStatus] 
         * @param {Date} [dueBefore] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPayoutsOverviewGet: async (partnerId?: string, payoutStatus?: ContractPayoutStatus, dueBefore?: Date, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/contracts/payouts-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (payoutStatus !== undefined) {
                localVarQueryParameter['payoutStatus'] = payoutStatus;
            }

            if (dueBefore !== undefined) {
                localVarQueryParameter['dueBefore'] = (dueBefore as any instanceof Date) ?
                    (dueBefore as any).toISOString() :
                    dueBefore;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContractPayoutsApi - functional programming interface
 */
export const AdminContractPayoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContractPayoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get contract payouts
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractPayoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Block a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {BlockInstallmentRequest} blockInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdBlockPut(contractId: string, installmentId: string, blockInstallmentRequest: BlockInstallmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdBlockPut(contractId, installmentId, blockInstallmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdBlockPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a contract payouts documents
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {UpdatePayoutDocumentsRequest} updatePayoutDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdDocumentsPut(installmentId: string, contractId: string, updatePayoutDocumentsRequest: UpdatePayoutDocumentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdDocumentsPut(installmentId, contractId, updatePayoutDocumentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdDocumentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Open a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdOpenPut(contractId: string, installmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdOpenPut(contractId, installmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdOpenPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Payout a contract installment
         * @param {string} contractId 
         * @param {string} installmentId 
         * @param {PayoutInstallmentRequest} payoutInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdPayPut(contractId: string, installmentId: string, payoutInstallmentRequest: PayoutInstallmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdPayPut(contractId, installmentId, payoutInstallmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdPayPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Postpone a contract installment
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {PostponeInstallmentRequest} postponeInstallmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdPostponePut(installmentId: string, contractId: string, postponeInstallmentRequest: PostponeInstallmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdPostponePut(installmentId, contractId, postponeInstallmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdPostponePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unblock a blocked contract installment
         * @param {string} installmentId 
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdPayoutsInstallmentIdUnblockPut(installmentId: string, contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdUnblockPut(installmentId, contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsContractIdPayoutsInstallmentIdUnblockPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get payouts for all contracts
         * @param {string} [partnerId] 
         * @param {ContractPayoutStatus} [payoutStatus] 
         * @param {Date} [dueBefore] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsPayoutsOverviewGet(partnerId?: string, payoutStatus?: ContractPayoutStatus, dueBefore?: Date, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPayoutOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsPayoutsOverviewGet(partnerId, payoutStatus, dueBefore, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractPayoutsApi.adminContractsPayoutsOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminContractPayoutsApi - factory interface
 */
export const AdminContractPayoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContractPayoutsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get contract payouts
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsGet(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractPayoutResponse> {
            return localVarFp.adminContractsContractIdPayoutsGet(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Block a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.blockInstallmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a contract payouts documents
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters.installmentId, requestParameters.contractId, requestParameters.updatePayoutDocumentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Open a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters.contractId, requestParameters.installmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Payout a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.payoutInstallmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Postpone a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters.installmentId, requestParameters.contractId, requestParameters.postponeInstallmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unblock a blocked contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters.installmentId, requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payouts for all contracts
         * @param {AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPayoutsOverviewGet(requestParameters: AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPayoutOverviewResponse> {
            return localVarFp.adminContractsPayoutsOverviewGet(requestParameters.partnerId, requestParameters.payoutStatus, requestParameters.dueBefore, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminContractsContractIdPayoutsGet operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest {
    readonly contractId: string
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdBlockPut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest {
    readonly contractId: string

    readonly installmentId: string

    readonly blockInstallmentRequest: BlockInstallmentRequest
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdDocumentsPut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest {
    readonly installmentId: string

    readonly contractId: string

    readonly updatePayoutDocumentsRequest: UpdatePayoutDocumentsRequest
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdOpenPut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest {
    readonly contractId: string

    readonly installmentId: string
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdPayPut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest {
    readonly contractId: string

    readonly installmentId: string

    readonly payoutInstallmentRequest: PayoutInstallmentRequest
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdPostponePut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest {
    readonly installmentId: string

    readonly contractId: string

    readonly postponeInstallmentRequest: PostponeInstallmentRequest
}

/**
 * Request parameters for adminContractsContractIdPayoutsInstallmentIdUnblockPut operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest {
    readonly installmentId: string

    readonly contractId: string
}

/**
 * Request parameters for adminContractsPayoutsOverviewGet operation in AdminContractPayoutsApi.
 */
export interface AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest {
    readonly partnerId?: string

    readonly payoutStatus?: ContractPayoutStatus

    readonly dueBefore?: Date

    readonly offSet?: number

    readonly pageSize?: number
}

/**
 * AdminContractPayoutsApi - object-oriented interface
 */
export class AdminContractPayoutsApi extends BaseAPI {
    /**
     * 
     * @summary Get contract payouts
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsGet(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsGet(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Block a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.blockInstallmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a contract payouts documents
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters.installmentId, requestParameters.contractId, requestParameters.updatePayoutDocumentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Open a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters.contractId, requestParameters.installmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Payout a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.payoutInstallmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Postpone a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters.installmentId, requestParameters.contractId, requestParameters.postponeInstallmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unblock a blocked contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters: AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters.installmentId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payouts for all contracts
     * @param {AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsPayoutsOverviewGet(requestParameters: AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsPayoutsOverviewGet(requestParameters.partnerId, requestParameters.payoutStatus, requestParameters.dueBefore, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminContractProgressApi - axios parameter creator
 */
export const AdminContractProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a summary over all contracts
         * @param {Array<string>} [partnerManagerIds] 
         * @param {Array<string>} [partnerIds] 
         * @param {string} [seasonIds] 
         * @param {Array<PartnerRegion>} [partnerRegions] 
         * @param {Array<ContractType>} [contractTypes] 
         * @param {boolean} [hasProtectionClause] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsSummaryGet: async (partnerManagerIds?: Array<string>, partnerIds?: Array<string>, seasonIds?: string, partnerRegions?: Array<PartnerRegion>, contractTypes?: Array<ContractType>, hasProtectionClause?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/contracts/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (partnerManagerIds) {
                localVarQueryParameter['partnerManagerIds'] = partnerManagerIds;
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }

            if (seasonIds !== undefined) {
                localVarQueryParameter['seasonIds'] = seasonIds;
            }

            if (partnerRegions) {
                localVarQueryParameter['partnerRegions'] = partnerRegions;
            }

            if (contractTypes) {
                localVarQueryParameter['contractTypes'] = contractTypes;
            }

            if (hasProtectionClause !== undefined) {
                localVarQueryParameter['hasProtectionClause'] = hasProtectionClause;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContractProgressApi - functional programming interface
 */
export const AdminContractProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContractProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a summary over all contracts
         * @param {Array<string>} [partnerManagerIds] 
         * @param {Array<string>} [partnerIds] 
         * @param {string} [seasonIds] 
         * @param {Array<PartnerRegion>} [partnerRegions] 
         * @param {Array<ContractType>} [contractTypes] 
         * @param {boolean} [hasProtectionClause] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsSummaryGet(partnerManagerIds?: Array<string>, partnerIds?: Array<string>, seasonIds?: string, partnerRegions?: Array<PartnerRegion>, contractTypes?: Array<ContractType>, hasProtectionClause?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractProgressSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsSummaryGet(partnerManagerIds, partnerIds, seasonIds, partnerRegions, contractTypes, hasProtectionClause, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractProgressApi.adminContractsSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminContractProgressApi - factory interface
 */
export const AdminContractProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContractProgressApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a summary over all contracts
         * @param {AdminContractProgressApiAdminContractsSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsSummaryGet(requestParameters: AdminContractProgressApiAdminContractsSummaryGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContractProgressSummaryResponse> {
            return localVarFp.adminContractsSummaryGet(requestParameters.partnerManagerIds, requestParameters.partnerIds, requestParameters.seasonIds, requestParameters.partnerRegions, requestParameters.contractTypes, requestParameters.hasProtectionClause, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminContractsSummaryGet operation in AdminContractProgressApi.
 */
export interface AdminContractProgressApiAdminContractsSummaryGetRequest {
    readonly partnerManagerIds?: Array<string>

    readonly partnerIds?: Array<string>

    readonly seasonIds?: string

    readonly partnerRegions?: Array<PartnerRegion>

    readonly contractTypes?: Array<ContractType>

    readonly hasProtectionClause?: boolean
}

/**
 * AdminContractProgressApi - object-oriented interface
 */
export class AdminContractProgressApi extends BaseAPI {
    /**
     * 
     * @summary Get a summary over all contracts
     * @param {AdminContractProgressApiAdminContractsSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsSummaryGet(requestParameters: AdminContractProgressApiAdminContractsSummaryGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminContractProgressApiFp(this.configuration).adminContractsSummaryGet(requestParameters.partnerManagerIds, requestParameters.partnerIds, requestParameters.seasonIds, requestParameters.partnerRegions, requestParameters.contractTypes, requestParameters.hasProtectionClause, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminContractSeasonApi - axios parameter creator
 */
export const AdminContractSeasonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contract seasons
         * @param {string} [name] 
         * @param {boolean} [isCurrent] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractSeasonsGet: async (name?: string, isCurrent?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/contract-seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isCurrent !== undefined) {
                localVarQueryParameter['isCurrent'] = isCurrent;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContractSeasonApi - functional programming interface
 */
export const AdminContractSeasonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContractSeasonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get contract seasons
         * @param {string} [name] 
         * @param {boolean} [isCurrent] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractSeasonsGet(name?: string, isCurrent?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfContractSeasonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractSeasonsGet(name, isCurrent, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractSeasonApi.adminContractSeasonsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminContractSeasonApi - factory interface
 */
export const AdminContractSeasonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContractSeasonApiFp(configuration)
    return {
        /**
         * 
         * @summary Get contract seasons
         * @param {AdminContractSeasonApiAdminContractSeasonsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractSeasonsGet(requestParameters: AdminContractSeasonApiAdminContractSeasonsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfContractSeasonResponse> {
            return localVarFp.adminContractSeasonsGet(requestParameters.name, requestParameters.isCurrent, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminContractSeasonsGet operation in AdminContractSeasonApi.
 */
export interface AdminContractSeasonApiAdminContractSeasonsGetRequest {
    readonly name?: string

    readonly isCurrent?: boolean

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * AdminContractSeasonApi - object-oriented interface
 */
export class AdminContractSeasonApi extends BaseAPI {
    /**
     * 
     * @summary Get contract seasons
     * @param {AdminContractSeasonApiAdminContractSeasonsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractSeasonsGet(requestParameters: AdminContractSeasonApiAdminContractSeasonsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminContractSeasonApiFp(this.configuration).adminContractSeasonsGet(requestParameters.name, requestParameters.isCurrent, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminContractsApi - axios parameter creator
 */
export const AdminContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [admin] Duplicate a contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdDuplicatePost: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdDuplicatePost', 'contractId', contractId)
            const localVarPath = `/admin/contracts/{contractId}/duplicate`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of contracts
         * @param {string} [seasonIds] 
         * @param {Array<string>} [partnerIds] 
         * @param {Array<string>} [partnerManagerIds] 
         * @param {boolean} [isArchived] 
         * @param {Array<ContractType>} [contractTypes] 
         * @param {Array<PartnerRegion>} [partnerRegions] 
         * @param {SortContractOn} [sortContractOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [hasProtectionClause] 
         * @param {string} [ids] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsGet: async (seasonIds?: string, partnerIds?: Array<string>, partnerManagerIds?: Array<string>, isArchived?: boolean, contractTypes?: Array<ContractType>, partnerRegions?: Array<PartnerRegion>, sortContractOn?: SortContractOn, sortDirection?: SortDirection, hasProtectionClause?: boolean, ids?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (seasonIds !== undefined) {
                localVarQueryParameter['seasonIds'] = seasonIds;
            }

            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }

            if (partnerManagerIds) {
                localVarQueryParameter['partnerManagerIds'] = partnerManagerIds;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (contractTypes) {
                localVarQueryParameter['contractTypes'] = contractTypes;
            }

            if (partnerRegions) {
                localVarQueryParameter['partnerRegions'] = partnerRegions;
            }

            if (sortContractOn !== undefined) {
                localVarQueryParameter['sortContractOn'] = sortContractOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (hasProtectionClause !== undefined) {
                localVarQueryParameter['hasProtectionClause'] = hasProtectionClause;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activate a contract with protection clause
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdActivatePatch: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdActivatePatch', 'id', id)
            const localVarPath = `/admin/contracts/{id}/activate`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdArchivePatch: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdArchivePatch', 'id', id)
            const localVarPath = `/admin/contracts/{id}/archive`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdDelete', 'id', id)
            const localVarPath = `/admin/contracts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get contract with Id
         * @param {string} id 
         * @param {boolean} [showProgressInContractCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdGet: async (id: string, showProgressInContractCurrency?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdGet', 'id', id)
            const localVarPath = `/admin/contracts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (showProgressInContractCurrency !== undefined) {
                localVarQueryParameter['showProgressInContractCurrency'] = showProgressInContractCurrency;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalculates the progress of the contract
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdRecalculateProgressPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdRecalculateProgressPost', 'id', id)
            const localVarPath = `/admin/contracts/{id}/recalculate-progress`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUnarchivePatch: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdUnarchivePatch', 'id', id)
            const localVarPath = `/admin/contracts/{id}/unarchive`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {string} id 
         * @param {boolean} [locked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUpdateLockPost: async (id: string, locked?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdUpdateLockPost', 'id', id)
            const localVarPath = `/admin/contracts/{id}/update-lock`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locked !== undefined) {
                localVarQueryParameter['locked'] = locked;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create a contract
         * @param {CreateContractRequestDto} createContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPost: async (createContractRequestDto: CreateContractRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContractRequestDto' is not null or undefined
            assertParamExists('adminContractsPost', 'createContractRequestDto', createContractRequestDto)
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Update the contract
         * @param {UpdateContractRequestDto} updateContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPut: async (updateContractRequestDto: UpdateContractRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateContractRequestDto' is not null or undefined
            assertParamExists('adminContractsPut', 'updateContractRequestDto', updateContractRequestDto)
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContractsApi - functional programming interface
 */
export const AdminContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [admin] Duplicate a contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsContractIdDuplicatePost(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsContractIdDuplicatePost(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsContractIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of contracts
         * @param {string} [seasonIds] 
         * @param {Array<string>} [partnerIds] 
         * @param {Array<string>} [partnerManagerIds] 
         * @param {boolean} [isArchived] 
         * @param {Array<ContractType>} [contractTypes] 
         * @param {Array<PartnerRegion>} [partnerRegions] 
         * @param {SortContractOn} [sortContractOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [hasProtectionClause] 
         * @param {string} [ids] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsGet(seasonIds?: string, partnerIds?: Array<string>, partnerManagerIds?: Array<string>, isArchived?: boolean, contractTypes?: Array<ContractType>, partnerRegions?: Array<PartnerRegion>, sortContractOn?: SortContractOn, sortDirection?: SortDirection, hasProtectionClause?: boolean, ids?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsGet(seasonIds, partnerIds, partnerManagerIds, isArchived, contractTypes, partnerRegions, sortContractOn, sortDirection, hasProtectionClause, ids, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Activate a contract with protection clause
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdActivatePatch(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdActivatePatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdActivatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdArchivePatch(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdArchivePatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get contract with Id
         * @param {string} id 
         * @param {boolean} [showProgressInContractCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdGet(id: string, showProgressInContractCurrency?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdGet(id, showProgressInContractCurrency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recalculates the progress of the contract
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdRecalculateProgressPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdRecalculateProgressPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdRecalculateProgressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdUnarchivePatch(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdUnarchivePatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdUnarchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {string} id 
         * @param {boolean} [locked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsIdUpdateLockPost(id: string, locked?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsIdUpdateLockPost(id, locked, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsIdUpdateLockPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create a contract
         * @param {CreateContractRequestDto} createContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsPost(createContractRequestDto: CreateContractRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsPost(createContractRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Update the contract
         * @param {UpdateContractRequestDto} updateContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContractsPut(updateContractRequestDto: UpdateContractRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContractsPut(updateContractRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractsApi.adminContractsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminContractsApi - factory interface
 */
export const AdminContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContractsApiFp(configuration)
    return {
        /**
         * 
         * @summary [admin] Duplicate a contract
         * @param {AdminContractsApiAdminContractsContractIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdDuplicatePost(requestParameters: AdminContractsApiAdminContractsContractIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.adminContractsContractIdDuplicatePost(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of contracts
         * @param {AdminContractsApiAdminContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsGet(requestParameters: AdminContractsApiAdminContractsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfContractDto> {
            return localVarFp.adminContractsGet(requestParameters.seasonIds, requestParameters.partnerIds, requestParameters.partnerManagerIds, requestParameters.isArchived, requestParameters.contractTypes, requestParameters.partnerRegions, requestParameters.sortContractOn, requestParameters.sortDirection, requestParameters.hasProtectionClause, requestParameters.ids, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activate a contract with protection clause
         * @param {AdminContractsApiAdminContractsIdActivatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdActivatePatch(requestParameters: AdminContractsApiAdminContractsIdActivatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsIdActivatePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {AdminContractsApiAdminContractsIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdArchivePatch(requestParameters: AdminContractsApiAdminContractsIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsIdArchivePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {AdminContractsApiAdminContractsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdDelete(requestParameters: AdminContractsApiAdminContractsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get contract with Id
         * @param {AdminContractsApiAdminContractsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdGet(requestParameters: AdminContractsApiAdminContractsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.adminContractsIdGet(requestParameters.id, requestParameters.showProgressInContractCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalculates the progress of the contract
         * @param {AdminContractsApiAdminContractsIdRecalculateProgressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdRecalculateProgressPost(requestParameters: AdminContractsApiAdminContractsIdRecalculateProgressPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.adminContractsIdRecalculateProgressPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {AdminContractsApiAdminContractsIdUnarchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUnarchivePatch(requestParameters: AdminContractsApiAdminContractsIdUnarchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsIdUnarchivePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {AdminContractsApiAdminContractsIdUpdateLockPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUpdateLockPost(requestParameters: AdminContractsApiAdminContractsIdUpdateLockPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminContractsIdUpdateLockPost(requestParameters.id, requestParameters.locked, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Create a contract
         * @param {AdminContractsApiAdminContractsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPost(requestParameters: AdminContractsApiAdminContractsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.adminContractsPost(requestParameters.createContractRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [FinanceManager and Admin] Update the contract
         * @param {AdminContractsApiAdminContractsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPut(requestParameters: AdminContractsApiAdminContractsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.adminContractsPut(requestParameters.updateContractRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminContractsContractIdDuplicatePost operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsContractIdDuplicatePostRequest {
    /**
     * 
     */
    readonly contractId: string
}

/**
 * Request parameters for adminContractsGet operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsGetRequest {
    /**
     * 
     */
    readonly seasonIds?: string

    /**
     * 
     */
    readonly partnerIds?: Array<string>

    /**
     * 
     */
    readonly partnerManagerIds?: Array<string>

    /**
     * 
     */
    readonly isArchived?: boolean

    /**
     * 
     */
    readonly contractTypes?: Array<ContractType>

    /**
     * 
     */
    readonly partnerRegions?: Array<PartnerRegion>

    /**
     * 
     */
    readonly sortContractOn?: SortContractOn

    /**
     * 
     */
    readonly sortDirection?: SortDirection

    readonly hasProtectionClause?: boolean

    /**
     * 
     */
    readonly ids?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminContractsIdActivatePatch operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdActivatePatchRequest {
    readonly id: string
}

/**
 * Request parameters for adminContractsIdArchivePatch operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdArchivePatchRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminContractsIdDelete operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdDeleteRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminContractsIdGet operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdGetRequest {
    /**
     * 
     */
    readonly id: string

    readonly showProgressInContractCurrency?: boolean
}

/**
 * Request parameters for adminContractsIdRecalculateProgressPost operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdRecalculateProgressPostRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminContractsIdUnarchivePatch operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdUnarchivePatchRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminContractsIdUpdateLockPost operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsIdUpdateLockPostRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * 
     */
    readonly locked?: boolean
}

/**
 * Request parameters for adminContractsPost operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsPostRequest {
    /**
     * 
     */
    readonly createContractRequestDto: CreateContractRequestDto
}

/**
 * Request parameters for adminContractsPut operation in AdminContractsApi.
 */
export interface AdminContractsApiAdminContractsPutRequest {
    /**
     * 
     */
    readonly updateContractRequestDto: UpdateContractRequestDto
}

/**
 * AdminContractsApi - object-oriented interface
 */
export class AdminContractsApi extends BaseAPI {
    /**
     * 
     * @summary [admin] Duplicate a contract
     * @param {AdminContractsApiAdminContractsContractIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsContractIdDuplicatePost(requestParameters: AdminContractsApiAdminContractsContractIdDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsContractIdDuplicatePost(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets a paginated list of contracts
     * @param {AdminContractsApiAdminContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsGet(requestParameters: AdminContractsApiAdminContractsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsGet(requestParameters.seasonIds, requestParameters.partnerIds, requestParameters.partnerManagerIds, requestParameters.isArchived, requestParameters.contractTypes, requestParameters.partnerRegions, requestParameters.sortContractOn, requestParameters.sortDirection, requestParameters.hasProtectionClause, requestParameters.ids, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activate a contract with protection clause
     * @param {AdminContractsApiAdminContractsIdActivatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdActivatePatch(requestParameters: AdminContractsApiAdminContractsIdActivatePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdActivatePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Finance Manager and Admin] Archive a contract with Id
     * @param {AdminContractsApiAdminContractsIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdArchivePatch(requestParameters: AdminContractsApiAdminContractsIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdArchivePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Finance Manager and Admin] Delete a contract with Id
     * @param {AdminContractsApiAdminContractsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdDelete(requestParameters: AdminContractsApiAdminContractsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get contract with Id
     * @param {AdminContractsApiAdminContractsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdGet(requestParameters: AdminContractsApiAdminContractsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdGet(requestParameters.id, requestParameters.showProgressInContractCurrency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalculates the progress of the contract
     * @param {AdminContractsApiAdminContractsIdRecalculateProgressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdRecalculateProgressPost(requestParameters: AdminContractsApiAdminContractsIdRecalculateProgressPostRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdRecalculateProgressPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Finance Manager and Admin] Unarchived a contract that is archived
     * @param {AdminContractsApiAdminContractsIdUnarchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdUnarchivePatch(requestParameters: AdminContractsApiAdminContractsIdUnarchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdUnarchivePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the locked status of the contract to whatever you want it to be
     * @param {AdminContractsApiAdminContractsIdUpdateLockPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsIdUpdateLockPost(requestParameters: AdminContractsApiAdminContractsIdUpdateLockPostRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsIdUpdateLockPost(requestParameters.id, requestParameters.locked, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [FinanceManager and Admin] Create a contract
     * @param {AdminContractsApiAdminContractsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsPost(requestParameters: AdminContractsApiAdminContractsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsPost(requestParameters.createContractRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [FinanceManager and Admin] Update the contract
     * @param {AdminContractsApiAdminContractsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminContractsPut(requestParameters: AdminContractsApiAdminContractsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminContractsApiFp(this.configuration).adminContractsPut(requestParameters.updateContractRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCountriesApi - axios parameter creator
 */
export const AdminCountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a country by iso2Code or Id
         * @param {string} countryIdentifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryIdentifierGet: async (countryIdentifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryIdentifier' is not null or undefined
            assertParamExists('adminCountriesCountryIdentifierGet', 'countryIdentifier', countryIdentifier)
            const localVarPath = `/admin/countries/{countryIdentifier}`
                .replace('{countryIdentifier}', encodeURIComponent(String(countryIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id if search term is empty it will give all the countries
         * @param {string} [searchTerm] If SearchTerm is empty you will get all the countries         search is done on name and country code or the id         id must 100% match
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeStates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet: async (searchTerm?: string, offSet?: number, pageSize?: number, includeStates?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (includeStates !== undefined) {
                localVarQueryParameter['includeStates'] = includeStates;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCountriesApi - functional programming interface
 */
export const AdminCountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a country by iso2Code or Id
         * @param {string} countryIdentifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCountriesCountryIdentifierGet(countryIdentifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCountriesCountryIdentifierGet(countryIdentifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCountriesApi.adminCountriesCountryIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id if search term is empty it will give all the countries
         * @param {string} [searchTerm] If SearchTerm is empty you will get all the countries         search is done on name and country code or the id         id must 100% match
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeStates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCountriesGet(searchTerm?: string, offSet?: number, pageSize?: number, includeStates?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminCountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCountriesGet(searchTerm, offSet, pageSize, includeStates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCountriesApi.adminCountriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCountriesApi - factory interface
 */
export const AdminCountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCountriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a country by iso2Code or Id
         * @param {AdminCountriesApiAdminCountriesCountryIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryIdentifierGet(requestParameters: AdminCountriesApiAdminCountriesCountryIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCountryResponse> {
            return localVarFp.adminCountriesCountryIdentifierGet(requestParameters.countryIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id if search term is empty it will give all the countries
         * @param {AdminCountriesApiAdminCountriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet(requestParameters: AdminCountriesApiAdminCountriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminCountryResponse> {
            return localVarFp.adminCountriesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeStates, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCountriesCountryIdentifierGet operation in AdminCountriesApi.
 */
export interface AdminCountriesApiAdminCountriesCountryIdentifierGetRequest {
    /**
     * 
     */
    readonly countryIdentifier: string
}

/**
 * Request parameters for adminCountriesGet operation in AdminCountriesApi.
 */
export interface AdminCountriesApiAdminCountriesGetRequest {
    /**
     * If SearchTerm is empty you will get all the countries         search is done on name and country code or the id         id must 100% match
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number

    readonly includeStates?: boolean
}

/**
 * AdminCountriesApi - object-oriented interface
 */
export class AdminCountriesApi extends BaseAPI {
    /**
     * 
     * @summary Get a country by iso2Code or Id
     * @param {AdminCountriesApiAdminCountriesCountryIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCountriesCountryIdentifierGet(requestParameters: AdminCountriesApiAdminCountriesCountryIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCountriesApiFp(this.configuration).adminCountriesCountryIdentifierGet(requestParameters.countryIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all counties, can search by name, if you give Id, it will find by Id if search term is empty it will give all the countries
     * @param {AdminCountriesApiAdminCountriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCountriesGet(requestParameters: AdminCountriesApiAdminCountriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCountriesApiFp(this.configuration).adminCountriesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeStates, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCurrencyApi - axios parameter creator
 */
export const AdminCurrencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] add a new currency
         * @param {string} body An ISO standard currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCurrenciesPost: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminCurrenciesPost', 'body', body)
            const localVarPath = `/admin/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCurrencyApi - functional programming interface
 */
export const AdminCurrencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCurrencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] add a new currency
         * @param {string} body An ISO standard currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCurrenciesPost(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCurrenciesPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCurrencyApi.adminCurrenciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCurrencyApi - factory interface
 */
export const AdminCurrencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCurrencyApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] add a new currency
         * @param {AdminCurrencyApiAdminCurrenciesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCurrenciesPost(requestParameters: AdminCurrencyApiAdminCurrenciesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.adminCurrenciesPost(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCurrenciesPost operation in AdminCurrencyApi.
 */
export interface AdminCurrencyApiAdminCurrenciesPostRequest {
    /**
     * An ISO standard currency code
     */
    readonly body: string
}

/**
 * AdminCurrencyApi - object-oriented interface
 */
export class AdminCurrencyApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] add a new currency
     * @param {AdminCurrencyApiAdminCurrenciesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCurrenciesPost(requestParameters: AdminCurrencyApiAdminCurrenciesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminCurrencyApiFp(this.configuration).adminCurrenciesPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomerAddressesApi - axios parameter creator
 */
export const AdminCustomerAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an address from a customer It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdDelete: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersAddressesAddressIdDelete', 'addressId', addressId)
            const localVarPath = `/admin/customers/addresses/{addressId}`
                .replace('{addressId}', encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AddressRequestDto} addressRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdPut: async (addressId: string, addressRequestDto: AddressRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersAddressesAddressIdPut', 'addressId', addressId)
            // verify required parameter 'addressRequestDto' is not null or undefined
            assertParamExists('adminCustomersAddressesAddressIdPut', 'addressRequestDto', addressRequestDto)
            const localVarPath = `/admin/customers/addresses/{addressId}`
                .replace('{addressId}', encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add\'s an address to the given customer
         * @param {string} customerId 
         * @param {AddressRequestDto} addressRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesPost: async (customerId: string, addressRequestDto: AddressRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesPost', 'customerId', customerId)
            // verify required parameter 'addressRequestDto' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesPost', 'addressRequestDto', addressRequestDto)
            const localVarPath = `/admin/customers/{customerId}/addresses`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomerAddressesApi - functional programming interface
 */
export const AdminCustomerAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomerAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an address from a customer It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersAddressesAddressIdDelete(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressDeletedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersAddressesAddressIdDelete(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerAddressesApi.adminCustomersAddressesAddressIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AddressRequestDto} addressRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersAddressesAddressIdPut(addressId: string, addressRequestDto: AddressRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersAddressesAddressIdPut(addressId, addressRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerAddressesApi.adminCustomersAddressesAddressIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add\'s an address to the given customer
         * @param {string} customerId 
         * @param {AddressRequestDto} addressRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdAddressesPost(customerId: string, addressRequestDto: AddressRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdAddressesPost(customerId, addressRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerAddressesApi.adminCustomersCustomerIdAddressesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomerAddressesApi - factory interface
 */
export const AdminCustomerAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomerAddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an address from a customer It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdDelete(requestParameters: AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerAddressDeletedDto> {
            return localVarFp.adminCustomersAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one address of a customer
         * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdPut(requestParameters: AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerAddressDto> {
            return localVarFp.adminCustomersAddressesAddressIdPut(requestParameters.addressId, requestParameters.addressRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add\'s an address to the given customer
         * @param {AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesPost(requestParameters: AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerAddressDto> {
            return localVarFp.adminCustomersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.addressRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCustomersAddressesAddressIdDelete operation in AdminCustomerAddressesApi.
 */
export interface AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest {
    /**
     * The id of the address that needs to be removed
     */
    readonly addressId: string
}

/**
 * Request parameters for adminCustomersAddressesAddressIdPut operation in AdminCustomerAddressesApi.
 */
export interface AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest {
    /**
     * The id of the address that needs to be updated
     */
    readonly addressId: string

    /**
     * 
     */
    readonly addressRequestDto: AddressRequestDto
}

/**
 * Request parameters for adminCustomersCustomerIdAddressesPost operation in AdminCustomerAddressesApi.
 */
export interface AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest {
    /**
     * 
     */
    readonly customerId: string

    /**
     * 
     */
    readonly addressRequestDto: AddressRequestDto
}

/**
 * AdminCustomerAddressesApi - object-oriented interface
 */
export class AdminCustomerAddressesApi extends BaseAPI {
    /**
     * 
     * @summary Delete an address from a customer It is not possible to delete an address if this address is a customer\'s billing or shipping address
     * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersAddressesAddressIdDelete(requestParameters: AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one address of a customer
     * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersAddressesAddressIdPut(requestParameters: AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersAddressesAddressIdPut(requestParameters.addressId, requestParameters.addressRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add\'s an address to the given customer
     * @param {AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdAddressesPost(requestParameters: AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.addressRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomerPaymentTokensApi - axios parameter creator
 */
export const AdminCustomerPaymentTokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {string} customerId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensGet: async (customerId: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensGet', 'customerId', customerId)
            const localVarPath = `/admin/customers/{customerId}/payment-tokens`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} paymentTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete: async (customerId: string, paymentTokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete', 'customerId', customerId)
            // verify required parameter 'paymentTokenId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete', 'paymentTokenId', paymentTokenId)
            const localVarPath = `/admin/customers/{customerId}/payment-tokens/{paymentTokenId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{paymentTokenId}', encodeURIComponent(String(paymentTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomerPaymentTokensApi - functional programming interface
 */
export const AdminCustomerPaymentTokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomerPaymentTokensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {string} customerId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdPaymentTokensGet(customerId: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminPaymentTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdPaymentTokensGet(customerId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerPaymentTokensApi.adminCustomersCustomerIdPaymentTokensGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} paymentTokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(customerId: string, paymentTokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(customerId, paymentTokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerPaymentTokensApi.adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomerPaymentTokensApi - factory interface
 */
export const AdminCustomerPaymentTokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomerPaymentTokensApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensGet(requestParameters: AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminPaymentTokenResponse> {
            return localVarFp.adminCustomersCustomerIdPaymentTokensGet(requestParameters.customerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters: AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters.customerId, requestParameters.paymentTokenId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCustomersCustomerIdPaymentTokensGet operation in AdminCustomerPaymentTokensApi.
 */
export interface AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest {
    readonly customerId: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete operation in AdminCustomerPaymentTokensApi.
 */
export interface AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest {
    readonly customerId: string

    readonly paymentTokenId: string
}

/**
 * AdminCustomerPaymentTokensApi - object-oriented interface
 */
export class AdminCustomerPaymentTokensApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get all saved payment tokens for a customer
     * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdPaymentTokensGet(requestParameters: AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerPaymentTokensApiFp(this.configuration).adminCustomersCustomerIdPaymentTokensGet(requestParameters.customerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters: AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerPaymentTokensApiFp(this.configuration).adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters.customerId, requestParameters.paymentTokenId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomerPreAuthorisationsApi - axios parameter creator
 */
export const AdminCustomerPreAuthorisationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all pre-authorisations for a customer
         * @param {string} customerId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsGet: async (customerId: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsGet', 'customerId', customerId)
            const localVarPath = `/admin/customers/{customerId}/pre-authorisations`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Capture pre-authorization
         * @param {string} preAuthorisationId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch: async (preAuthorisationId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preAuthorisationId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch', 'preAuthorisationId', preAuthorisationId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch', 'customerId', customerId)
            const localVarPath = `/admin/customers/{customerId}/pre-authorisations/{preAuthorisationId}/capture`
                .replace('{preAuthorisationId}', encodeURIComponent(String(preAuthorisationId)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Release pre-authorization
         * @param {string} preAuthorisationId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch: async (preAuthorisationId: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preAuthorisationId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch', 'preAuthorisationId', preAuthorisationId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch', 'customerId', customerId)
            const localVarPath = `/admin/customers/{customerId}/pre-authorisations/{preAuthorisationId}/release`
                .replace('{preAuthorisationId}', encodeURIComponent(String(preAuthorisationId)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomerPreAuthorisationsApi - functional programming interface
 */
export const AdminCustomerPreAuthorisationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomerPreAuthorisationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all pre-authorisations for a customer
         * @param {string} customerId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdPreAuthorisationsGet(customerId: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminPreAuthorisationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdPreAuthorisationsGet(customerId, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerPreAuthorisationsApi.adminCustomersCustomerIdPreAuthorisationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Capture pre-authorization
         * @param {string} preAuthorisationId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(preAuthorisationId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(preAuthorisationId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerPreAuthorisationsApi.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Release pre-authorization
         * @param {string} preAuthorisationId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(preAuthorisationId: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(preAuthorisationId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerPreAuthorisationsApi.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomerPreAuthorisationsApi - factory interface
 */
export const AdminCustomerPreAuthorisationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomerPreAuthorisationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all pre-authorisations for a customer
         * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsGet(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminPreAuthorisationResponse> {
            return localVarFp.adminCustomersCustomerIdPreAuthorisationsGet(requestParameters.customerId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Capture pre-authorization
         * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Release pre-authorization
         * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCustomersCustomerIdPreAuthorisationsGet operation in AdminCustomerPreAuthorisationsApi.
 */
export interface AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest {
    readonly customerId: string

    readonly offSet?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch operation in AdminCustomerPreAuthorisationsApi.
 */
export interface AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatchRequest {
    readonly preAuthorisationId: string

    readonly customerId: string
}

/**
 * Request parameters for adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch operation in AdminCustomerPreAuthorisationsApi.
 */
export interface AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest {
    readonly preAuthorisationId: string

    readonly customerId: string
}

/**
 * AdminCustomerPreAuthorisationsApi - object-oriented interface
 */
export class AdminCustomerPreAuthorisationsApi extends BaseAPI {
    /**
     * 
     * @summary Get all pre-authorisations for a customer
     * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdPreAuthorisationsGet(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerPreAuthorisationsApiFp(this.configuration).adminCustomersCustomerIdPreAuthorisationsGet(requestParameters.customerId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Capture pre-authorization
     * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerPreAuthorisationsApiFp(this.configuration).adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdCapturePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Release pre-authorization
     * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters: AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerPreAuthorisationsApiFp(this.configuration).adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomersApi - axios parameter creator
 */
export const AdminCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesAddressIdStatusPatch: async (customerId: string, addressId: string, billing?: boolean, shipping?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesAddressIdStatusPatch', 'customerId', customerId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesAddressIdStatusPatch', 'addressId', addressId)
            const localVarPath = `/admin/customers/{customerId}/addresses/{addressId}/status`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{addressId}', encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billing !== undefined) {
                localVarQueryParameter['billing'] = billing;
            }

            if (shipping !== undefined) {
                localVarQueryParameter['shipping'] = shipping;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdBlockShipmentPatch: async (customerId: string, body: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdBlockShipmentPatch', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminCustomersCustomerIdBlockShipmentPatch', 'body', body)
            const localVarPath = `/admin/customers/{customerId}/block-shipment`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get customer by id
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdGet: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdGet', 'customerId', customerId)
            const localVarPath = `/admin/customers/{customerId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {UpdateTrustProfileRequest} updateTrustProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdTrustProfilePatch: async (customerId: string, updateTrustProfileRequest: UpdateTrustProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdTrustProfilePatch', 'customerId', customerId)
            // verify required parameter 'updateTrustProfileRequest' is not null or undefined
            assertParamExists('adminCustomersCustomerIdTrustProfilePatch', 'updateTrustProfileRequest', updateTrustProfileRequest)
            const localVarPath = `/admin/customers/{customerId}/trust-profile`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrustProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get customers by ids
         * @param {string} [customerIds] 
         * @param {string} [platformIds] 
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet: async (customerIds?: string, platformIds?: string, searchTerm?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerIds !== undefined) {
                localVarQueryParameter['customerIds'] = customerIds;
            }

            if (platformIds !== undefined) {
                localVarQueryParameter['platformIds'] = platformIds;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer object by userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUserUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminCustomersUserUserIdGet', 'userId', userId)
            const localVarPath = `/admin/customers/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get customer by userIds
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUsersPost: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('adminCustomersUsersPost', 'requestBody', requestBody)
            const localVarPath = `/admin/customers/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomersApi - functional programming interface
 */
export const AdminCustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdAddressesAddressIdStatusPatch(customerId: string, addressId: string, billing?: boolean, shipping?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCustomerAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersCustomerIdAddressesAddressIdStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdBlockShipmentPatch(customerId: string, body: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdBlockShipmentPatch(customerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersCustomerIdBlockShipmentPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get customer by id
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdGet(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdGet(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersCustomerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {UpdateTrustProfileRequest} updateTrustProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersCustomerIdTrustProfilePatch(customerId: string, updateTrustProfileRequest: UpdateTrustProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersCustomerIdTrustProfilePatch(customerId, updateTrustProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersCustomerIdTrustProfilePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get customers by ids
         * @param {string} [customerIds] 
         * @param {string} [platformIds] 
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersGet(customerIds?: string, platformIds?: string, searchTerm?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersGet(customerIds, platformIds, searchTerm, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get customer object by userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersUserUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersUserUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersUserUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get customer by userIds
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCustomersUsersPost(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminCustomerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCustomersUsersPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomersApi.adminCustomersUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomersApi - factory interface
 */
export const AdminCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCustomerAddressResponse> {
            return localVarFp.adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdBlockShipmentPatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCustomersCustomerIdBlockShipmentPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get customer by id
         * @param {AdminCustomersApiAdminCustomersCustomerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdGet(requestParameters: AdminCustomersApiAdminCustomersCustomerIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCustomerResponse> {
            return localVarFp.adminCustomersCustomerIdGet(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCustomersApiAdminCustomersCustomerIdTrustProfilePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdTrustProfilePatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdTrustProfilePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCustomersCustomerIdTrustProfilePatch(requestParameters.customerId, requestParameters.updateTrustProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get customers by ids
         * @param {AdminCustomersApiAdminCustomersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet(requestParameters: AdminCustomersApiAdminCustomersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminCustomerResponse> {
            return localVarFp.adminCustomersGet(requestParameters.customerIds, requestParameters.platformIds, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer object by userId
         * @param {AdminCustomersApiAdminCustomersUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUserUserIdGet(requestParameters: AdminCustomersApiAdminCustomersUserUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCustomerResponse> {
            return localVarFp.adminCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get customer by userIds
         * @param {AdminCustomersApiAdminCustomersUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUsersPost(requestParameters: AdminCustomersApiAdminCustomersUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerResponse>> {
            return localVarFp.adminCustomersUsersPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCustomersCustomerIdAddressesAddressIdStatusPatch operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest {
    /**
     * The id of the customer
     */
    readonly customerId: string

    /**
     * The id of the new billing/shipping address
     */
    readonly addressId: string

    /**
     * Set this address to the user\&#39;s billing address
     */
    readonly billing?: boolean

    /**
     * Set this address to the user\&#39;s shipping address
     */
    readonly shipping?: boolean
}

/**
 * Request parameters for adminCustomersCustomerIdBlockShipmentPatch operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest {
    readonly customerId: string

    readonly body: boolean
}

/**
 * Request parameters for adminCustomersCustomerIdGet operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersCustomerIdGetRequest {
    /**
     * 
     */
    readonly customerId: string
}

/**
 * Request parameters for adminCustomersCustomerIdTrustProfilePatch operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersCustomerIdTrustProfilePatchRequest {
    readonly customerId: string

    readonly updateTrustProfileRequest: UpdateTrustProfileRequest
}

/**
 * Request parameters for adminCustomersGet operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersGetRequest {
    /**
     * 
     */
    readonly customerIds?: string

    /**
     * 
     */
    readonly platformIds?: string

    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminCustomersUserUserIdGet operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersUserUserIdGetRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * Request parameters for adminCustomersUsersPost operation in AdminCustomersApi.
 */
export interface AdminCustomersApiAdminCustomersUsersPostRequest {
    /**
     * 
     */
    readonly requestBody: Array<string>
}

/**
 * AdminCustomersApi - object-oriented interface
 */
export class AdminCustomersApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
     * @param {AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdBlockShipmentPatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdBlockShipmentPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get customer by id
     * @param {AdminCustomersApiAdminCustomersCustomerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdGet(requestParameters: AdminCustomersApiAdminCustomersCustomerIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdGet(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCustomersApiAdminCustomersCustomerIdTrustProfilePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersCustomerIdTrustProfilePatch(requestParameters: AdminCustomersApiAdminCustomersCustomerIdTrustProfilePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdTrustProfilePatch(requestParameters.customerId, requestParameters.updateTrustProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get customers by ids
     * @param {AdminCustomersApiAdminCustomersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersGet(requestParameters: AdminCustomersApiAdminCustomersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersGet(requestParameters.customerIds, requestParameters.platformIds, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer object by userId
     * @param {AdminCustomersApiAdminCustomersUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersUserUserIdGet(requestParameters: AdminCustomersApiAdminCustomersUserUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get customer by userIds
     * @param {AdminCustomersApiAdminCustomersUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCustomersUsersPost(requestParameters: AdminCustomersApiAdminCustomersUsersPostRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomersApiFp(this.configuration).adminCustomersUsersPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDiscountsApi - axios parameter creator
 */
export const AdminDiscountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found; otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {Array<CreateOrUpdateDiscountRequest>} createOrUpdateDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsBatchPut: async (createOrUpdateDiscountRequest: Array<CreateOrUpdateDiscountRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrUpdateDiscountRequest' is not null or undefined
            assertParamExists('adminDiscountsBatchPut', 'createOrUpdateDiscountRequest', createOrUpdateDiscountRequest)
            const localVarPath = `/admin/discounts/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateDiscountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event. Requires Finance Manager or Admin permissions.
         * @param {string} [platformId] 
         * @param {DiscountTypeDto} [discountType] 
         * @param {VersionTypeDto} [versionType] 
         * @param {number | null} [tier] 
         * @param {string} [countryCode] 
         * @param {string} [categoryId] 
         * @param {string} [eventId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsGet: async (platformId?: string, discountType?: DiscountTypeDto, versionType?: VersionTypeDto, tier?: number | null, countryCode?: string, categoryId?: string, eventId?: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformId !== undefined) {
                localVarQueryParameter['PlatformId'] = platformId;
            }

            if (discountType !== undefined) {
                localVarQueryParameter['DiscountType'] = discountType;
            }

            if (versionType !== undefined) {
                localVarQueryParameter['VersionType'] = versionType;
            }

            if (tier !== undefined) {
                localVarQueryParameter['Tier'] = tier;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['CountryCode'] = countryCode;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['EventId'] = eventId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDiscountsApi - functional programming interface
 */
export const AdminDiscountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDiscountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found; otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {Array<CreateOrUpdateDiscountRequest>} createOrUpdateDiscountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiscountsBatchPut(createOrUpdateDiscountRequest: Array<CreateOrUpdateDiscountRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscountResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiscountsBatchPut(createOrUpdateDiscountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountsApi.adminDiscountsBatchPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event. Requires Finance Manager or Admin permissions.
         * @param {string} [platformId] 
         * @param {DiscountTypeDto} [discountType] 
         * @param {VersionTypeDto} [versionType] 
         * @param {number | null} [tier] 
         * @param {string} [countryCode] 
         * @param {string} [categoryId] 
         * @param {string} [eventId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiscountsGet(platformId?: string, discountType?: DiscountTypeDto, versionType?: VersionTypeDto, tier?: number | null, countryCode?: string, categoryId?: string, eventId?: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscountResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiscountsGet(platformId, discountType, versionType, tier, countryCode, categoryId, eventId, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountsApi.adminDiscountsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDiscountsApi - factory interface
 */
export const AdminDiscountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDiscountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found; otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {AdminDiscountsApiAdminDiscountsBatchPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsBatchPut(requestParameters: AdminDiscountsApiAdminDiscountsBatchPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscountResponse>> {
            return localVarFp.adminDiscountsBatchPut(requestParameters.createOrUpdateDiscountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event. Requires Finance Manager or Admin permissions.
         * @param {AdminDiscountsApiAdminDiscountsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsGet(requestParameters: AdminDiscountsApiAdminDiscountsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscountResponse>> {
            return localVarFp.adminDiscountsGet(requestParameters.platformId, requestParameters.discountType, requestParameters.versionType, requestParameters.tier, requestParameters.countryCode, requestParameters.categoryId, requestParameters.eventId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminDiscountsBatchPut operation in AdminDiscountsApi.
 */
export interface AdminDiscountsApiAdminDiscountsBatchPutRequest {
    /**
     * 
     */
    readonly createOrUpdateDiscountRequest: Array<CreateOrUpdateDiscountRequest>
}

/**
 * Request parameters for adminDiscountsGet operation in AdminDiscountsApi.
 */
export interface AdminDiscountsApiAdminDiscountsGetRequest {
    readonly platformId?: string

    readonly discountType?: DiscountTypeDto

    readonly versionType?: VersionTypeDto

    readonly tier?: number | null

    readonly countryCode?: string

    readonly categoryId?: string

    readonly eventId?: string

    readonly isActive?: boolean
}

/**
 * AdminDiscountsApi - object-oriented interface
 */
export class AdminDiscountsApi extends BaseAPI {
    /**
     * 
     * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found; otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
     * @param {AdminDiscountsApiAdminDiscountsBatchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDiscountsBatchPut(requestParameters: AdminDiscountsApiAdminDiscountsBatchPutRequest, options?: RawAxiosRequestConfig) {
        return AdminDiscountsApiFp(this.configuration).adminDiscountsBatchPut(requestParameters.createOrUpdateDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event. Requires Finance Manager or Admin permissions.
     * @param {AdminDiscountsApiAdminDiscountsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDiscountsGet(requestParameters: AdminDiscountsApiAdminDiscountsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDiscountsApiFp(this.configuration).adminDiscountsGet(requestParameters.platformId, requestParameters.discountType, requestParameters.versionType, requestParameters.tier, requestParameters.countryCode, requestParameters.categoryId, requestParameters.eventId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventSettingsApi - axios parameter creator
 */
export const AdminEventSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get paginated list of event settings
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsGet: async (offset?: number, pageSize?: number, isArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/event-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Archive or unarchive event settings
         * @param {string} id 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdArchivePatch: async (id: string, archiveRequest: ArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminEventSettingsIdArchivePatch', 'id', id)
            // verify required parameter 'archiveRequest' is not null or undefined
            assertParamExists('adminEventSettingsIdArchivePatch', 'archiveRequest', archiveRequest)
            const localVarPath = `/admin/event-settings/{id}/archive`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get event setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminEventSettingsIdGet', 'id', id)
            const localVarPath = `/admin/event-settings/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update event settings
         * @param {string} id 
         * @param {UpdateEventSettingsRequest} updateEventSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdPut: async (id: string, updateEventSettingsRequest: UpdateEventSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminEventSettingsIdPut', 'id', id)
            // verify required parameter 'updateEventSettingsRequest' is not null or undefined
            assertParamExists('adminEventSettingsIdPut', 'updateEventSettingsRequest', updateEventSettingsRequest)
            const localVarPath = `/admin/event-settings/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create event settings
         * @param {CreateEventSettingsRequest} createEventSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsPost: async (createEventSettingsRequest: CreateEventSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEventSettingsRequest' is not null or undefined
            assertParamExists('adminEventSettingsPost', 'createEventSettingsRequest', createEventSettingsRequest)
            const localVarPath = `/admin/event-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventSettingsApi - functional programming interface
 */
export const AdminEventSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get paginated list of event settings
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventSettingsGet(offset?: number, pageSize?: number, isArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminEventSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventSettingsGet(offset, pageSize, isArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventSettingsApi.adminEventSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Archive or unarchive event settings
         * @param {string} id 
         * @param {ArchiveRequest} archiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventSettingsIdArchivePatch(id: string, archiveRequest: ArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventSettingsIdArchivePatch(id, archiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventSettingsApi.adminEventSettingsIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get event setting by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventSettingsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEventSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventSettingsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventSettingsApi.adminEventSettingsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update event settings
         * @param {string} id 
         * @param {UpdateEventSettingsRequest} updateEventSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventSettingsIdPut(id: string, updateEventSettingsRequest: UpdateEventSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventSettingsIdPut(id, updateEventSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventSettingsApi.adminEventSettingsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create event settings
         * @param {CreateEventSettingsRequest} createEventSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventSettingsPost(createEventSettingsRequest: CreateEventSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventSettingsPost(createEventSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventSettingsApi.adminEventSettingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventSettingsApi - factory interface
 */
export const AdminEventSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get paginated list of event settings
         * @param {AdminEventSettingsApiAdminEventSettingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsGet(requestParameters: AdminEventSettingsApiAdminEventSettingsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminEventSettingsResponse> {
            return localVarFp.adminEventSettingsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.isArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Archive or unarchive event settings
         * @param {AdminEventSettingsApiAdminEventSettingsIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdArchivePatch(requestParameters: AdminEventSettingsApiAdminEventSettingsIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventSettingsIdArchivePatch(requestParameters.id, requestParameters.archiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get event setting by id
         * @param {AdminEventSettingsApiAdminEventSettingsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdGet(requestParameters: AdminEventSettingsApiAdminEventSettingsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEventSettingsResponse> {
            return localVarFp.adminEventSettingsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update event settings
         * @param {AdminEventSettingsApiAdminEventSettingsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsIdPut(requestParameters: AdminEventSettingsApiAdminEventSettingsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventSettingsIdPut(requestParameters.id, requestParameters.updateEventSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create event settings
         * @param {AdminEventSettingsApiAdminEventSettingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSettingsPost(requestParameters: AdminEventSettingsApiAdminEventSettingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventSettingsPost(requestParameters.createEventSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventSettingsGet operation in AdminEventSettingsApi.
 */
export interface AdminEventSettingsApiAdminEventSettingsGetRequest {
    readonly offset?: number

    readonly pageSize?: number

    readonly isArchived?: boolean
}

/**
 * Request parameters for adminEventSettingsIdArchivePatch operation in AdminEventSettingsApi.
 */
export interface AdminEventSettingsApiAdminEventSettingsIdArchivePatchRequest {
    readonly id: string

    readonly archiveRequest: ArchiveRequest
}

/**
 * Request parameters for adminEventSettingsIdGet operation in AdminEventSettingsApi.
 */
export interface AdminEventSettingsApiAdminEventSettingsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for adminEventSettingsIdPut operation in AdminEventSettingsApi.
 */
export interface AdminEventSettingsApiAdminEventSettingsIdPutRequest {
    readonly id: string

    readonly updateEventSettingsRequest: UpdateEventSettingsRequest
}

/**
 * Request parameters for adminEventSettingsPost operation in AdminEventSettingsApi.
 */
export interface AdminEventSettingsApiAdminEventSettingsPostRequest {
    readonly createEventSettingsRequest: CreateEventSettingsRequest
}

/**
 * AdminEventSettingsApi - object-oriented interface
 */
export class AdminEventSettingsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get paginated list of event settings
     * @param {AdminEventSettingsApiAdminEventSettingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventSettingsGet(requestParameters: AdminEventSettingsApiAdminEventSettingsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventSettingsApiFp(this.configuration).adminEventSettingsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.isArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Archive or unarchive event settings
     * @param {AdminEventSettingsApiAdminEventSettingsIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventSettingsIdArchivePatch(requestParameters: AdminEventSettingsApiAdminEventSettingsIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventSettingsApiFp(this.configuration).adminEventSettingsIdArchivePatch(requestParameters.id, requestParameters.archiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get event setting by id
     * @param {AdminEventSettingsApiAdminEventSettingsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventSettingsIdGet(requestParameters: AdminEventSettingsApiAdminEventSettingsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventSettingsApiFp(this.configuration).adminEventSettingsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update event settings
     * @param {AdminEventSettingsApiAdminEventSettingsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventSettingsIdPut(requestParameters: AdminEventSettingsApiAdminEventSettingsIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventSettingsApiFp(this.configuration).adminEventSettingsIdPut(requestParameters.id, requestParameters.updateEventSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create event settings
     * @param {AdminEventSettingsApiAdminEventSettingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventSettingsPost(requestParameters: AdminEventSettingsApiAdminEventSettingsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventSettingsApiFp(this.configuration).adminEventSettingsPost(requestParameters.createEventSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminExchangeRatesApi - axios parameter creator
 */
export const AdminExchangeRatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExchangeratesRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/exchangerates/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminExchangeRatesApi - functional programming interface
 */
export const AdminExchangeRatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminExchangeRatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminExchangeratesRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentExchangeRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminExchangeratesRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminExchangeRatesApi.adminExchangeratesRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminExchangeRatesApi - factory interface
 */
export const AdminExchangeRatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminExchangeRatesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExchangeratesRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<CurrentExchangeRatesResponse> {
            return localVarFp.adminExchangeratesRefreshPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminExchangeRatesApi - object-oriented interface
 */
export class AdminExchangeRatesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] refresh current exchange rates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminExchangeratesRefreshPost(options?: RawAxiosRequestConfig) {
        return AdminExchangeRatesApiFp(this.configuration).adminExchangeratesRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFinancialReportApi - axios parameter creator
 */
export const AdminFinancialReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Generate a financial report for an event
         * @param {string} eventId 
         * @param {GenerateFinancialReportRequest} generateFinancialReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsEventsEventIdPost: async (eventId: string, generateFinancialReportRequest: GenerateFinancialReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminFinancialReportsEventsEventIdPost', 'eventId', eventId)
            // verify required parameter 'generateFinancialReportRequest' is not null or undefined
            assertParamExists('adminFinancialReportsEventsEventIdPost', 'generateFinancialReportRequest', generateFinancialReportRequest)
            const localVarPath = `/admin/financial-reports/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateFinancialReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get financial reports
         * @param {string} [contractId] 
         * @param {SortDirection} [sortBy] 
         * @param {boolean} [isFinal] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsGet: async (contractId?: string, sortBy?: SortDirection, isFinal?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/financial-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contractId !== undefined) {
                localVarQueryParameter['ContractId'] = contractId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (isFinal !== undefined) {
                localVarQueryParameter['IsFinal'] = isFinal;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFinancialReportApi - functional programming interface
 */
export const AdminFinancialReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFinancialReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Generate a financial report for an event
         * @param {string} eventId 
         * @param {GenerateFinancialReportRequest} generateFinancialReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFinancialReportsEventsEventIdPost(eventId: string, generateFinancialReportRequest: GenerateFinancialReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFinancialReportsEventsEventIdPost(eventId, generateFinancialReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFinancialReportApi.adminFinancialReportsEventsEventIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get financial reports
         * @param {string} [contractId] 
         * @param {SortDirection} [sortBy] 
         * @param {boolean} [isFinal] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFinancialReportsGet(contractId?: string, sortBy?: SortDirection, isFinal?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfFinancialReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFinancialReportsGet(contractId, sortBy, isFinal, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFinancialReportApi.adminFinancialReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFinancialReportApi - factory interface
 */
export const AdminFinancialReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFinancialReportApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Generate a financial report for an event
         * @param {AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsEventsEventIdPost(requestParameters: AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminFinancialReportsEventsEventIdPost(requestParameters.eventId, requestParameters.generateFinancialReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get financial reports
         * @param {AdminFinancialReportApiAdminFinancialReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsGet(requestParameters: AdminFinancialReportApiAdminFinancialReportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfFinancialReportResponse> {
            return localVarFp.adminFinancialReportsGet(requestParameters.contractId, requestParameters.sortBy, requestParameters.isFinal, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminFinancialReportsEventsEventIdPost operation in AdminFinancialReportApi.
 */
export interface AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest {
    readonly eventId: string

    readonly generateFinancialReportRequest: GenerateFinancialReportRequest
}

/**
 * Request parameters for adminFinancialReportsGet operation in AdminFinancialReportApi.
 */
export interface AdminFinancialReportApiAdminFinancialReportsGetRequest {
    readonly contractId?: string

    readonly sortBy?: SortDirection

    readonly isFinal?: boolean

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * AdminFinancialReportApi - object-oriented interface
 */
export class AdminFinancialReportApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Generate a financial report for an event
     * @param {AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFinancialReportsEventsEventIdPost(requestParameters: AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminFinancialReportApiFp(this.configuration).adminFinancialReportsEventsEventIdPost(requestParameters.eventId, requestParameters.generateFinancialReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get financial reports
     * @param {AdminFinancialReportApiAdminFinancialReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFinancialReportsGet(requestParameters: AdminFinancialReportApiAdminFinancialReportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminFinancialReportApiFp(this.configuration).adminFinancialReportsGet(requestParameters.contractId, requestParameters.sortBy, requestParameters.isFinal, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminGlobalShippingConfigsApi - axios parameter creator
 */
export const AdminGlobalShippingConfigsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] get a global shipping config
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigEntityIdGet: async (entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminGlobalshippingconfigEntityIdGet', 'entityId', entityId)
            const localVarPath = `/admin/globalshippingconfig/{entityId}`
                .replace('{entityId}', encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get global shipping configs and filter by name
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigGet: async (searchTerm?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [ShippingAdmin] update a global shipping config
         * @param {UpdateGlobalShippingConfigRequest} updateGlobalShippingConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPatch: async (updateGlobalShippingConfigRequest: UpdateGlobalShippingConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGlobalShippingConfigRequest' is not null or undefined
            assertParamExists('adminGlobalshippingconfigPatch', 'updateGlobalShippingConfigRequest', updateGlobalShippingConfigRequest)
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlobalShippingConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [ShippingAdmin] create a global shipping config
         * @param {CreateGlobalShippingConfigRequest} createGlobalShippingConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPost: async (createGlobalShippingConfigRequest: CreateGlobalShippingConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGlobalShippingConfigRequest' is not null or undefined
            assertParamExists('adminGlobalshippingconfigPost', 'createGlobalShippingConfigRequest', createGlobalShippingConfigRequest)
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGlobalShippingConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminGlobalShippingConfigsApi - functional programming interface
 */
export const AdminGlobalShippingConfigsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminGlobalShippingConfigsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] get a global shipping config
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGlobalshippingconfigEntityIdGet(entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGlobalShippingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGlobalshippingconfigEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminGlobalShippingConfigsApi.adminGlobalshippingconfigEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get global shipping configs and filter by name
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGlobalshippingconfigGet(searchTerm?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminGlobalShippingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGlobalshippingconfigGet(searchTerm, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminGlobalShippingConfigsApi.adminGlobalshippingconfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [ShippingAdmin] update a global shipping config
         * @param {UpdateGlobalShippingConfigRequest} updateGlobalShippingConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGlobalshippingconfigPatch(updateGlobalShippingConfigRequest: UpdateGlobalShippingConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGlobalShippingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGlobalshippingconfigPatch(updateGlobalShippingConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminGlobalShippingConfigsApi.adminGlobalshippingconfigPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [ShippingAdmin] create a global shipping config
         * @param {CreateGlobalShippingConfigRequest} createGlobalShippingConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGlobalshippingconfigPost(createGlobalShippingConfigRequest: CreateGlobalShippingConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGlobalShippingConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGlobalshippingconfigPost(createGlobalShippingConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminGlobalShippingConfigsApi.adminGlobalshippingconfigPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminGlobalShippingConfigsApi - factory interface
 */
export const AdminGlobalShippingConfigsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminGlobalShippingConfigsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] get a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigEntityIdGet(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGlobalShippingConfigDto> {
            return localVarFp.adminGlobalshippingconfigEntityIdGet(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get global shipping configs and filter by name
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigGet(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminGlobalShippingConfigDto> {
            return localVarFp.adminGlobalshippingconfigGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [ShippingAdmin] update a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPatch(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGlobalShippingConfigDto> {
            return localVarFp.adminGlobalshippingconfigPatch(requestParameters.updateGlobalShippingConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [ShippingAdmin] create a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPost(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGlobalShippingConfigDto> {
            return localVarFp.adminGlobalshippingconfigPost(requestParameters.createGlobalShippingConfigRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminGlobalshippingconfigEntityIdGet operation in AdminGlobalShippingConfigsApi.
 */
export interface AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest {
    /**
     * 
     */
    readonly entityId: string
}

/**
 * Request parameters for adminGlobalshippingconfigGet operation in AdminGlobalShippingConfigsApi.
 */
export interface AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminGlobalshippingconfigPatch operation in AdminGlobalShippingConfigsApi.
 */
export interface AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest {
    /**
     * 
     */
    readonly updateGlobalShippingConfigRequest: UpdateGlobalShippingConfigRequest
}

/**
 * Request parameters for adminGlobalshippingconfigPost operation in AdminGlobalShippingConfigsApi.
 */
export interface AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest {
    /**
     * 
     */
    readonly createGlobalShippingConfigRequest: CreateGlobalShippingConfigRequest
}

/**
 * AdminGlobalShippingConfigsApi - object-oriented interface
 */
export class AdminGlobalShippingConfigsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] get a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminGlobalshippingconfigEntityIdGet(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigEntityIdGet(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get global shipping configs and filter by name
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminGlobalshippingconfigGet(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [ShippingAdmin] update a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminGlobalshippingconfigPatch(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigPatch(requestParameters.updateGlobalShippingConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [ShippingAdmin] create a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminGlobalshippingconfigPost(requestParameters: AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest, options?: RawAxiosRequestConfig) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigPost(requestParameters.createGlobalShippingConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLegalOrganisationApi - axios parameter creator
 */
export const AdminLegalOrganisationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/legalorganisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Delete a legal organisation by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminLegalorganisationsIdDelete', 'id', id)
            const localVarPath = `/admin/legalorganisations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get a legal organisation by id
         * @param {string} id ID of the legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminLegalorganisationsIdGet', 'id', id)
            const localVarPath = `/admin/legalorganisations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update a legal organisation
         * @param {string} legalOrganisationId 
         * @param {UpdateLegalOrgnisationRequestDto} updateLegalOrgnisationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsLegalOrganisationIdPatch: async (legalOrganisationId: string, updateLegalOrgnisationRequestDto: UpdateLegalOrgnisationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legalOrganisationId' is not null or undefined
            assertParamExists('adminLegalorganisationsLegalOrganisationIdPatch', 'legalOrganisationId', legalOrganisationId)
            // verify required parameter 'updateLegalOrgnisationRequestDto' is not null or undefined
            assertParamExists('adminLegalorganisationsLegalOrganisationIdPatch', 'updateLegalOrgnisationRequestDto', updateLegalOrgnisationRequestDto)
            const localVarPath = `/admin/legalorganisations/{legalOrganisationId}`
                .replace('{legalOrganisationId}', encodeURIComponent(String(legalOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLegalOrgnisationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsListGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/legalorganisations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create a legal organisation
         * @param {CreateLegalOrganisationRequestDto} createLegalOrganisationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsPost: async (createLegalOrganisationRequestDto: CreateLegalOrganisationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLegalOrganisationRequestDto' is not null or undefined
            assertParamExists('adminLegalorganisationsPost', 'createLegalOrganisationRequestDto', createLegalOrganisationRequestDto)
            const localVarPath = `/admin/legalorganisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLegalOrganisationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLegalOrganisationApi - functional programming interface
 */
export const AdminLegalOrganisationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLegalOrganisationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminLegalOrganisationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Delete a legal organisation by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get a legal organisation by id
         * @param {string} id ID of the legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLegalOrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update a legal organisation
         * @param {string} legalOrganisationId 
         * @param {UpdateLegalOrgnisationRequestDto} updateLegalOrgnisationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsLegalOrganisationIdPatch(legalOrganisationId: string, updateLegalOrgnisationRequestDto: UpdateLegalOrgnisationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLegalOrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsLegalOrganisationIdPatch(legalOrganisationId, updateLegalOrgnisationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsLegalOrganisationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsListGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminLegalOrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsListGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create a legal organisation
         * @param {CreateLegalOrganisationRequestDto} createLegalOrganisationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLegalorganisationsPost(createLegalOrganisationRequestDto: CreateLegalOrganisationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLegalOrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLegalorganisationsPost(createLegalOrganisationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLegalOrganisationApi.adminLegalorganisationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLegalOrganisationApi - factory interface
 */
export const AdminLegalOrganisationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLegalOrganisationApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminLegalOrganisationDto>> {
            return localVarFp.adminLegalorganisationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Delete a legal organisation by Id
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdDelete(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminLegalorganisationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get a legal organisation by id
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdGet(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLegalOrganisationDto> {
            return localVarFp.adminLegalorganisationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update a legal organisation
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsLegalOrganisationIdPatch(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLegalOrganisationDto> {
            return localVarFp.adminLegalorganisationsLegalOrganisationIdPatch(requestParameters.legalOrganisationId, requestParameters.updateLegalOrgnisationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsListGet(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminLegalOrganisationDto> {
            return localVarFp.adminLegalorganisationsListGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create a legal organisation
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsPost(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminLegalOrganisationDto> {
            return localVarFp.adminLegalorganisationsPost(requestParameters.createLegalOrganisationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminLegalorganisationsIdDelete operation in AdminLegalOrganisationApi.
 */
export interface AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminLegalorganisationsIdGet operation in AdminLegalOrganisationApi.
 */
export interface AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest {
    /**
     * ID of the legal organisation
     */
    readonly id: string
}

/**
 * Request parameters for adminLegalorganisationsLegalOrganisationIdPatch operation in AdminLegalOrganisationApi.
 */
export interface AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest {
    /**
     * 
     */
    readonly legalOrganisationId: string

    /**
     * 
     */
    readonly updateLegalOrgnisationRequestDto: UpdateLegalOrgnisationRequestDto
}

/**
 * Request parameters for adminLegalorganisationsListGet operation in AdminLegalOrganisationApi.
 */
export interface AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminLegalorganisationsPost operation in AdminLegalOrganisationApi.
 */
export interface AdminLegalOrganisationApiAdminLegalorganisationsPostRequest {
    /**
     * 
     */
    readonly createLegalOrganisationRequestDto: CreateLegalOrganisationRequestDto
}

/**
 * AdminLegalOrganisationApi - object-oriented interface
 */
export class AdminLegalOrganisationApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] get all legal organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsGet(options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Delete a legal organisation by Id
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsIdDelete(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get a legal organisation by id
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsIdGet(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update a legal organisation
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsLegalOrganisationIdPatch(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsLegalOrganisationIdPatch(requestParameters.legalOrganisationId, requestParameters.updateLegalOrgnisationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets a paginated list of legal organisations with the searched name
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsListGet(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsListGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create a legal organisation
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLegalorganisationsPost(requestParameters: AdminLegalOrganisationApiAdminLegalorganisationsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsPost(requestParameters.createLegalOrganisationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminNotesApi - axios parameter creator
 */
export const AdminNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] get notes for an entity
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesGet: async (entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminEntitiesEntityIdNotesGet', 'entityId', entityId)
            const localVarPath = `/admin/entities/{entityId}/notes`
                .replace('{entityId}', encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] create a note for an entity with id entityId
         * @param {string} entityId 
         * @param {CreateNoteRequest} createNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesPost: async (entityId: string, createNoteRequest: CreateNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminEntitiesEntityIdNotesPost', 'entityId', entityId)
            // verify required parameter 'createNoteRequest' is not null or undefined
            assertParamExists('adminEntitiesEntityIdNotesPost', 'createNoteRequest', createNoteRequest)
            const localVarPath = `/admin/entities/{entityId}/notes`
                .replace('{entityId}', encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] delete a note by noteId
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdDelete: async (noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('adminNotesNoteIdDelete', 'noteId', noteId)
            const localVarPath = `/admin/notes/{noteId}`
                .replace('{noteId}', encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] update a note by noteId
         * @param {string} noteId 
         * @param {UpdateNoteRequest} updateNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdPatch: async (noteId: string, updateNoteRequest: UpdateNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('adminNotesNoteIdPatch', 'noteId', noteId)
            // verify required parameter 'updateNoteRequest' is not null or undefined
            assertParamExists('adminNotesNoteIdPatch', 'updateNoteRequest', updateNoteRequest)
            const localVarPath = `/admin/notes/{noteId}`
                .replace('{noteId}', encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotesApi - functional programming interface
 */
export const AdminNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] get notes for an entity
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEntitiesEntityIdNotesGet(entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEntitiesEntityIdNotesGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotesApi.adminEntitiesEntityIdNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] create a note for an entity with id entityId
         * @param {string} entityId 
         * @param {CreateNoteRequest} createNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEntitiesEntityIdNotesPost(entityId: string, createNoteRequest: CreateNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEntitiesEntityIdNotesPost(entityId, createNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotesApi.adminEntitiesEntityIdNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] delete a note by noteId
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotesNoteIdDelete(noteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotesNoteIdDelete(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotesApi.adminNotesNoteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] update a note by noteId
         * @param {string} noteId 
         * @param {UpdateNoteRequest} updateNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotesNoteIdPatch(noteId: string, updateNoteRequest: UpdateNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotesNoteIdPatch(noteId, updateNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotesApi.adminNotesNoteIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNotesApi - factory interface
 */
export const AdminNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] get notes for an entity
         * @param {AdminNotesApiAdminEntitiesEntityIdNotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesGet(requestParameters: AdminNotesApiAdminEntitiesEntityIdNotesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NoteDto>> {
            return localVarFp.adminEntitiesEntityIdNotesGet(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] create a note for an entity with id entityId
         * @param {AdminNotesApiAdminEntitiesEntityIdNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesPost(requestParameters: AdminNotesApiAdminEntitiesEntityIdNotesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoteDto> {
            return localVarFp.adminEntitiesEntityIdNotesPost(requestParameters.entityId, requestParameters.createNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] delete a note by noteId
         * @param {AdminNotesApiAdminNotesNoteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdDelete(requestParameters: AdminNotesApiAdminNotesNoteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminNotesNoteIdDelete(requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] update a note by noteId
         * @param {AdminNotesApiAdminNotesNoteIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdPatch(requestParameters: AdminNotesApiAdminNotesNoteIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoteDto> {
            return localVarFp.adminNotesNoteIdPatch(requestParameters.noteId, requestParameters.updateNoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEntitiesEntityIdNotesGet operation in AdminNotesApi.
 */
export interface AdminNotesApiAdminEntitiesEntityIdNotesGetRequest {
    /**
     * 
     */
    readonly entityId: string
}

/**
 * Request parameters for adminEntitiesEntityIdNotesPost operation in AdminNotesApi.
 */
export interface AdminNotesApiAdminEntitiesEntityIdNotesPostRequest {
    /**
     * 
     */
    readonly entityId: string

    /**
     * 
     */
    readonly createNoteRequest: CreateNoteRequest
}

/**
 * Request parameters for adminNotesNoteIdDelete operation in AdminNotesApi.
 */
export interface AdminNotesApiAdminNotesNoteIdDeleteRequest {
    /**
     * 
     */
    readonly noteId: string
}

/**
 * Request parameters for adminNotesNoteIdPatch operation in AdminNotesApi.
 */
export interface AdminNotesApiAdminNotesNoteIdPatchRequest {
    /**
     * 
     */
    readonly noteId: string

    /**
     * 
     */
    readonly updateNoteRequest: UpdateNoteRequest
}

/**
 * AdminNotesApi - object-oriented interface
 */
export class AdminNotesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] get notes for an entity
     * @param {AdminNotesApiAdminEntitiesEntityIdNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEntitiesEntityIdNotesGet(requestParameters: AdminNotesApiAdminEntitiesEntityIdNotesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminNotesApiFp(this.configuration).adminEntitiesEntityIdNotesGet(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] create a note for an entity with id entityId
     * @param {AdminNotesApiAdminEntitiesEntityIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEntitiesEntityIdNotesPost(requestParameters: AdminNotesApiAdminEntitiesEntityIdNotesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminNotesApiFp(this.configuration).adminEntitiesEntityIdNotesPost(requestParameters.entityId, requestParameters.createNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] delete a note by noteId
     * @param {AdminNotesApiAdminNotesNoteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminNotesNoteIdDelete(requestParameters: AdminNotesApiAdminNotesNoteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminNotesApiFp(this.configuration).adminNotesNoteIdDelete(requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] update a note by noteId
     * @param {AdminNotesApiAdminNotesNoteIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminNotesNoteIdPatch(requestParameters: AdminNotesApiAdminNotesNoteIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminNotesApiFp(this.configuration).adminNotesNoteIdPatch(requestParameters.noteId, requestParameters.updateNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrderDocumentsApi - axios parameter creator
 */
export const AdminOrderDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] get an order document including its invoice items by id
         * @param {string} documentId the id of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdGet: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderDocumentsDocumentIdGet', 'documentId', documentId)
            const localVarPath = `/admin/order-documents/{documentId}`
                .replace('{documentId}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get the url of an order document pdf
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdPdfGet: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderDocumentsDocumentIdPdfGet', 'documentId', documentId)
            const localVarPath = `/admin/order-documents/{documentId}/pdf`
                .replace('{documentId}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] List invoice documents of an event
         * @param {string} eventId 
         * @param {string} [searchTerm] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdGet: async (eventId: string, searchTerm?: string, pageSize?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/admin/order-documents/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdRecalculationPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdRecalculationPost', 'eventId', eventId)
            const localVarPath = `/admin/order-documents/events/{eventId}/recalculation`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdZipGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdZipGet', 'eventId', eventId)
            const localVarPath = `/admin/order-documents/events/{eventId}/zip`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Search order documents.
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/order-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get paginated order documents of an user.
         * @param {string} userId The id of the user
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsUsersUserIdGet: async (userId: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminOrderDocumentsUsersUserIdGet', 'userId', userId)
            const localVarPath = `/admin/order-documents/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrderDocumentsApi - functional programming interface
 */
export const AdminOrderDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrderDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] get an order document including its invoice items by id
         * @param {string} documentId the id of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsDocumentIdGet(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsDocumentIdGet(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsDocumentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get the url of an order document pdf
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsDocumentIdPdfGet(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsDocumentIdPdfGet(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsDocumentIdPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] List invoice documents of an event
         * @param {string} eventId 
         * @param {string} [searchTerm] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsEventsEventIdGet(eventId: string, searchTerm?: string, pageSize?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdGet(eventId, searchTerm, pageSize, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsEventsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsEventsEventIdRecalculationPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoContentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdRecalculationPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsEventsEventIdRecalculationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsEventsEventIdZipGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdZipGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsEventsEventIdZipGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Search order documents.
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get paginated order documents of an user.
         * @param {string} userId The id of the user
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderDocumentsUsersUserIdGet(userId: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderDocumentsUsersUserIdGet(userId, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderDocumentsApi.adminOrderDocumentsUsersUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrderDocumentsApi - factory interface
 */
export const AdminOrderDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrderDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] get an order document including its invoice items by id
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDocumentDto> {
            return localVarFp.adminOrderDocumentsDocumentIdGet(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get the url of an order document pdf
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdPdfGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminOrderDocumentsDocumentIdPdfGet(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] List invoice documents of an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDocumentDto> {
            return localVarFp.adminOrderDocumentsEventsEventIdGet(requestParameters.eventId, requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoContentResult> {
            return localVarFp.adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdZipGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminOrderDocumentsEventsEventIdZipGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Search order documents.
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDocumentDto> {
            return localVarFp.adminOrderDocumentsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get paginated order documents of an user.
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsUsersUserIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDocumentDto> {
            return localVarFp.adminOrderDocumentsUsersUserIdGet(requestParameters.userId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminOrderDocumentsDocumentIdGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest {
    /**
     * the id of the invoice
     */
    readonly documentId: string
}

/**
 * Request parameters for adminOrderDocumentsDocumentIdPdfGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest {
    /**
     * 
     */
    readonly documentId: string
}

/**
 * Request parameters for adminOrderDocumentsEventsEventIdGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest {
    readonly eventId: string

    readonly searchTerm?: string

    readonly pageSize?: number

    readonly offset?: number
}

/**
 * Request parameters for adminOrderDocumentsEventsEventIdRecalculationPost operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for adminOrderDocumentsEventsEventIdZipGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest {
    readonly eventId: string
}

/**
 * Request parameters for adminOrderDocumentsGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminOrderDocumentsUsersUserIdGet operation in AdminOrderDocumentsApi.
 */
export interface AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest {
    /**
     * The id of the user
     */
    readonly userId: string

    /**
     * Offset
     */
    readonly offSet?: number

    /**
     * Page size
     */
    readonly pageSize?: number
}

/**
 * AdminOrderDocumentsApi - object-oriented interface
 */
export class AdminOrderDocumentsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] get an order document including its invoice items by id
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsDocumentIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsDocumentIdGet(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get the url of an order document pdf
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsDocumentIdPdfGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsDocumentIdPdfGet(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] List invoice documents of an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsEventsEventIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdGet(requestParameters.eventId, requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Recalculate invoice documents for an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Download a zip file containing all the customer invoices for an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsEventsEventIdZipGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdZipGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Search order documents.
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get paginated order documents of an user.
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrderDocumentsUsersUserIdGet(requestParameters: AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsUsersUserIdGet(requestParameters.userId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrderRefundsApi - axios parameter creator
 */
export const AdminOrderRefundsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [percentage] 
         * @param {RefundType} [refundType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundCalculateGet: async (orderId: string, percentage?: number, refundType?: RefundType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdRefundCalculateGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/refund/calculate`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (percentage !== undefined) {
                localVarQueryParameter['percentage'] = percentage;
            }

            if (refundType !== undefined) {
                localVarQueryParameter['refundType'] = refundType;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {RefundRequest} refundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundPost: async (orderId: string, refundRequest: RefundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdRefundPost', 'orderId', orderId)
            // verify required parameter 'refundRequest' is not null or undefined
            assertParamExists('adminOrdersOrderIdRefundPost', 'refundRequest', refundRequest)
            const localVarPath = `/admin/orders/{orderId}/refund`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrderRefundsApi - functional programming interface
 */
export const AdminOrderRefundsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrderRefundsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orderId 
         * @param {number} [percentage] 
         * @param {RefundType} [refundType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdRefundCalculateGet(orderId: string, percentage?: number, refundType?: RefundType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdRefundCalculateGet(orderId, percentage, refundType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderRefundsApi.adminOrdersOrderIdRefundCalculateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {RefundRequest} refundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdRefundPost(orderId: string, refundRequest: RefundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdRefundPost(orderId, refundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderRefundsApi.adminOrdersOrderIdRefundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrderRefundsApi - factory interface
 */
export const AdminOrderRefundsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrderRefundsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundCalculateGet(requestParameters: AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundCalculationResponse> {
            return localVarFp.adminOrdersOrderIdRefundCalculateGet(requestParameters.orderId, requestParameters.percentage, requestParameters.refundType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundPost(requestParameters: AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrdersOrderIdRefundPost(requestParameters.orderId, requestParameters.refundRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminOrdersOrderIdRefundCalculateGet operation in AdminOrderRefundsApi.
 */
export interface AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest {
    readonly orderId: string

    readonly percentage?: number

    readonly refundType?: RefundType
}

/**
 * Request parameters for adminOrdersOrderIdRefundPost operation in AdminOrderRefundsApi.
 */
export interface AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest {
    readonly orderId: string

    readonly refundRequest: RefundRequest
}

/**
 * AdminOrderRefundsApi - object-oriented interface
 */
export class AdminOrderRefundsApi extends BaseAPI {
    /**
     * 
     * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdRefundCalculateGet(requestParameters: AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderRefundsApiFp(this.configuration).adminOrdersOrderIdRefundCalculateGet(requestParameters.orderId, requestParameters.percentage, requestParameters.refundType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdRefundPost(requestParameters: AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderRefundsApiFp(this.configuration).adminOrdersOrderIdRefundPost(requestParameters.orderId, requestParameters.refundRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrdersApi - axios parameter creator
 */
export const AdminOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} parcelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersBundledParcelIdGet: async (parcelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parcelId' is not null or undefined
            assertParamExists('adminOrdersBundledParcelIdGet', 'parcelId', parcelId)
            const localVarPath = `/admin/orders/bundled/{parcelId}`
                .replace('{parcelId}', encodeURIComponent(String(parcelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] list framing orders
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersFramingGet: async (pageSize?: number, offset?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/orders/framing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {OrdersFilterType} [ordersFilter] all, frames, products &#x3D;&amp;gt; use one of them to get the specific filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet: async (xPlatformKey: string, eventId?: string, offset?: number, pageSize?: number, ordersFilter?: OrdersFilterType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (ordersFilter !== undefined) {
                localVarQueryParameter['ordersFilter'] = ordersFilter;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update the shipping address of an order.
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateOrderAddressRequest} updateOrderAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdAddressShippingPatch: async (orderId: string, xPlatformKey: string, updateOrderAddressRequest: UpdateOrderAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdAddressShippingPatch', 'orderId', orderId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdAddressShippingPatch', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'updateOrderAddressRequest' is not null or undefined
            assertParamExists('adminOrdersOrderIdAddressShippingPatch', 'updateOrderAddressRequest', updateOrderAddressRequest)
            const localVarPath = `/admin/orders/{orderId}/address/shipping`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBlockShipmentPatch: async (orderId: string, body: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdBlockShipmentPatch', 'orderId', orderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminOrdersOrderIdBlockShipmentPatch', 'body', body)
            const localVarPath = `/admin/orders/{orderId}/block-shipment`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBundleableGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdBundleableGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/bundleable`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get a framing order by id
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdFramingGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/framing`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {string} orderId Id of order
         * @param {Date} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingWindowPut: async (orderId: string, body: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdFramingWindowPut', 'orderId', orderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminOrdersOrderIdFramingWindowPut', 'body', body)
            const localVarPath = `/admin/orders/{orderId}/framing-window`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get an order with order items
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicePdfGet: async (orderId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicePdfGet', 'orderId', orderId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicePdfGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/orders/{orderId}/invoice-pdf`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {string} orderId The id of the order
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesGet: async (orderId: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicesGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/invoices`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesPdfPost: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicesPdfPost', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/invoices/pdf`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Ftg order as a sales order in Odoo
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooFtgPost: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdOdooFtgPost', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/odoo/ftg`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create MWS order as a sales order in Odoo
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooMwsPost: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdOdooMwsPost', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/odoo/mws`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update Orders Almost Everything
         * @param {string} orderId 
         * @param {UpdateOrderRequestDto} updateOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPatch: async (orderId: string, updateOrderRequestDto: UpdateOrderRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPatch', 'orderId', orderId)
            // verify required parameter 'updateOrderRequestDto' is not null or undefined
            assertParamExists('adminOrdersOrderIdPatch', 'updateOrderRequestDto', updateOrderRequestDto)
            const localVarPath = `/admin/orders/{orderId}`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {SendPaymentReminderRequestDto} sendPaymentReminderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentReminderPost: async (orderId: string, xPlatformKey: string, sendPaymentReminderRequestDto: SendPaymentReminderRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentReminderPost', 'orderId', orderId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentReminderPost', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'sendPaymentReminderRequestDto' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentReminderPost', 'sendPaymentReminderRequestDto', sendPaymentReminderRequestDto)
            const localVarPath = `/admin/orders/{orderId}/payment-reminder`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPaymentReminderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get payments by order id
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentsGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentsGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/payments`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pick an order.
         * @param {string} orderId 
         * @param {PickOrderRequest} pickOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPicksPut: async (orderId: string, pickOrderRequest: PickOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPicksPut', 'orderId', orderId)
            // verify required parameter 'pickOrderRequest' is not null or undefined
            assertParamExists('adminOrdersOrderIdPicksPut', 'pickOrderRequest', pickOrderRequest)
            const localVarPath = `/admin/orders/{orderId}/picks`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pickOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the shipment details for a shippable order.
         * @param {string} orderId 
         * @param {string} [originCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentDetailsGet: async (orderId: string, originCountryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShipmentDetailsGet', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/shipment-details`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (originCountryCode !== undefined) {
                localVarQueryParameter['originCountryCode'] = originCountryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resets the shipment of an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentResetPatch: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShipmentResetPatch', 'orderId', orderId)
            const localVarPath = `/admin/orders/{orderId}/shipment/reset`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateOrderManualShippedRequest} updateOrderManualShippedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShippedManuallyPatch: async (orderId: string, xPlatformKey: string, updateOrderManualShippedRequest: UpdateOrderManualShippedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShippedManuallyPatch', 'orderId', orderId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdShippedManuallyPatch', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'updateOrderManualShippedRequest' is not null or undefined
            assertParamExists('adminOrdersOrderIdShippedManuallyPatch', 'updateOrderManualShippedRequest', updateOrderManualShippedRequest)
            const localVarPath = `/admin/orders/{orderId}/shipped-manually`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderManualShippedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] search for orders
         * @param {string} [searchTerm] 
         * @param {string} [paymentFilter] 
         * @param {string} [shippingFilter] 
         * @param {string} [country] 
         * @param {string} [eventId] 
         * @param {OrdersFilterType} [ordersFilter] 
         * @param {AuthenticatedByFabricksFilterType} [authenticatedByFabricksFilter] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {string} [sortOption] 
         * @param {string} [sortDirection] 
         * @param {boolean} [filterB2bFramingOrders] 
         * @param {PublicSalesMethod} [salesMethod] 
         * @param {string} [platformId] 
         * @param {string} [shippingOfficeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSearchGet: async (searchTerm?: string, paymentFilter?: string, shippingFilter?: string, country?: string, eventId?: string, ordersFilter?: OrdersFilterType, authenticatedByFabricksFilter?: AuthenticatedByFabricksFilterType, pageSize?: number, offset?: number, sortOption?: string, sortDirection?: string, filterB2bFramingOrders?: boolean, salesMethod?: PublicSalesMethod, platformId?: string, shippingOfficeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/orders/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (paymentFilter !== undefined) {
                localVarQueryParameter['paymentFilter'] = paymentFilter;
            }

            if (shippingFilter !== undefined) {
                localVarQueryParameter['shippingFilter'] = shippingFilter;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }

            if (ordersFilter !== undefined) {
                localVarQueryParameter['ordersFilter'] = ordersFilter;
            }

            if (authenticatedByFabricksFilter !== undefined) {
                localVarQueryParameter['authenticatedByFabricksFilter'] = authenticatedByFabricksFilter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortOption !== undefined) {
                localVarQueryParameter['sortOption'] = sortOption;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (filterB2bFramingOrders !== undefined) {
                localVarQueryParameter['filterB2bFramingOrders'] = filterB2bFramingOrders;
            }

            if (salesMethod !== undefined) {
                localVarQueryParameter['salesMethod'] = salesMethod;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get non-closed orders of a product
         * @param {string} skuId Id of the sku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkuSkuIdGet: async (skuId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminOrdersSkuSkuIdGet', 'skuId', skuId)
            const localVarPath = `/admin/orders/sku/{skuId}`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get report orders by sku ids
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkusPost: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('adminOrdersSkusPost', 'requestBody', requestBody)
            const localVarPath = `/admin/orders/skus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create a new order for a user.
         * @param {string} userId 
         * @param {string} xPlatformKey Select the platform.
         * @param {CreateOrderRequestDto} createOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersUsersUserIdPost: async (userId: string, xPlatformKey: string, createOrderRequestDto: CreateOrderRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminOrdersUsersUserIdPost', 'userId', userId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersUsersUserIdPost', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'createOrderRequestDto' is not null or undefined
            assertParamExists('adminOrdersUsersUserIdPost', 'createOrderRequestDto', createOrderRequestDto)
            const localVarPath = `/admin/orders/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get orders for an user
         * @param {string} userId The id of the user
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdOrdersGet: async (userId: string, xPlatformKey: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdOrdersGet', 'userId', userId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminUsersUserIdOrdersGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/users/{userId}/orders`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrdersApi - functional programming interface
 */
export const AdminOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} parcelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersBundledParcelIdGet(parcelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BundledOrdersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersBundledParcelIdGet(parcelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersBundledParcelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] list framing orders
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersFramingGet(pageSize?: number, offset?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminFramingOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersFramingGet(pageSize, offset, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersFramingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {OrdersFilterType} [ordersFilter] all, frames, products &#x3D;&amp;gt; use one of them to get the specific filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersGet(xPlatformKey: string, eventId?: string, offset?: number, pageSize?: number, ordersFilter?: OrdersFilterType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersGet(xPlatformKey, eventId, offset, pageSize, ordersFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update the shipping address of an order.
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateOrderAddressRequest} updateOrderAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdAddressShippingPatch(orderId: string, xPlatformKey: string, updateOrderAddressRequest: UpdateOrderAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdAddressShippingPatch(orderId, xPlatformKey, updateOrderAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdAddressShippingPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdBlockShipmentPatch(orderId: string, body: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdBlockShipmentPatch(orderId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdBlockShipmentPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdBundleableGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdBundleableGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdBundleableGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get a framing order by id
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdFramingGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFramingOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdFramingGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdFramingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {string} orderId Id of order
         * @param {Date} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdFramingWindowPut(orderId: string, body: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdFramingWindowPut(orderId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdFramingWindowPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get an order with order items
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderWithPlatformNameDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdInvoicePdfGet(orderId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdInvoicePdfGet(orderId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdInvoicePdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {string} orderId The id of the order
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdInvoicesGet(orderId: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdInvoicesGet(orderId, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdInvoicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdInvoicesPdfPost(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdInvoicesPdfPost(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdInvoicesPdfPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Ftg order as a sales order in Odoo
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdOdooFtgPost(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdOdooFtgPost(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdOdooFtgPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create MWS order as a sales order in Odoo
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdOdooMwsPost(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdOdooMwsPost(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdOdooMwsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update Orders Almost Everything
         * @param {string} orderId 
         * @param {UpdateOrderRequestDto} updateOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdPatch(orderId: string, updateOrderRequestDto: UpdateOrderRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdPatch(orderId, updateOrderRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {SendPaymentReminderRequestDto} sendPaymentReminderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdPaymentReminderPost(orderId: string, xPlatformKey: string, sendPaymentReminderRequestDto: SendPaymentReminderRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReminderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdPaymentReminderPost(orderId, xPlatformKey, sendPaymentReminderRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdPaymentReminderPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get payments by order id
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdPaymentsGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdPaymentsGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdPaymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pick an order.
         * @param {string} orderId 
         * @param {PickOrderRequest} pickOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdPicksPut(orderId: string, pickOrderRequest: PickOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdPicksPut(orderId, pickOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdPicksPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the shipment details for a shippable order.
         * @param {string} orderId 
         * @param {string} [originCountryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdShipmentDetailsGet(orderId: string, originCountryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdShipmentDetailsGet(orderId, originCountryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdShipmentDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resets the shipment of an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdShipmentResetPatch(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdShipmentResetPatch(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdShipmentResetPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateOrderManualShippedRequest} updateOrderManualShippedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersOrderIdShippedManuallyPatch(orderId: string, xPlatformKey: string, updateOrderManualShippedRequest: UpdateOrderManualShippedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersOrderIdShippedManuallyPatch(orderId, xPlatformKey, updateOrderManualShippedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersOrderIdShippedManuallyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] search for orders
         * @param {string} [searchTerm] 
         * @param {string} [paymentFilter] 
         * @param {string} [shippingFilter] 
         * @param {string} [country] 
         * @param {string} [eventId] 
         * @param {OrdersFilterType} [ordersFilter] 
         * @param {AuthenticatedByFabricksFilterType} [authenticatedByFabricksFilter] 
         * @param {number} [pageSize] 
         * @param {number} [offset] 
         * @param {string} [sortOption] 
         * @param {string} [sortDirection] 
         * @param {boolean} [filterB2bFramingOrders] 
         * @param {PublicSalesMethod} [salesMethod] 
         * @param {string} [platformId] 
         * @param {string} [shippingOfficeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersSearchGet(searchTerm?: string, paymentFilter?: string, shippingFilter?: string, country?: string, eventId?: string, ordersFilter?: OrdersFilterType, authenticatedByFabricksFilter?: AuthenticatedByFabricksFilterType, pageSize?: number, offset?: number, sortOption?: string, sortDirection?: string, filterB2bFramingOrders?: boolean, salesMethod?: PublicSalesMethod, platformId?: string, shippingOfficeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersSearchGet(searchTerm, paymentFilter, shippingFilter, country, eventId, ordersFilter, authenticatedByFabricksFilter, pageSize, offset, sortOption, sortDirection, filterB2bFramingOrders, salesMethod, platformId, shippingOfficeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get non-closed orders of a product
         * @param {string} skuId Id of the sku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersSkuSkuIdGet(skuId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersSkuSkuIdGet(skuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersSkuSkuIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get report orders by sku ids
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersSkusPost(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersSkusPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersSkusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create a new order for a user.
         * @param {string} userId 
         * @param {string} xPlatformKey Select the platform.
         * @param {CreateOrderRequestDto} createOrderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersUsersUserIdPost(userId: string, xPlatformKey: string, createOrderRequestDto: CreateOrderRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersUsersUserIdPost(userId, xPlatformKey, createOrderRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminOrdersUsersUserIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get orders for an user
         * @param {string} userId The id of the user
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersUserIdOrdersGet(userId: string, xPlatformKey: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersUserIdOrdersGet(userId, xPlatformKey, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrdersApi.adminUsersUserIdOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrdersApi - factory interface
 */
export const AdminOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminOrdersApiAdminOrdersBundledParcelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersBundledParcelIdGet(requestParameters: AdminOrdersApiAdminOrdersBundledParcelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BundledOrdersResponse>> {
            return localVarFp.adminOrdersBundledParcelIdGet(requestParameters.parcelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] list framing orders
         * @param {AdminOrdersApiAdminOrdersFramingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersFramingGet(requestParameters: AdminOrdersApiAdminOrdersFramingGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminFramingOrderDto> {
            return localVarFp.adminOrdersFramingGet(requestParameters.pageSize, requestParameters.offset, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get paginated result of orders
         * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet(requestParameters: AdminOrdersApiAdminOrdersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDto> {
            return localVarFp.adminOrdersGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.ordersFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update the shipping address of an order.
         * @param {AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdAddressShippingPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersOrderIdAddressShippingPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.updateOrderAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBlockShipmentPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrdersOrderIdBlockShipmentPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBundleableGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderDto>> {
            return localVarFp.adminOrdersOrderIdBundleableGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get a framing order by id
         * @param {AdminOrdersApiAdminOrdersOrderIdFramingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdFramingGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminFramingOrderDto> {
            return localVarFp.adminOrdersOrderIdFramingGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingWindowPut(requestParameters: AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersOrderIdFramingWindowPut(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get an order with order items
         * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderWithPlatformNameDto> {
            return localVarFp.adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicePdfGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminOrdersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDocumentDto> {
            return localVarFp.adminOrdersOrderIdInvoicesGet(requestParameters.orderId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesPdfPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminOrdersOrderIdInvoicesPdfPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Ftg order as a sales order in Odoo
         * @param {AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooFtgPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrdersOrderIdOdooFtgPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create MWS order as a sales order in Odoo
         * @param {AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooMwsPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrdersOrderIdOdooMwsPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update Orders Almost Everything
         * @param {AdminOrdersApiAdminOrdersOrderIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersOrderIdPatch(requestParameters.orderId, requestParameters.updateOrderRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentReminderPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentReminderDto> {
            return localVarFp.adminOrdersOrderIdPaymentReminderPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.sendPaymentReminderRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get payments by order id
         * @param {AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentsGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionResponse>> {
            return localVarFp.adminOrdersOrderIdPaymentsGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pick an order.
         * @param {AdminOrdersApiAdminOrdersOrderIdPicksPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPicksPut(requestParameters: AdminOrdersApiAdminOrdersOrderIdPicksPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersOrderIdPicksPut(requestParameters.orderId, requestParameters.pickOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the shipment details for a shippable order.
         * @param {AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentDetailsGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShipmentDetailsResponse> {
            return localVarFp.adminOrdersOrderIdShipmentDetailsGet(requestParameters.orderId, requestParameters.originCountryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resets the shipment of an order
         * @param {AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentResetPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrdersOrderIdShipmentResetPatch(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShippedManuallyPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersOrderIdShippedManuallyPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.updateOrderManualShippedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] search for orders
         * @param {AdminOrdersApiAdminOrdersSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSearchGet(requestParameters: AdminOrdersApiAdminOrdersSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDto> {
            return localVarFp.adminOrdersSearchGet(requestParameters.searchTerm, requestParameters.paymentFilter, requestParameters.shippingFilter, requestParameters.country, requestParameters.eventId, requestParameters.ordersFilter, requestParameters.authenticatedByFabricksFilter, requestParameters.pageSize, requestParameters.offset, requestParameters.sortOption, requestParameters.sortDirection, requestParameters.filterB2bFramingOrders, requestParameters.salesMethod, requestParameters.platformId, requestParameters.shippingOfficeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get non-closed orders of a product
         * @param {AdminOrdersApiAdminOrdersSkuSkuIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkuSkuIdGet(requestParameters: AdminOrdersApiAdminOrdersSkuSkuIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderDto>> {
            return localVarFp.adminOrdersSkuSkuIdGet(requestParameters.skuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get report orders by sku ids
         * @param {AdminOrdersApiAdminOrdersSkusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkusPost(requestParameters: AdminOrdersApiAdminOrdersSkusPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportOrderDto>> {
            return localVarFp.adminOrdersSkusPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create a new order for a user.
         * @param {AdminOrdersApiAdminOrdersUsersUserIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersUsersUserIdPost(requestParameters: AdminOrdersApiAdminOrdersUsersUserIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.adminOrdersUsersUserIdPost(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.createOrderRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get orders for an user
         * @param {AdminOrdersApiAdminUsersUserIdOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdOrdersGet(requestParameters: AdminOrdersApiAdminUsersUserIdOrdersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminOrderDto> {
            return localVarFp.adminUsersUserIdOrdersGet(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminOrdersBundledParcelIdGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersBundledParcelIdGetRequest {
    readonly parcelId: string
}

/**
 * Request parameters for adminOrdersFramingGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersFramingGetRequest {
    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for adminOrdersGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly eventId?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * all, frames, products &#x3D;&amp;gt; use one of them to get the specific filter
     */
    readonly ordersFilter?: OrdersFilterType
}

/**
 * Request parameters for adminOrdersOrderIdAddressShippingPatch operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest {
    /**
     * The id of the order
     */
    readonly orderId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly updateOrderAddressRequest: UpdateOrderAddressRequest
}

/**
 * Request parameters for adminOrdersOrderIdBlockShipmentPatch operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest {
    readonly orderId: string

    readonly body: boolean
}

/**
 * Request parameters for adminOrdersOrderIdBundleableGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdFramingGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdFramingGetRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdFramingWindowPut operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest {
    /**
     * Id of order
     */
    readonly orderId: string

    /**
     * 
     */
    readonly body: Date
}

/**
 * Request parameters for adminOrdersOrderIdGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdGetRequest {
    /**
     * The id of the order
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdInvoicePdfGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for adminOrdersOrderIdInvoicesGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest {
    /**
     * The id of the order
     */
    readonly orderId: string

    /**
     * Offset
     */
    readonly offSet?: number

    /**
     * Page size
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminOrdersOrderIdInvoicesPdfPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdOdooFtgPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdOdooMwsPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdPatch operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdPatchRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * 
     */
    readonly updateOrderRequestDto: UpdateOrderRequestDto
}

/**
 * Request parameters for adminOrdersOrderIdPaymentReminderPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly sendPaymentReminderRequestDto: SendPaymentReminderRequestDto
}

/**
 * Request parameters for adminOrdersOrderIdPaymentsGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdPicksPut operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdPicksPutRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * 
     */
    readonly pickOrderRequest: PickOrderRequest
}

/**
 * Request parameters for adminOrdersOrderIdShipmentDetailsGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * 
     */
    readonly originCountryCode?: string
}

/**
 * Request parameters for adminOrdersOrderIdShipmentResetPatch operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest {
    readonly orderId: string
}

/**
 * Request parameters for adminOrdersOrderIdShippedManuallyPatch operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest {
    /**
     * The id of the order
     */
    readonly orderId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly updateOrderManualShippedRequest: UpdateOrderManualShippedRequest
}

/**
 * Request parameters for adminOrdersSearchGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersSearchGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    readonly paymentFilter?: string

    readonly shippingFilter?: string

    readonly country?: string

    /**
     * 
     */
    readonly eventId?: string

    /**
     * 
     */
    readonly ordersFilter?: OrdersFilterType

    /**
     * 
     */
    readonly authenticatedByFabricksFilter?: AuthenticatedByFabricksFilterType

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly sortOption?: string

    /**
     * 
     */
    readonly sortDirection?: string

    /**
     * 
     */
    readonly filterB2bFramingOrders?: boolean

    /**
     * 
     */
    readonly salesMethod?: PublicSalesMethod

    /**
     * 
     */
    readonly platformId?: string

    readonly shippingOfficeId?: string
}

/**
 * Request parameters for adminOrdersSkuSkuIdGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersSkuSkuIdGetRequest {
    /**
     * Id of the sku
     */
    readonly skuId: string
}

/**
 * Request parameters for adminOrdersSkusPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersSkusPostRequest {
    /**
     * 
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for adminOrdersUsersUserIdPost operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminOrdersUsersUserIdPostRequest {
    /**
     * 
     */
    readonly userId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly createOrderRequestDto: CreateOrderRequestDto
}

/**
 * Request parameters for adminUsersUserIdOrdersGet operation in AdminOrdersApi.
 */
export interface AdminOrdersApiAdminUsersUserIdOrdersGetRequest {
    /**
     * The id of the user
     */
    readonly userId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminOrdersApi - object-oriented interface
 */
export class AdminOrdersApi extends BaseAPI {
    /**
     * 
     * @param {AdminOrdersApiAdminOrdersBundledParcelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersBundledParcelIdGet(requestParameters: AdminOrdersApiAdminOrdersBundledParcelIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersBundledParcelIdGet(requestParameters.parcelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] list framing orders
     * @param {AdminOrdersApiAdminOrdersFramingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersFramingGet(requestParameters: AdminOrdersApiAdminOrdersFramingGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersFramingGet(requestParameters.pageSize, requestParameters.offset, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get paginated result of orders
     * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersGet(requestParameters: AdminOrdersApiAdminOrdersGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.ordersFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update the shipping address of an order.
     * @param {AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdAddressShippingPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdAddressShippingPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.updateOrderAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdBlockShipmentPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdBlockShipmentPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get a list of orders that can be bundled with the given order
     * @param {AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdBundleableGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdBundleableGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get a framing order by id
     * @param {AdminOrdersApiAdminOrdersOrderIdFramingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdFramingGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdFramingGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdFramingGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Change order FramingWindowExpirationDate
     * @param {AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdFramingWindowPut(requestParameters: AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdFramingWindowPut(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get an order with order items
     * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get the pdf url of an order\'s invoice
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdInvoicePdfGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get paginated customer invoices of an order by order id
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdInvoicesGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicesGet(requestParameters.orderId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Regenerate the current invoice for an order
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdInvoicesPdfPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicesPdfPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Ftg order as a sales order in Odoo
     * @param {AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdOdooFtgPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdOdooFtgPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create MWS order as a sales order in Odoo
     * @param {AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdOdooMwsPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdOdooMwsPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update Orders Almost Everything
     * @param {AdminOrdersApiAdminOrdersOrderIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPatch(requestParameters.orderId, requestParameters.updateOrderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] send a payment reminder email for an order to the customer
     * @param {AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdPaymentReminderPost(requestParameters: AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPaymentReminderPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.sendPaymentReminderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get payments by order id
     * @param {AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdPaymentsGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPaymentsGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pick an order.
     * @param {AdminOrdersApiAdminOrdersOrderIdPicksPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdPicksPut(requestParameters: AdminOrdersApiAdminOrdersOrderIdPicksPutRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPicksPut(requestParameters.orderId, requestParameters.pickOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the shipment details for a shippable order.
     * @param {AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdShipmentDetailsGet(requestParameters: AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShipmentDetailsGet(requestParameters.orderId, requestParameters.originCountryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resets the shipment of an order
     * @param {AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdShipmentResetPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShipmentResetPatch(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update Order Manual Shipped Status
     * @param {AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersOrderIdShippedManuallyPatch(requestParameters: AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShippedManuallyPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.updateOrderManualShippedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] search for orders
     * @param {AdminOrdersApiAdminOrdersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersSearchGet(requestParameters: AdminOrdersApiAdminOrdersSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSearchGet(requestParameters.searchTerm, requestParameters.paymentFilter, requestParameters.shippingFilter, requestParameters.country, requestParameters.eventId, requestParameters.ordersFilter, requestParameters.authenticatedByFabricksFilter, requestParameters.pageSize, requestParameters.offset, requestParameters.sortOption, requestParameters.sortDirection, requestParameters.filterB2bFramingOrders, requestParameters.salesMethod, requestParameters.platformId, requestParameters.shippingOfficeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get non-closed orders of a product
     * @param {AdminOrdersApiAdminOrdersSkuSkuIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersSkuSkuIdGet(requestParameters: AdminOrdersApiAdminOrdersSkuSkuIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSkuSkuIdGet(requestParameters.skuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get report orders by sku ids
     * @param {AdminOrdersApiAdminOrdersSkusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersSkusPost(requestParameters: AdminOrdersApiAdminOrdersSkusPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSkusPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create a new order for a user.
     * @param {AdminOrdersApiAdminOrdersUsersUserIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersUsersUserIdPost(requestParameters: AdminOrdersApiAdminOrdersUsersUserIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminOrdersUsersUserIdPost(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.createOrderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get orders for an user
     * @param {AdminOrdersApiAdminUsersUserIdOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminUsersUserIdOrdersGet(requestParameters: AdminOrdersApiAdminUsersUserIdOrdersGetRequest, options?: RawAxiosRequestConfig) {
        return AdminOrdersApiFp(this.configuration).adminUsersUserIdOrdersGet(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminParcelApi - axios parameter creator
 */
export const AdminParcelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelOrderOrderIdGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminParcelOrderOrderIdGet', 'orderId', orderId)
            const localVarPath = `/admin/parcel/order/{orderId}`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update the shipment status of the parcel
         * @param {string} parcelId 
         * @param {UpdateParcelShipmentStatusRequest} updateParcelShipmentStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsParcelIdPatch: async (parcelId: string, updateParcelShipmentStatusRequest: UpdateParcelShipmentStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parcelId' is not null or undefined
            assertParamExists('adminParcelsParcelIdPatch', 'parcelId', parcelId)
            // verify required parameter 'updateParcelShipmentStatusRequest' is not null or undefined
            assertParamExists('adminParcelsParcelIdPatch', 'updateParcelShipmentStatusRequest', updateParcelShipmentStatusRequest)
            const localVarPath = `/admin/parcels/{parcelId}`
                .replace('{parcelId}', encodeURIComponent(String(parcelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateParcelShipmentStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminParcelApi - functional programming interface
 */
export const AdminParcelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminParcelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelOrderOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParcelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelOrderOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelApi.adminParcelOrderOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update the shipment status of the parcel
         * @param {string} parcelId 
         * @param {UpdateParcelShipmentStatusRequest} updateParcelShipmentStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsParcelIdPatch(parcelId: string, updateParcelShipmentStatusRequest: UpdateParcelShipmentStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParcelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsParcelIdPatch(parcelId, updateParcelShipmentStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelApi.adminParcelsParcelIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminParcelApi - factory interface
 */
export const AdminParcelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminParcelApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {AdminParcelApiAdminParcelOrderOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelOrderOrderIdGet(requestParameters: AdminParcelApiAdminParcelOrderOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ParcelDto> {
            return localVarFp.adminParcelOrderOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update the shipment status of the parcel
         * @param {AdminParcelApiAdminParcelsParcelIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsParcelIdPatch(requestParameters: AdminParcelApiAdminParcelsParcelIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ParcelDto> {
            return localVarFp.adminParcelsParcelIdPatch(requestParameters.parcelId, requestParameters.updateParcelShipmentStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminParcelOrderOrderIdGet operation in AdminParcelApi.
 */
export interface AdminParcelApiAdminParcelOrderOrderIdGetRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for adminParcelsParcelIdPatch operation in AdminParcelApi.
 */
export interface AdminParcelApiAdminParcelsParcelIdPatchRequest {
    /**
     * 
     */
    readonly parcelId: string

    /**
     * 
     */
    readonly updateParcelShipmentStatusRequest: UpdateParcelShipmentStatusRequest
}

/**
 * AdminParcelApi - object-oriented interface
 */
export class AdminParcelApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
     * @param {AdminParcelApiAdminParcelOrderOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelOrderOrderIdGet(requestParameters: AdminParcelApiAdminParcelOrderOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelApiFp(this.configuration).adminParcelOrderOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update the shipment status of the parcel
     * @param {AdminParcelApiAdminParcelsParcelIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsParcelIdPatch(requestParameters: AdminParcelApiAdminParcelsParcelIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelApiFp(this.configuration).adminParcelsParcelIdPatch(requestParameters.parcelId, requestParameters.updateParcelShipmentStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminParcelTypesApi - axios parameter creator
 */
export const AdminParcelTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin]  Get a list of all parcel types
         * @param {string} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesGet: async (orderIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/parcels/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderIds !== undefined) {
                localVarQueryParameter['orderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminParcelsTypesIdDelete', 'id', id)
            const localVarPath = `/admin/parcels/types/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin]  Get a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminParcelsTypesIdGet', 'id', id)
            const localVarPath = `/admin/parcels/types/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {string} parcelTypeId The id of the parcel type
         * @param {string} productTypeId The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost: async (parcelTypeId: string, productTypeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parcelTypeId' is not null or undefined
            assertParamExists('adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost', 'parcelTypeId', parcelTypeId)
            // verify required parameter 'productTypeId' is not null or undefined
            assertParamExists('adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost', 'productTypeId', productTypeId)
            const localVarPath = `/admin/parcels/types/{parcelTypeId}/product-types/{productTypeId}`
                .replace('{parcelTypeId}', encodeURIComponent(String(parcelTypeId)))
                .replace('{productTypeId}', encodeURIComponent(String(productTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {CreateParcelTypeRequestDto} createParcelTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesPost: async (createParcelTypeRequestDto: CreateParcelTypeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createParcelTypeRequestDto' is not null or undefined
            assertParamExists('adminParcelsTypesPost', 'createParcelTypeRequestDto', createParcelTypeRequestDto)
            const localVarPath = `/admin/parcels/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createParcelTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesSearchGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/parcels/types/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminParcelTypesApi - functional programming interface
 */
export const AdminParcelTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminParcelTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin]  Get a list of all parcel types
         * @param {string} [orderIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesGet(orderIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParcelTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesGet(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin]  Get a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParcelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {string} parcelTypeId The id of the parcel type
         * @param {string} productTypeId The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(parcelTypeId: string, productTypeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(parcelTypeId, productTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {CreateParcelTypeRequestDto} createParcelTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesPost(createParcelTypeRequestDto: CreateParcelTypeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParcelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesPost(createParcelTypeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminParcelsTypesSearchGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfParcelTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminParcelsTypesSearchGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminParcelTypesApi.adminParcelsTypesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminParcelTypesApi - factory interface
 */
export const AdminParcelTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminParcelTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin]  Get a list of all parcel types
         * @param {AdminParcelTypesApiAdminParcelsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ParcelTypeDto>> {
            return localVarFp.adminParcelsTypesGet(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdDelete(requestParameters: AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminParcelsTypesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin]  Get a parcel type by id
         * @param {AdminParcelTypesApiAdminParcelsTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ParcelTypeDto> {
            return localVarFp.adminParcelsTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters: AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters.parcelTypeId, requestParameters.productTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {AdminParcelTypesApiAdminParcelsTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesPost(requestParameters: AdminParcelTypesApiAdminParcelsTypesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ParcelTypeDto> {
            return localVarFp.adminParcelsTypesPost(requestParameters.createParcelTypeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {AdminParcelTypesApiAdminParcelsTypesSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesSearchGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfParcelTypeDto> {
            return localVarFp.adminParcelsTypesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminParcelsTypesGet operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesGetRequest {
    /**
     * 
     */
    readonly orderIds?: string
}

/**
 * Request parameters for adminParcelsTypesIdDelete operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest {
    /**
     * The id of the parcel type
     */
    readonly id: string
}

/**
 * Request parameters for adminParcelsTypesIdGet operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesIdGetRequest {
    /**
     * The id of the parcel type
     */
    readonly id: string
}

/**
 * Request parameters for adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest {
    /**
     * The id of the parcel type
     */
    readonly parcelTypeId: string

    /**
     * The id of the product type
     */
    readonly productTypeId: string
}

/**
 * Request parameters for adminParcelsTypesPost operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesPostRequest {
    /**
     * 
     */
    readonly createParcelTypeRequestDto: CreateParcelTypeRequestDto
}

/**
 * Request parameters for adminParcelsTypesSearchGet operation in AdminParcelTypesApi.
 */
export interface AdminParcelTypesApiAdminParcelsTypesSearchGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminParcelTypesApi - object-oriented interface
 */
export class AdminParcelTypesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin]  Get a list of all parcel types
     * @param {AdminParcelTypesApiAdminParcelsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesGet(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [ShippingAdmin]  Deletes a parcel type by id
     * @param {AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesIdDelete(requestParameters: AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin]  Get a parcel type by id
     * @param {AdminParcelTypesApiAdminParcelsTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesIdGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [ShippingAdmin] Create a link between a parcel type and a product type
     * @param {AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters: AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters.parcelTypeId, requestParameters.productTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
     * @param {AdminParcelTypesApiAdminParcelsTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesPost(requestParameters: AdminParcelTypesApiAdminParcelsTypesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesPost(requestParameters.createParcelTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
     * @param {AdminParcelTypesApiAdminParcelsTypesSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminParcelsTypesSearchGet(requestParameters: AdminParcelTypesApiAdminParcelsTypesSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPartnerDocumentsApi - axios parameter creator
 */
export const AdminPartnerDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsDocumentIdDelete: async (partnerId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsDocumentIdDelete', 'partnerId', partnerId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/admin/partners/{partnerId}/documents/{documentId}`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)))
                .replace('{documentId}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsGet: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsGet', 'partnerId', partnerId)
            const localVarPath = `/admin/partners/{partnerId}/documents`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {CreatePartnerDocumentRequest} createPartnerDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsPost: async (partnerId: string, createPartnerDocumentRequest: CreatePartnerDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsPost', 'partnerId', partnerId)
            // verify required parameter 'createPartnerDocumentRequest' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsPost', 'createPartnerDocumentRequest', createPartnerDocumentRequest)
            const localVarPath = `/admin/partners/{partnerId}/documents`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPartnerDocumentsApi - functional programming interface
 */
export const AdminPartnerDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPartnerDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdDocumentsDocumentIdDelete(partnerId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsDocumentIdDelete(partnerId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerDocumentsApi.adminPartnersPartnerIdDocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdDocumentsGet(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerDocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsGet(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerDocumentsApi.adminPartnersPartnerIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {CreatePartnerDocumentRequest} createPartnerDocumentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdDocumentsPost(partnerId: string, createPartnerDocumentRequest: CreatePartnerDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsPost(partnerId, createPartnerDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerDocumentsApi.adminPartnersPartnerIdDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPartnerDocumentsApi - factory interface
 */
export const AdminPartnerDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPartnerDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters.partnerId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsGet(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerDocumentDto>> {
            return localVarFp.adminPartnersPartnerIdDocumentsGet(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsPost(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnersPartnerIdDocumentsPost(requestParameters.partnerId, requestParameters.createPartnerDocumentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPartnersPartnerIdDocumentsDocumentIdDelete operation in AdminPartnerDocumentsApi.
 */
export interface AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest {
    readonly partnerId: string

    readonly documentId: string
}

/**
 * Request parameters for adminPartnersPartnerIdDocumentsGet operation in AdminPartnerDocumentsApi.
 */
export interface AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest {
    readonly partnerId: string
}

/**
 * Request parameters for adminPartnersPartnerIdDocumentsPost operation in AdminPartnerDocumentsApi.
 */
export interface AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest {
    readonly partnerId: string

    readonly createPartnerDocumentRequest: CreatePartnerDocumentRequest
}

/**
 * AdminPartnerDocumentsApi - object-oriented interface
 */
export class AdminPartnerDocumentsApi extends BaseAPI {
    /**
     * 
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters.partnerId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdDocumentsGet(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsGet(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdDocumentsPost(requestParameters: AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsPost(requestParameters.partnerId, requestParameters.createPartnerDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPartnerPickupAddressApi - axios parameter creator
 */
export const AdminPartnerPickupAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get partner pick up address by ID
         * @param {number} addressId 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdGet: async (addressId: number, partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdGet', 'addressId', addressId)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdGet', 'partnerId', partnerId)
            const localVarPath = `/admin/partners/{partnerId}/pickup-address/{addressId}`
                .replace('{addressId}', encodeURIComponent(String(addressId)))
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a partner pick up address
         * @param {number} addressId 
         * @param {string} partnerId 
         * @param {UpdatePartnerPickupAddressRequest} updatePartnerPickupAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdPut: async (addressId: number, partnerId: string, updatePartnerPickupAddressRequest: UpdatePartnerPickupAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdPut', 'addressId', addressId)
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdPut', 'partnerId', partnerId)
            // verify required parameter 'updatePartnerPickupAddressRequest' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdPut', 'updatePartnerPickupAddressRequest', updatePartnerPickupAddressRequest)
            const localVarPath = `/admin/partners/{partnerId}/pickup-address/{addressId}`
                .replace('{addressId}', encodeURIComponent(String(addressId)))
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartnerPickupAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all partner pick up addresses
         * @param {string} partnerId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressGet: async (partnerId: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressGet', 'partnerId', partnerId)
            const localVarPath = `/admin/partners/{partnerId}/pickup-address`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a partner pick up address
         * @param {string} partnerId 
         * @param {CreatePartnerPickupAddressRequest} createPartnerPickupAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressPost: async (partnerId: string, createPartnerPickupAddressRequest: CreatePartnerPickupAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressPost', 'partnerId', partnerId)
            // verify required parameter 'createPartnerPickupAddressRequest' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressPost', 'createPartnerPickupAddressRequest', createPartnerPickupAddressRequest)
            const localVarPath = `/admin/partners/{partnerId}/pickup-address`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerPickupAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get partner pickup address states
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPickupAddressStatesGet: async (countryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partners/pickup-address/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPartnerPickupAddressApi - functional programming interface
 */
export const AdminPartnerPickupAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPartnerPickupAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get partner pick up address by ID
         * @param {number} addressId 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdPickupAddressAddressIdGet(addressId: number, partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPickupAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressAddressIdGet(addressId, partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerPickupAddressApi.adminPartnersPartnerIdPickupAddressAddressIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a partner pick up address
         * @param {number} addressId 
         * @param {string} partnerId 
         * @param {UpdatePartnerPickupAddressRequest} updatePartnerPickupAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdPickupAddressAddressIdPut(addressId: number, partnerId: string, updatePartnerPickupAddressRequest: UpdatePartnerPickupAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressAddressIdPut(addressId, partnerId, updatePartnerPickupAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerPickupAddressApi.adminPartnersPartnerIdPickupAddressAddressIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all partner pick up addresses
         * @param {string} partnerId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdPickupAddressGet(partnerId: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPartnerPickupAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressGet(partnerId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerPickupAddressApi.adminPartnersPartnerIdPickupAddressGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a partner pick up address
         * @param {string} partnerId 
         * @param {CreatePartnerPickupAddressRequest} createPartnerPickupAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdPickupAddressPost(partnerId: string, createPartnerPickupAddressRequest: CreatePartnerPickupAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressPost(partnerId, createPartnerPickupAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerPickupAddressApi.adminPartnersPartnerIdPickupAddressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get partner pickup address states
         * @param {string} [countryCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPickupAddressStatesGet(countryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerPickupAddressStateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPickupAddressStatesGet(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnerPickupAddressApi.adminPartnersPickupAddressStatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPartnerPickupAddressApi - factory interface
 */
export const AdminPartnerPickupAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPartnerPickupAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Get partner pick up address by ID
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerPickupAddressResponse> {
            return localVarFp.adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters.addressId, requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a partner pick up address
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters.addressId, requestParameters.partnerId, requestParameters.updatePartnerPickupAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all partner pick up addresses
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPartnerPickupAddressResponse> {
            return localVarFp.adminPartnersPartnerIdPickupAddressGet(requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a partner pick up address
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressPost(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnersPartnerIdPickupAddressPost(requestParameters.partnerId, requestParameters.createPartnerPickupAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get partner pickup address states
         * @param {AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPickupAddressStatesGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerPickupAddressStateResponse>> {
            return localVarFp.adminPartnersPickupAddressStatesGet(requestParameters.countryCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPartnersPartnerIdPickupAddressAddressIdGet operation in AdminPartnerPickupAddressApi.
 */
export interface AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest {
    readonly addressId: number

    readonly partnerId: string
}

/**
 * Request parameters for adminPartnersPartnerIdPickupAddressAddressIdPut operation in AdminPartnerPickupAddressApi.
 */
export interface AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest {
    readonly addressId: number

    readonly partnerId: string

    readonly updatePartnerPickupAddressRequest: UpdatePartnerPickupAddressRequest
}

/**
 * Request parameters for adminPartnersPartnerIdPickupAddressGet operation in AdminPartnerPickupAddressApi.
 */
export interface AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest {
    readonly partnerId: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminPartnersPartnerIdPickupAddressPost operation in AdminPartnerPickupAddressApi.
 */
export interface AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest {
    readonly partnerId: string

    readonly createPartnerPickupAddressRequest: CreatePartnerPickupAddressRequest
}

/**
 * Request parameters for adminPartnersPickupAddressStatesGet operation in AdminPartnerPickupAddressApi.
 */
export interface AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest {
    readonly countryCode?: string
}

/**
 * AdminPartnerPickupAddressApi - object-oriented interface
 */
export class AdminPartnerPickupAddressApi extends BaseAPI {
    /**
     * 
     * @summary Get partner pick up address by ID
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters.addressId, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a partner pick up address
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters.addressId, requestParameters.partnerId, requestParameters.updatePartnerPickupAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all partner pick up addresses
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdPickupAddressGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressGet(requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a partner pick up address
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdPickupAddressPost(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressPost(requestParameters.partnerId, requestParameters.createPartnerPickupAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get partner pickup address states
     * @param {AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPickupAddressStatesGet(requestParameters: AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPickupAddressStatesGet(requestParameters.countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPartnersApi - axios parameter creator
 */
export const AdminPartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersContractsGet: async (contracts?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partners/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contracts !== undefined) {
                localVarQueryParameter['contracts'] = contracts;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {string} [searchTerm] 
         * @param {string} [partnerManagerUserId] 
         * @param {PartnerRegion} [region] 
         * @param {ContractType} [contractType] 
         * @param {boolean} [isActive] 
         * @param {PartnerSortAttribute} [sortBy] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersGet: async (searchTerm?: string, partnerManagerUserId?: string, region?: PartnerRegion, contractType?: ContractType, isActive?: boolean, sortBy?: PartnerSortAttribute, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (partnerManagerUserId !== undefined) {
                localVarQueryParameter['partnerManagerUserId'] = partnerManagerUserId;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (contractType !== undefined) {
                localVarQueryParameter['contractType'] = contractType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Delete a partner
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPartnersIdDelete', 'id', id)
            const localVarPath = `/admin/partners/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get partner with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPartnersIdGet', 'id', id)
            const localVarPath = `/admin/partners/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {string} [partners] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersListGet: async (partners?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partners/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (partners !== undefined) {
                localVarQueryParameter['partners'] = partners;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] create or update customer of partner
         * @param {string} partnerId 
         * @param {CreateOrUpdateCustomerRequest} createOrUpdateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdCustomerPut: async (partnerId: string, createOrUpdateCustomerRequest: CreateOrUpdateCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdCustomerPut', 'partnerId', partnerId)
            // verify required parameter 'createOrUpdateCustomerRequest' is not null or undefined
            assertParamExists('adminPartnersPartnerIdCustomerPut', 'createOrUpdateCustomerRequest', createOrUpdateCustomerRequest)
            const localVarPath = `/admin/partners/{partnerId}/customer`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update the partner
         * @param {string} partnerId 
         * @param {UpdatePartnerRequestDto} updatePartnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPatch: async (partnerId: string, updatePartnerRequestDto: UpdatePartnerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPatch', 'partnerId', partnerId)
            // verify required parameter 'updatePartnerRequestDto' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPatch', 'updatePartnerRequestDto', updatePartnerRequestDto)
            const localVarPath = `/admin/partners/{partnerId}`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartnerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get Vendors Under Partners
         * @param {string} partnerId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeGlobalVendors] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdVendorsGet: async (partnerId: string, offSet?: number, pageSize?: number, includeGlobalVendors?: boolean, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdVendorsGet', 'partnerId', partnerId)
            const localVarPath = `/admin/partners/{partnerId}/vendors`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (includeGlobalVendors !== undefined) {
                localVarQueryParameter['includeGlobalVendors'] = includeGlobalVendors;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create a partner
         * @param {CreatePartnerRequestDto} createPartnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPost: async (createPartnerRequestDto: CreatePartnerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartnerRequestDto' is not null or undefined
            assertParamExists('adminPartnersPost', 'createPartnerRequestDto', createPartnerRequestDto)
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPartnersApi - functional programming interface
 */
export const AdminPartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersContractsGet(contracts?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersContractsGet(contracts, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {string} [searchTerm] 
         * @param {string} [partnerManagerUserId] 
         * @param {PartnerRegion} [region] 
         * @param {ContractType} [contractType] 
         * @param {boolean} [isActive] 
         * @param {PartnerSortAttribute} [sortBy] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersGet(searchTerm?: string, partnerManagerUserId?: string, region?: PartnerRegion, contractType?: ContractType, isActive?: boolean, sortBy?: PartnerSortAttribute, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersGet(searchTerm, partnerManagerUserId, region, contractType, isActive, sortBy, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Delete a partner
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get partner with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {string} [partners] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersListGet(partners?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersListGet(partners, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] create or update customer of partner
         * @param {string} partnerId 
         * @param {CreateOrUpdateCustomerRequest} createOrUpdateCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdCustomerPut(partnerId: string, createOrUpdateCustomerRequest: CreateOrUpdateCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdCustomerPut(partnerId, createOrUpdateCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersPartnerIdCustomerPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update the partner
         * @param {string} partnerId 
         * @param {UpdatePartnerRequestDto} updatePartnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdPatch(partnerId: string, updatePartnerRequestDto: UpdatePartnerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdPatch(partnerId, updatePartnerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersPartnerIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get Vendors Under Partners
         * @param {string} partnerId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeGlobalVendors] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPartnerIdVendorsGet(partnerId: string, offSet?: number, pageSize?: number, includeGlobalVendors?: boolean, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfVendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPartnerIdVendorsGet(partnerId, offSet, pageSize, includeGlobalVendors, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersPartnerIdVendorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create a partner
         * @param {CreatePartnerRequestDto} createPartnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnersPost(createPartnerRequestDto: CreatePartnerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnersPost(createPartnerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPartnersApi.adminPartnersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPartnersApi - factory interface
 */
export const AdminPartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPartnersApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {AdminPartnersApiAdminPartnersContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersContractsGet(requestParameters: AdminPartnersApiAdminPartnersContractsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPartnerDto> {
            return localVarFp.adminPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {AdminPartnersApiAdminPartnersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersGet(requestParameters: AdminPartnersApiAdminPartnersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPartnerDto> {
            return localVarFp.adminPartnersGet(requestParameters.searchTerm, requestParameters.partnerManagerUserId, requestParameters.region, requestParameters.contractType, requestParameters.isActive, requestParameters.sortBy, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Delete a partner
         * @param {AdminPartnersApiAdminPartnersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdDelete(requestParameters: AdminPartnersApiAdminPartnersIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get partner with Id
         * @param {AdminPartnersApiAdminPartnersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdGet(requestParameters: AdminPartnersApiAdminPartnersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.adminPartnersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {AdminPartnersApiAdminPartnersListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersListGet(requestParameters: AdminPartnersApiAdminPartnersListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPartnerDto> {
            return localVarFp.adminPartnersListGet(requestParameters.partners, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] create or update customer of partner
         * @param {AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdCustomerPut(requestParameters: AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.adminPartnersPartnerIdCustomerPut(requestParameters.partnerId, requestParameters.createOrUpdateCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update the partner
         * @param {AdminPartnersApiAdminPartnersPartnerIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPatch(requestParameters: AdminPartnersApiAdminPartnersPartnerIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.adminPartnersPartnerIdPatch(requestParameters.partnerId, requestParameters.updatePartnerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get Vendors Under Partners
         * @param {AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdVendorsGet(requestParameters: AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfVendorDto> {
            return localVarFp.adminPartnersPartnerIdVendorsGet(requestParameters.partnerId, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeGlobalVendors, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create a partner
         * @param {AdminPartnersApiAdminPartnersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPost(requestParameters: AdminPartnersApiAdminPartnersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.adminPartnersPost(requestParameters.createPartnerRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPartnersContractsGet operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersContractsGetRequest {
    /**
     * 
     */
    readonly contracts?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminPartnersGet operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersGetRequest {
    readonly searchTerm?: string

    readonly partnerManagerUserId?: string

    readonly region?: PartnerRegion

    readonly contractType?: ContractType

    readonly isActive?: boolean

    readonly sortBy?: PartnerSortAttribute

    readonly offSet?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminPartnersIdDelete operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersIdDeleteRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminPartnersIdGet operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersIdGetRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminPartnersListGet operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersListGetRequest {
    /**
     * 
     */
    readonly partners?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminPartnersPartnerIdCustomerPut operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest {
    /**
     * 
     */
    readonly partnerId: string

    /**
     * 
     */
    readonly createOrUpdateCustomerRequest: CreateOrUpdateCustomerRequest
}

/**
 * Request parameters for adminPartnersPartnerIdPatch operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersPartnerIdPatchRequest {
    /**
     * 
     */
    readonly partnerId: string

    /**
     * 
     */
    readonly updatePartnerRequestDto: UpdatePartnerRequestDto
}

/**
 * Request parameters for adminPartnersPartnerIdVendorsGet operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest {
    /**
     * 
     */
    readonly partnerId: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly includeGlobalVendors?: boolean

    /**
     * 
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for adminPartnersPost operation in AdminPartnersApi.
 */
export interface AdminPartnersApiAdminPartnersPostRequest {
    /**
     * 
     */
    readonly createPartnerRequestDto: CreatePartnerRequestDto
}

/**
 * AdminPartnersApi - object-oriented interface
 */
export class AdminPartnersApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] getting partners by contracts Ids
     * @param {AdminPartnersApiAdminPartnersContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersContractsGet(requestParameters: AdminPartnersApiAdminPartnersContractsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets a paginated list of partners with the searched name
     * @param {AdminPartnersApiAdminPartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersGet(requestParameters: AdminPartnersApiAdminPartnersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersGet(requestParameters.searchTerm, requestParameters.partnerManagerUserId, requestParameters.region, requestParameters.contractType, requestParameters.isActive, requestParameters.sortBy, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Delete a partner
     * @param {AdminPartnersApiAdminPartnersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersIdDelete(requestParameters: AdminPartnersApiAdminPartnersIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get partner with Id
     * @param {AdminPartnersApiAdminPartnersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersIdGet(requestParameters: AdminPartnersApiAdminPartnersIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets all the partners with the given ids list
     * @param {AdminPartnersApiAdminPartnersListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersListGet(requestParameters: AdminPartnersApiAdminPartnersListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersListGet(requestParameters.partners, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] create or update customer of partner
     * @param {AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdCustomerPut(requestParameters: AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdCustomerPut(requestParameters.partnerId, requestParameters.createOrUpdateCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update the partner
     * @param {AdminPartnersApiAdminPartnersPartnerIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdPatch(requestParameters: AdminPartnersApiAdminPartnersPartnerIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdPatch(requestParameters.partnerId, requestParameters.updatePartnerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get Vendors Under Partners
     * @param {AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPartnerIdVendorsGet(requestParameters: AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdVendorsGet(requestParameters.partnerId, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeGlobalVendors, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create a partner
     * @param {AdminPartnersApiAdminPartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnersPost(requestParameters: AdminPartnersApiAdminPartnersPostRequest, options?: RawAxiosRequestConfig) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPost(requestParameters.createPartnerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPickListsApi - axios parameter creator
 */
export const AdminPickListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} pickListType 
         * @param {string} [shippingOfficeId] 
         * @param {string} [eventId] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [offset] 
         * @param {Date} [paidBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPickListTypeGet: async (pickListType: string, shippingOfficeId?: string, eventId?: string, pageSize?: number | null, offset?: number | null, paidBefore?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickListType' is not null or undefined
            assertParamExists('adminOrdersPickListsPickListTypeGet', 'pickListType', pickListType)
            const localVarPath = `/admin/orders/pick-lists/{pickListType}`
                .replace('{pickListType}', encodeURIComponent(String(pickListType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['EventId'] = eventId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (paidBefore !== undefined) {
                localVarQueryParameter['PaidBefore'] = (paidBefore as any instanceof Date) ?
                    (paidBefore as any).toISOString() :
                    paidBefore;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPickListsApi - functional programming interface
 */
export const AdminPickListsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPickListsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} pickListType 
         * @param {string} [shippingOfficeId] 
         * @param {string} [eventId] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [offset] 
         * @param {Date} [paidBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrdersPickListsPickListTypeGet(pickListType: string, shippingOfficeId?: string, eventId?: string, pageSize?: number | null, offset?: number | null, paidBefore?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPickListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrdersPickListsPickListTypeGet(pickListType, shippingOfficeId, eventId, pageSize, offset, paidBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPickListsApi.adminOrdersPickListsPickListTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPickListsApi - factory interface
 */
export const AdminPickListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPickListsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPickListTypeGet(requestParameters: AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPickListItem> {
            return localVarFp.adminOrdersPickListsPickListTypeGet(requestParameters.pickListType, requestParameters.shippingOfficeId, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.paidBefore, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminOrdersPickListsPickListTypeGet operation in AdminPickListsApi.
 */
export interface AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest {
    readonly pickListType: string

    readonly shippingOfficeId?: string

    readonly eventId?: string

    readonly pageSize?: number | null

    readonly offset?: number | null

    readonly paidBefore?: Date
}

/**
 * AdminPickListsApi - object-oriented interface
 */
export class AdminPickListsApi extends BaseAPI {
    /**
     * 
     * @param {AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOrdersPickListsPickListTypeGet(requestParameters: AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPickListsApiFp(this.configuration).adminOrdersPickListsPickListTypeGet(requestParameters.pickListType, requestParameters.shippingOfficeId, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.paidBefore, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPickupsApi - axios parameter creator
 */
export const AdminPickupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {string} [shippingOfficeId] 
         * @param {boolean} [all] optional boolean argument that if true returns all of the pickups sorted by date descending. Enables pagination
         * @param {number} [offset] optional offset for pagination. Default 0
         * @param {number} [pageSize] optional page size for pagination. Default 25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsGet: async (shippingOfficeId?: string, all?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pickups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] This endpoint deletes a pickup
         * @param {string} id The id of the pickup that needs deleting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pickupsIdDelete', 'id', id)
            const localVarPath = `/pickups/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPickupsApi - functional programming interface
 */
export const AdminPickupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPickupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {string} [shippingOfficeId] 
         * @param {boolean} [all] optional boolean argument that if true returns all of the pickups sorted by date descending. Enables pagination
         * @param {number} [offset] optional offset for pagination. Default 0
         * @param {number} [pageSize] optional page size for pagination. Default 25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickupsGet(shippingOfficeId?: string, all?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPickupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickupsGet(shippingOfficeId, all, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPickupsApi.pickupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] This endpoint deletes a pickup
         * @param {string} id The id of the pickup that needs deleting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickupsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickupsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPickupsApi.pickupsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPickupsApi - factory interface
 */
export const AdminPickupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPickupsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {AdminPickupsApiPickupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsGet(requestParameters: AdminPickupsApiPickupsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPickupDto> {
            return localVarFp.pickupsGet(requestParameters.shippingOfficeId, requestParameters.all, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] This endpoint deletes a pickup
         * @param {AdminPickupsApiPickupsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsIdDelete(requestParameters: AdminPickupsApiPickupsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.pickupsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pickupsGet operation in AdminPickupsApi.
 */
export interface AdminPickupsApiPickupsGetRequest {
    /**
     * 
     */
    readonly shippingOfficeId?: string

    /**
     * optional boolean argument that if true returns all of the pickups sorted by date descending. Enables pagination
     */
    readonly all?: boolean

    /**
     * optional offset for pagination. Default 0
     */
    readonly offset?: number

    /**
     * optional page size for pagination. Default 25
     */
    readonly pageSize?: number
}

/**
 * Request parameters for pickupsIdDelete operation in AdminPickupsApi.
 */
export interface AdminPickupsApiPickupsIdDeleteRequest {
    /**
     * The id of the pickup that needs deleting
     */
    readonly id: string
}

/**
 * AdminPickupsApi - object-oriented interface
 */
export class AdminPickupsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
     * @param {AdminPickupsApiPickupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickupsGet(requestParameters: AdminPickupsApiPickupsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPickupsApiFp(this.configuration).pickupsGet(requestParameters.shippingOfficeId, requestParameters.all, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] This endpoint deletes a pickup
     * @param {AdminPickupsApiPickupsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickupsIdDelete(requestParameters: AdminPickupsApiPickupsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminPickupsApiFp(this.configuration).pickupsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductTypesApi - axios parameter creator
 */
export const AdminProductTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesConditionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/types/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get all product types
         * @param {string} [includedProductTypeId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesGet: async (includedProductTypeId?: string, offset?: number, pageSize?: number, includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includedProductTypeId !== undefined) {
                localVarQueryParameter['includedProductTypeId'] = includedProductTypeId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin]  Get a product type by id
         * @param {string} id The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminProductsTypesIdGet', 'id', id)
            const localVarPath = `/admin/products/types/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin and ProductManager] Update a product type
         * @param {UpdateProductTypeRequest} updateProductTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPatch: async (updateProductTypeRequest: UpdateProductTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProductTypeRequest' is not null or undefined
            assertParamExists('adminProductsTypesPatch', 'updateProductTypeRequest', updateProductTypeRequest)
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin and ProductManager] Create a product type
         * @param {CreateProductTypeRequest} createProductTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPost: async (createProductTypeRequest: CreateProductTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductTypeRequest' is not null or undefined
            assertParamExists('adminProductsTypesPost', 'createProductTypeRequest', createProductTypeRequest)
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductTypesApi - functional programming interface
 */
export const AdminProductTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsTypesConditionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsTypesConditionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductTypesApi.adminProductsTypesConditionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get all product types
         * @param {string} [includedProductTypeId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsTypesGet(includedProductTypeId?: string, offset?: number, pageSize?: number, includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfProductTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsTypesGet(includedProductTypeId, offset, pageSize, includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductTypesApi.adminProductsTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin]  Get a product type by id
         * @param {string} id The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsTypesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductTypesApi.adminProductsTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin and ProductManager] Update a product type
         * @param {UpdateProductTypeRequest} updateProductTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsTypesPatch(updateProductTypeRequest: UpdateProductTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsTypesPatch(updateProductTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductTypesApi.adminProductsTypesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin and ProductManager] Create a product type
         * @param {CreateProductTypeRequest} createProductTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsTypesPost(createProductTypeRequest: CreateProductTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsTypesPost(createProductTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductTypesApi.adminProductsTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductTypesApi - factory interface
 */
export const AdminProductTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesConditionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.adminProductsTypesConditionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get all product types
         * @param {AdminProductTypesApiAdminProductsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesGet(requestParameters: AdminProductTypesApiAdminProductsTypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfProductTypeDto> {
            return localVarFp.adminProductsTypesGet(requestParameters.includedProductTypeId, requestParameters.offset, requestParameters.pageSize, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin]  Get a product type by id
         * @param {AdminProductTypesApiAdminProductsTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesIdGet(requestParameters: AdminProductTypesApiAdminProductsTypesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductTypeDto> {
            return localVarFp.adminProductsTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin and ProductManager] Update a product type
         * @param {AdminProductTypesApiAdminProductsTypesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPatch(requestParameters: AdminProductTypesApiAdminProductsTypesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductTypeDto> {
            return localVarFp.adminProductsTypesPatch(requestParameters.updateProductTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin and ProductManager] Create a product type
         * @param {AdminProductTypesApiAdminProductsTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPost(requestParameters: AdminProductTypesApiAdminProductsTypesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductTypeDto> {
            return localVarFp.adminProductsTypesPost(requestParameters.createProductTypeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminProductsTypesGet operation in AdminProductTypesApi.
 */
export interface AdminProductTypesApiAdminProductsTypesGetRequest {
    /**
     * 
     */
    readonly includedProductTypeId?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly includeInactive?: boolean
}

/**
 * Request parameters for adminProductsTypesIdGet operation in AdminProductTypesApi.
 */
export interface AdminProductTypesApiAdminProductsTypesIdGetRequest {
    /**
     * The id of the product type
     */
    readonly id: string
}

/**
 * Request parameters for adminProductsTypesPatch operation in AdminProductTypesApi.
 */
export interface AdminProductTypesApiAdminProductsTypesPatchRequest {
    /**
     * 
     */
    readonly updateProductTypeRequest: UpdateProductTypeRequest
}

/**
 * Request parameters for adminProductsTypesPost operation in AdminProductTypesApi.
 */
export interface AdminProductTypesApiAdminProductsTypesPostRequest {
    /**
     * 
     */
    readonly createProductTypeRequest: CreateProductTypeRequest
}

/**
 * AdminProductTypesApi - object-oriented interface
 */
export class AdminProductTypesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get all product type conditions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsTypesConditionsGet(options?: RawAxiosRequestConfig) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesConditionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get all product types
     * @param {AdminProductTypesApiAdminProductsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsTypesGet(requestParameters: AdminProductTypesApiAdminProductsTypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesGet(requestParameters.includedProductTypeId, requestParameters.offset, requestParameters.pageSize, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin]  Get a product type by id
     * @param {AdminProductTypesApiAdminProductsTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsTypesIdGet(requestParameters: AdminProductTypesApiAdminProductsTypesIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin and ProductManager] Update a product type
     * @param {AdminProductTypesApiAdminProductsTypesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsTypesPatch(requestParameters: AdminProductTypesApiAdminProductsTypesPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesPatch(requestParameters.updateProductTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin and ProductManager] Create a product type
     * @param {AdminProductTypesApiAdminProductsTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsTypesPost(requestParameters: AdminProductTypesApiAdminProductsTypesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesPost(requestParameters.createProductTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSeasonalFinancialReportsApi - axios parameter creator
 */
export const AdminSeasonalFinancialReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Generate a season financial report for a contract
         * @param {string} contractId 
         * @param {GenerateSeasonFinancialReportRequest} generateSeasonFinancialReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSeasonFinancialReportsContractContractIdPost: async (contractId: string, generateSeasonFinancialReportRequest: GenerateSeasonFinancialReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminSeasonFinancialReportsContractContractIdPost', 'contractId', contractId)
            // verify required parameter 'generateSeasonFinancialReportRequest' is not null or undefined
            assertParamExists('adminSeasonFinancialReportsContractContractIdPost', 'generateSeasonFinancialReportRequest', generateSeasonFinancialReportRequest)
            const localVarPath = `/admin/season-financial-reports/contract/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateSeasonFinancialReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSeasonalFinancialReportsApi - functional programming interface
 */
export const AdminSeasonalFinancialReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSeasonalFinancialReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Generate a season financial report for a contract
         * @param {string} contractId 
         * @param {GenerateSeasonFinancialReportRequest} generateSeasonFinancialReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSeasonFinancialReportsContractContractIdPost(contractId: string, generateSeasonFinancialReportRequest: GenerateSeasonFinancialReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSeasonFinancialReportsContractContractIdPost(contractId, generateSeasonFinancialReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSeasonalFinancialReportsApi.adminSeasonFinancialReportsContractContractIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSeasonalFinancialReportsApi - factory interface
 */
export const AdminSeasonalFinancialReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSeasonalFinancialReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Generate a season financial report for a contract
         * @param {AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSeasonFinancialReportsContractContractIdPost(requestParameters: AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminSeasonFinancialReportsContractContractIdPost(requestParameters.contractId, requestParameters.generateSeasonFinancialReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminSeasonFinancialReportsContractContractIdPost operation in AdminSeasonalFinancialReportsApi.
 */
export interface AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest {
    readonly contractId: string

    readonly generateSeasonFinancialReportRequest: GenerateSeasonFinancialReportRequest
}

/**
 * AdminSeasonalFinancialReportsApi - object-oriented interface
 */
export class AdminSeasonalFinancialReportsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Generate a season financial report for a contract
     * @param {AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSeasonFinancialReportsContractContractIdPost(requestParameters: AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminSeasonalFinancialReportsApiFp(this.configuration).adminSeasonFinancialReportsContractContractIdPost(requestParameters.contractId, requestParameters.generateSeasonFinancialReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminShipmentsApi - axios parameter creator
 */
export const AdminShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] This endpoint creates a shipment
         * @param {CreateShipmentRequestDto} createShipmentRequestDto Cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsPost: async (createShipmentRequestDto: CreateShipmentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShipmentRequestDto' is not null or undefined
            assertParamExists('adminShipmentsPost', 'createShipmentRequestDto', createShipmentRequestDto)
            const localVarPath = `/admin/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShipmentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {string} [userId] 
         * @param {string} [orderId] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [parcelTypeId] 
         * @param {number | null} [parcelHeight] 
         * @param {number | null} [parcelWidth] 
         * @param {number | null} [parcelDepth] 
         * @param {number | null} [parcelWeight] 
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsRatesGet: async (userId?: string, orderId?: string, shippingOfficeId?: string, parcelTypeId?: string, parcelHeight?: number | null, parcelWidth?: number | null, parcelDepth?: number | null, parcelWeight?: number | null, date?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/shipments/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }

            if (parcelTypeId !== undefined) {
                localVarQueryParameter['parcelTypeId'] = parcelTypeId;
            }

            if (parcelHeight !== undefined) {
                localVarQueryParameter['parcelHeight'] = parcelHeight;
            }

            if (parcelWidth !== undefined) {
                localVarQueryParameter['parcelWidth'] = parcelWidth;
            }

            if (parcelDepth !== undefined) {
                localVarQueryParameter['parcelDepth'] = parcelDepth;
            }

            if (parcelWeight !== undefined) {
                localVarQueryParameter['parcelWeight'] = parcelWeight;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminShipmentsApi - functional programming interface
 */
export const AdminShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] This endpoint creates a shipment
         * @param {CreateShipmentRequestDto} createShipmentRequestDto Cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminShipmentsPost(createShipmentRequestDto: CreateShipmentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateShipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminShipmentsPost(createShipmentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShipmentsApi.adminShipmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {string} [userId] 
         * @param {string} [orderId] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [parcelTypeId] 
         * @param {number | null} [parcelHeight] 
         * @param {number | null} [parcelWidth] 
         * @param {number | null} [parcelDepth] 
         * @param {number | null} [parcelWeight] 
         * @param {Date} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminShipmentsRatesGet(userId?: string, orderId?: string, shippingOfficeId?: string, parcelTypeId?: string, parcelHeight?: number | null, parcelWidth?: number | null, parcelDepth?: number | null, parcelWeight?: number | null, date?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShipmentRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminShipmentsRatesGet(userId, orderId, shippingOfficeId, parcelTypeId, parcelHeight, parcelWidth, parcelDepth, parcelWeight, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShipmentsApi.adminShipmentsRatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminShipmentsApi - factory interface
 */
export const AdminShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminShipmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] This endpoint creates a shipment
         * @param {AdminShipmentsApiAdminShipmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsPost(requestParameters: AdminShipmentsApiAdminShipmentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateShipmentResponse> {
            return localVarFp.adminShipmentsPost(requestParameters.createShipmentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {AdminShipmentsApiAdminShipmentsRatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsRatesGet(requestParameters: AdminShipmentsApiAdminShipmentsRatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetShipmentRatesResponse> {
            return localVarFp.adminShipmentsRatesGet(requestParameters.userId, requestParameters.orderId, requestParameters.shippingOfficeId, requestParameters.parcelTypeId, requestParameters.parcelHeight, requestParameters.parcelWidth, requestParameters.parcelDepth, requestParameters.parcelWeight, requestParameters.date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminShipmentsPost operation in AdminShipmentsApi.
 */
export interface AdminShipmentsApiAdminShipmentsPostRequest {
    /**
     * Cancellation token
     */
    readonly createShipmentRequestDto: CreateShipmentRequestDto
}

/**
 * Request parameters for adminShipmentsRatesGet operation in AdminShipmentsApi.
 */
export interface AdminShipmentsApiAdminShipmentsRatesGetRequest {
    /**
     * 
     */
    readonly userId?: string

    /**
     * 
     */
    readonly orderId?: string

    /**
     * 
     */
    readonly shippingOfficeId?: string

    /**
     * 
     */
    readonly parcelTypeId?: string

    /**
     * 
     */
    readonly parcelHeight?: number | null

    /**
     * 
     */
    readonly parcelWidth?: number | null

    /**
     * 
     */
    readonly parcelDepth?: number | null

    /**
     * 
     */
    readonly parcelWeight?: number | null

    /**
     * 
     */
    readonly date?: Date
}

/**
 * AdminShipmentsApi - object-oriented interface
 */
export class AdminShipmentsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] This endpoint creates a shipment
     * @param {AdminShipmentsApiAdminShipmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminShipmentsPost(requestParameters: AdminShipmentsApiAdminShipmentsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminShipmentsApiFp(this.configuration).adminShipmentsPost(requestParameters.createShipmentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get shipping rates for hypothetical shipment
     * @param {AdminShipmentsApiAdminShipmentsRatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminShipmentsRatesGet(requestParameters: AdminShipmentsApiAdminShipmentsRatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminShipmentsApiFp(this.configuration).adminShipmentsRatesGet(requestParameters.userId, requestParameters.orderId, requestParameters.shippingOfficeId, requestParameters.parcelTypeId, requestParameters.parcelHeight, requestParameters.parcelWidth, requestParameters.parcelDepth, requestParameters.parcelWeight, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminShippingOfficesApi - axios parameter creator
 */
export const AdminShippingOfficesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] list shipping offices
         * @param {boolean} [isFtg] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesGet: async (isFtg?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isFtg !== undefined) {
                localVarQueryParameter['isFtg'] = isFtg;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Delete a shipping office
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminOfficesIdDelete', 'id', id)
            const localVarPath = `/admin/offices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get shipping office with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminOfficesIdGet', 'id', id)
            const localVarPath = `/admin/offices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create a shipping office
         * @param {CreateShippingOfficeRequestDto} createShippingOfficeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPost: async (createShippingOfficeRequestDto: CreateShippingOfficeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShippingOfficeRequestDto' is not null or undefined
            assertParamExists('adminOfficesPost', 'createShippingOfficeRequestDto', createShippingOfficeRequestDto)
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShippingOfficeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update the shipping office
         * @param {UpdateShippingOfficeRequestDto} updateShippingOfficeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPut: async (updateShippingOfficeRequestDto: UpdateShippingOfficeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateShippingOfficeRequestDto' is not null or undefined
            assertParamExists('adminOfficesPut', 'updateShippingOfficeRequestDto', updateShippingOfficeRequestDto)
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShippingOfficeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesSearchGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/offices/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminShippingOfficesApi - functional programming interface
 */
export const AdminShippingOfficesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminShippingOfficesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] list shipping offices
         * @param {boolean} [isFtg] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesGet(isFtg?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesGet(isFtg, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Delete a shipping office
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get shipping office with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create a shipping office
         * @param {CreateShippingOfficeRequestDto} createShippingOfficeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesPost(createShippingOfficeRequestDto: CreateShippingOfficeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesPost(createShippingOfficeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update the shipping office
         * @param {UpdateShippingOfficeRequestDto} updateShippingOfficeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesPut(updateShippingOfficeRequestDto: UpdateShippingOfficeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesPut(updateShippingOfficeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {string} [searchTerm] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfficesSearchGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfficesSearchGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminShippingOfficesApi.adminOfficesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminShippingOfficesApi - factory interface
 */
export const AdminShippingOfficesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminShippingOfficesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] list shipping offices
         * @param {AdminShippingOfficesApiAdminOfficesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesGet(requestParameters: AdminShippingOfficesApiAdminOfficesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfShippingOfficeDto> {
            return localVarFp.adminOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Delete a shipping office
         * @param {AdminShippingOfficesApiAdminOfficesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdDelete(requestParameters: AdminShippingOfficesApiAdminOfficesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOfficesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get shipping office with Id
         * @param {AdminShippingOfficesApiAdminOfficesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdGet(requestParameters: AdminShippingOfficesApiAdminOfficesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShippingOfficeDto> {
            return localVarFp.adminOfficesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create a shipping office
         * @param {AdminShippingOfficesApiAdminOfficesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPost(requestParameters: AdminShippingOfficesApiAdminOfficesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShippingOfficeDto> {
            return localVarFp.adminOfficesPost(requestParameters.createShippingOfficeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update the shipping office
         * @param {AdminShippingOfficesApiAdminOfficesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPut(requestParameters: AdminShippingOfficesApiAdminOfficesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShippingOfficeDto> {
            return localVarFp.adminOfficesPut(requestParameters.updateShippingOfficeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {AdminShippingOfficesApiAdminOfficesSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesSearchGet(requestParameters: AdminShippingOfficesApiAdminOfficesSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfShippingOfficeDto> {
            return localVarFp.adminOfficesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminOfficesGet operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesGetRequest {
    /**
     * 
     */
    readonly isFtg?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminOfficesIdDelete operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesIdDeleteRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminOfficesIdGet operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesIdGetRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminOfficesPost operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesPostRequest {
    /**
     * 
     */
    readonly createShippingOfficeRequestDto: CreateShippingOfficeRequestDto
}

/**
 * Request parameters for adminOfficesPut operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesPutRequest {
    /**
     * 
     */
    readonly updateShippingOfficeRequestDto: UpdateShippingOfficeRequestDto
}

/**
 * Request parameters for adminOfficesSearchGet operation in AdminShippingOfficesApi.
 */
export interface AdminShippingOfficesApiAdminOfficesSearchGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminShippingOfficesApi - object-oriented interface
 */
export class AdminShippingOfficesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] list shipping offices
     * @param {AdminShippingOfficesApiAdminOfficesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesGet(requestParameters: AdminShippingOfficesApiAdminOfficesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Delete a shipping office
     * @param {AdminShippingOfficesApiAdminOfficesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesIdDelete(requestParameters: AdminShippingOfficesApiAdminOfficesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get shipping office with Id
     * @param {AdminShippingOfficesApiAdminOfficesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesIdGet(requestParameters: AdminShippingOfficesApiAdminOfficesIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create a shipping office
     * @param {AdminShippingOfficesApiAdminOfficesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesPost(requestParameters: AdminShippingOfficesApiAdminOfficesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesPost(requestParameters.createShippingOfficeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update the shipping office
     * @param {AdminShippingOfficesApiAdminOfficesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesPut(requestParameters: AdminShippingOfficesApiAdminOfficesPutRequest, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesPut(requestParameters.updateShippingOfficeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
     * @param {AdminShippingOfficesApiAdminOfficesSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOfficesSearchGet(requestParameters: AdminShippingOfficesApiAdminOfficesSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminVendorInvoicesApi - axios parameter creator
 */
export const AdminVendorInvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesInvoiceIdPdfGet: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('adminVendorInvoicesInvoiceIdPdfGet', 'invoiceId', invoiceId)
            const localVarPath = `/admin/vendor-invoices/{invoiceId}/pdf`
                .replace('{invoiceId}', encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {string} vendorId The id of the vendor
         * @param {boolean} [includeProformas] 
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesVendorsVendorIdInvoicesGet: async (vendorId: string, includeProformas?: boolean, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminVendorInvoicesVendorsVendorIdInvoicesGet', 'vendorId', vendorId)
            const localVarPath = `/admin/vendor-invoices/vendors/{vendorId}/invoices`
                .replace('{vendorId}', encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeProformas !== undefined) {
                localVarQueryParameter['includeProformas'] = includeProformas;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminVendorInvoicesApi - functional programming interface
 */
export const AdminVendorInvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminVendorInvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorInvoicesInvoiceIdPdfGet(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProtectedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorInvoicesInvoiceIdPdfGet(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorInvoicesApi.adminVendorInvoicesInvoiceIdPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {string} vendorId The id of the vendor
         * @param {boolean} [includeProformas] 
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorInvoicesVendorsVendorIdInvoicesGet(vendorId: string, includeProformas?: boolean, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminVendorInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorInvoicesVendorsVendorIdInvoicesGet(vendorId, includeProformas, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorInvoicesApi.adminVendorInvoicesVendorsVendorIdInvoicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminVendorInvoicesApi - factory interface
 */
export const AdminVendorInvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminVendorInvoicesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesInvoiceIdPdfGet(requestParameters: AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProtectedUrlDto> {
            return localVarFp.adminVendorInvoicesInvoiceIdPdfGet(requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters: AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminVendorInvoiceDto> {
            return localVarFp.adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters.vendorId, requestParameters.includeProformas, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminVendorInvoicesInvoiceIdPdfGet operation in AdminVendorInvoicesApi.
 */
export interface AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest {
    /**
     * 
     */
    readonly invoiceId: string
}

/**
 * Request parameters for adminVendorInvoicesVendorsVendorIdInvoicesGet operation in AdminVendorInvoicesApi.
 */
export interface AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest {
    /**
     * The id of the vendor
     */
    readonly vendorId: string

    /**
     * 
     */
    readonly includeProformas?: boolean

    /**
     * Offset
     */
    readonly offSet?: number

    /**
     * Page size
     */
    readonly pageSize?: number
}

/**
 * AdminVendorInvoicesApi - object-oriented interface
 */
export class AdminVendorInvoicesApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get the url of the vendor invoice\' pdf
     * @param {AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorInvoicesInvoiceIdPdfGet(requestParameters: AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorInvoicesApiFp(this.configuration).adminVendorInvoicesInvoiceIdPdfGet(requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
     * @param {AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters: AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorInvoicesApiFp(this.configuration).adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters.vendorId, requestParameters.includeProformas, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminVendorsApi - axios parameter creator
 */
export const AdminVendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {string} [searchTerm] currently only searchable by full Id
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsGet: async (searchTerm?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Delete a vendor
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVendorsIdDelete', 'id', id)
            const localVarPath = `/admin/vendors/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get vendor with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVendorsIdGet', 'id', id)
            const localVarPath = `/admin/vendors/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {string} [vendors] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsListGet: async (vendors?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/vendors/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vendors !== undefined) {
                localVarQueryParameter['vendors'] = vendors;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Create a vendor
         * @param {CreateVendorRequestDto} createVendorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPost: async (createVendorRequestDto: CreateVendorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createVendorRequestDto' is not null or undefined
            assertParamExists('adminVendorsPost', 'createVendorRequestDto', createVendorRequestDto)
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVendorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Update the vendor
         * @param {UpdateVendorRequestDto} updateVendorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPut: async (updateVendorRequestDto: UpdateVendorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateVendorRequestDto' is not null or undefined
            assertParamExists('adminVendorsPut', 'updateVendorRequestDto', updateVendorRequestDto)
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVendorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get Contracts Under Vendor
         * @param {string} vendorId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsVendorIdContractsGet: async (vendorId: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminVendorsVendorIdContractsGet', 'vendorId', vendorId)
            const localVarPath = `/admin/vendors/{vendorId}/contracts`
                .replace('{vendorId}', encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminVendorsApi - functional programming interface
 */
export const AdminVendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminVendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {string} [searchTerm] currently only searchable by full Id
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsGet(searchTerm?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfVendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsGet(searchTerm, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Delete a vendor
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get vendor with Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {string} [vendors] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsListGet(vendors?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsListGet(vendors, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Create a vendor
         * @param {CreateVendorRequestDto} createVendorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsPost(createVendorRequestDto: CreateVendorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsPost(createVendorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Update the vendor
         * @param {UpdateVendorRequestDto} updateVendorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsPut(updateVendorRequestDto: UpdateVendorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsPut(updateVendorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get Contracts Under Vendor
         * @param {string} vendorId 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVendorsVendorIdContractsGet(vendorId: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVendorsVendorIdContractsGet(vendorId, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorsApi.adminVendorsVendorIdContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminVendorsApi - factory interface
 */
export const AdminVendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminVendorsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {AdminVendorsApiAdminVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsGet(requestParameters: AdminVendorsApiAdminVendorsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfVendorDto> {
            return localVarFp.adminVendorsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Delete a vendor
         * @param {AdminVendorsApiAdminVendorsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdDelete(requestParameters: AdminVendorsApiAdminVendorsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminVendorsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get vendor with Id
         * @param {AdminVendorsApiAdminVendorsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdGet(requestParameters: AdminVendorsApiAdminVendorsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDto> {
            return localVarFp.adminVendorsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {AdminVendorsApiAdminVendorsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsListGet(requestParameters: AdminVendorsApiAdminVendorsListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<VendorDto> {
            return localVarFp.adminVendorsListGet(requestParameters.vendors, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Create a vendor
         * @param {AdminVendorsApiAdminVendorsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPost(requestParameters: AdminVendorsApiAdminVendorsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDto> {
            return localVarFp.adminVendorsPost(requestParameters.createVendorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Update the vendor
         * @param {AdminVendorsApiAdminVendorsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPut(requestParameters: AdminVendorsApiAdminVendorsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDto> {
            return localVarFp.adminVendorsPut(requestParameters.updateVendorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get Contracts Under Vendor
         * @param {AdminVendorsApiAdminVendorsVendorIdContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsVendorIdContractsGet(requestParameters: AdminVendorsApiAdminVendorsVendorIdContractsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfContractDto> {
            return localVarFp.adminVendorsVendorIdContractsGet(requestParameters.vendorId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminVendorsGet operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsGetRequest {
    /**
     * currently only searchable by full Id
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminVendorsIdDelete operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsIdDeleteRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminVendorsIdGet operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsIdGetRequest {
    /**
     * 
     */
    readonly id: string
}

/**
 * Request parameters for adminVendorsListGet operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsListGetRequest {
    /**
     * 
     */
    readonly vendors?: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminVendorsPost operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsPostRequest {
    /**
     * 
     */
    readonly createVendorRequestDto: CreateVendorRequestDto
}

/**
 * Request parameters for adminVendorsPut operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsPutRequest {
    /**
     * 
     */
    readonly updateVendorRequestDto: UpdateVendorRequestDto
}

/**
 * Request parameters for adminVendorsVendorIdContractsGet operation in AdminVendorsApi.
 */
export interface AdminVendorsApiAdminVendorsVendorIdContractsGetRequest {
    /**
     * 
     */
    readonly vendorId: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * AdminVendorsApi - object-oriented interface
 */
export class AdminVendorsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
     * @param {AdminVendorsApiAdminVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsGet(requestParameters: AdminVendorsApiAdminVendorsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Delete a vendor
     * @param {AdminVendorsApiAdminVendorsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsIdDelete(requestParameters: AdminVendorsApiAdminVendorsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get vendor with Id
     * @param {AdminVendorsApiAdminVendorsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsIdGet(requestParameters: AdminVendorsApiAdminVendorsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Gets all the vendors with the given ids list
     * @param {AdminVendorsApiAdminVendorsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsListGet(requestParameters: AdminVendorsApiAdminVendorsListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsListGet(requestParameters.vendors, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Create a vendor
     * @param {AdminVendorsApiAdminVendorsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsPost(requestParameters: AdminVendorsApiAdminVendorsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsPost(requestParameters.createVendorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Update the vendor
     * @param {AdminVendorsApiAdminVendorsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsPut(requestParameters: AdminVendorsApiAdminVendorsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsPut(requestParameters.updateVendorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get Contracts Under Vendor
     * @param {AdminVendorsApiAdminVendorsVendorIdContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminVendorsVendorIdContractsGet(requestParameters: AdminVendorsApiAdminVendorsVendorIdContractsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminVendorsApiFp(this.configuration).adminVendorsVendorIdContractsGet(requestParameters.vendorId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessIdentifiersApi - axios parameter creator
 */
export const BusinessIdentifiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessIdentifiersTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-identifiers/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessIdentifiersApi - functional programming interface
 */
export const BusinessIdentifiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessIdentifiersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessIdentifiersTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessIdentifierType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.businessIdentifiersTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessIdentifiersApi.businessIdentifiersTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessIdentifiersApi - factory interface
 */
export const BusinessIdentifiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessIdentifiersApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessIdentifiersTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<BusinessIdentifierType>> {
            return localVarFp.businessIdentifiersTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessIdentifiersApi - object-oriented interface
 */
export class BusinessIdentifiersApi extends BaseAPI {
    /**
     * 
     * @summary Gets all the possible business identifier types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public businessIdentifiersTypesGet(options?: RawAxiosRequestConfig) {
        return BusinessIdentifiersApiFp(this.configuration).businessIdentifiersTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CostEstimatesApi - axios parameter creator
 */
export const CostEstimatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch the summary of additional bid costs for a given bid value NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was still the BidCostsController
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [contractId] 
         * @param {string} [eventSettingsId] 
         * @param {number} [bid] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {PublicBoxType} [boxType] 
         * @param {ShippingType} [shippingType] 
         * @param {Date} [eventStartDate] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [userId] 
         * @param {string} [productTypeId] 
         * @param {string} [countryOfOriginIso] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBidCostsGet: async (xPlatformKey: string, contractId?: string, eventSettingsId?: string, bid?: number, currency?: string, destinationCountryCode?: string, boxType?: PublicBoxType, shippingType?: ShippingType, eventStartDate?: Date, shippingOfficeId?: string, userId?: string, productTypeId?: string, countryOfOriginIso?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('internalBidCostsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/internal/bid-costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contractId !== undefined) {
                localVarQueryParameter['ContractId'] = contractId;
            }

            if (eventSettingsId !== undefined) {
                localVarQueryParameter['EventSettingsId'] = eventSettingsId;
            }

            if (bid !== undefined) {
                localVarQueryParameter['Bid'] = bid;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['DestinationCountryCode'] = destinationCountryCode;
            }

            if (boxType !== undefined) {
                localVarQueryParameter['BoxType'] = boxType;
            }

            if (shippingType !== undefined) {
                localVarQueryParameter['ShippingType'] = shippingType;
            }

            if (eventStartDate !== undefined) {
                localVarQueryParameter['EventStartDate'] = (eventStartDate as any instanceof Date) ?
                    (eventStartDate as any).toISOString() :
                    eventStartDate;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }

            if (productTypeId !== undefined) {
                localVarQueryParameter['ProductTypeId'] = productTypeId;
            }

            if (countryOfOriginIso !== undefined) {
                localVarQueryParameter['CountryOfOriginIso'] = countryOfOriginIso;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [basePrice] 
         * @param {boolean} [basePriceIncludesVat] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {string} [destinationStateCode] 
         * @param {PublicBoxType} [boxType] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCostEstimatesGet: async (basePrice?: number, basePriceIncludesVat?: boolean, currency?: string, destinationCountryCode?: string, destinationStateCode?: string, boxType?: PublicBoxType, shippingOfficeId?: string, orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/cost-estimates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (basePrice !== undefined) {
                localVarQueryParameter['BasePrice'] = basePrice;
            }

            if (basePriceIncludesVat !== undefined) {
                localVarQueryParameter['BasePriceIncludesVat'] = basePriceIncludesVat;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['DestinationCountryCode'] = destinationCountryCode;
            }

            if (destinationStateCode !== undefined) {
                localVarQueryParameter['DestinationStateCode'] = destinationStateCode;
            }

            if (boxType !== undefined) {
                localVarQueryParameter['BoxType'] = boxType;
            }

            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CostEstimatesApi - functional programming interface
 */
export const CostEstimatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CostEstimatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch the summary of additional bid costs for a given bid value NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was still the BidCostsController
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [contractId] 
         * @param {string} [eventSettingsId] 
         * @param {number} [bid] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {PublicBoxType} [boxType] 
         * @param {ShippingType} [shippingType] 
         * @param {Date} [eventStartDate] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [userId] 
         * @param {string} [productTypeId] 
         * @param {string} [countryOfOriginIso] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalBidCostsGet(xPlatformKey: string, contractId?: string, eventSettingsId?: string, bid?: number, currency?: string, destinationCountryCode?: string, boxType?: PublicBoxType, shippingType?: ShippingType, eventStartDate?: Date, shippingOfficeId?: string, userId?: string, productTypeId?: string, countryOfOriginIso?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidCostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalBidCostsGet(xPlatformKey, contractId, eventSettingsId, bid, currency, destinationCountryCode, boxType, shippingType, eventStartDate, shippingOfficeId, userId, productTypeId, countryOfOriginIso, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostEstimatesApi.internalBidCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [basePrice] 
         * @param {boolean} [basePriceIncludesVat] 
         * @param {string} [currency] 
         * @param {string} [destinationCountryCode] 
         * @param {string} [destinationStateCode] 
         * @param {PublicBoxType} [boxType] 
         * @param {string} [shippingOfficeId] 
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCostEstimatesGet(basePrice?: number, basePriceIncludesVat?: boolean, currency?: string, destinationCountryCode?: string, destinationStateCode?: string, boxType?: PublicBoxType, shippingOfficeId?: string, orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostEstimateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCostEstimatesGet(basePrice, basePriceIncludesVat, currency, destinationCountryCode, destinationStateCode, boxType, shippingOfficeId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostEstimatesApi.internalCostEstimatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CostEstimatesApi - factory interface
 */
export const CostEstimatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CostEstimatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch the summary of additional bid costs for a given bid value NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was still the BidCostsController
         * @param {CostEstimatesApiInternalBidCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBidCostsGet(requestParameters: CostEstimatesApiInternalBidCostsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BidCostsResponse> {
            return localVarFp.internalBidCostsGet(requestParameters.xPlatformKey, requestParameters.contractId, requestParameters.eventSettingsId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.boxType, requestParameters.shippingType, requestParameters.eventStartDate, requestParameters.shippingOfficeId, requestParameters.userId, requestParameters.productTypeId, requestParameters.countryOfOriginIso, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CostEstimatesApiInternalCostEstimatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCostEstimatesGet(requestParameters: CostEstimatesApiInternalCostEstimatesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CostEstimateResponse> {
            return localVarFp.internalCostEstimatesGet(requestParameters.basePrice, requestParameters.basePriceIncludesVat, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, requestParameters.boxType, requestParameters.shippingOfficeId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalBidCostsGet operation in CostEstimatesApi.
 */
export interface CostEstimatesApiInternalBidCostsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly contractId?: string

    readonly eventSettingsId?: string

    readonly bid?: number

    readonly currency?: string

    readonly destinationCountryCode?: string

    readonly boxType?: PublicBoxType

    readonly shippingType?: ShippingType

    readonly eventStartDate?: Date

    readonly shippingOfficeId?: string

    readonly userId?: string

    readonly productTypeId?: string

    readonly countryOfOriginIso?: string
}

/**
 * Request parameters for internalCostEstimatesGet operation in CostEstimatesApi.
 */
export interface CostEstimatesApiInternalCostEstimatesGetRequest {
    readonly basePrice?: number

    readonly basePriceIncludesVat?: boolean

    readonly currency?: string

    readonly destinationCountryCode?: string

    readonly destinationStateCode?: string

    readonly boxType?: PublicBoxType

    readonly shippingOfficeId?: string

    readonly orderId?: string
}

/**
 * CostEstimatesApi - object-oriented interface
 */
export class CostEstimatesApi extends BaseAPI {
    /**
     * 
     * @summary Fetch the summary of additional bid costs for a given bid value NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was still the BidCostsController
     * @param {CostEstimatesApiInternalBidCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalBidCostsGet(requestParameters: CostEstimatesApiInternalBidCostsGetRequest, options?: RawAxiosRequestConfig) {
        return CostEstimatesApiFp(this.configuration).internalBidCostsGet(requestParameters.xPlatformKey, requestParameters.contractId, requestParameters.eventSettingsId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.boxType, requestParameters.shippingType, requestParameters.eventStartDate, requestParameters.shippingOfficeId, requestParameters.userId, requestParameters.productTypeId, requestParameters.countryOfOriginIso, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CostEstimatesApiInternalCostEstimatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalCostEstimatesGet(requestParameters: CostEstimatesApiInternalCostEstimatesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CostEstimatesApiFp(this.configuration).internalCostEstimatesGet(requestParameters.basePrice, requestParameters.basePriceIncludesVat, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, requestParameters.boxType, requestParameters.shippingOfficeId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CronApi - axios parameter creator
 */
export const CronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [CronJob] close pending fixed-price frame orders older than 24 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAbandonedFixedPriceFrameOrdersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/close-abandoned-fixed-price-frame-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] close open framing orders for which the framing window has closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeFramingOrdersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/close-framing-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] set orders older than a year that are open to closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOldOrdersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/close-old-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary     [CronJob] Order has been delivered after x days run this daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverOrdersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deliver-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Cronjob] fetch current day exchange rates, daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchexchangeratesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fetchexchangerates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manages customers\' pre-authorizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePreAuthorizationPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/manage-pre-authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] mark old orders as unpaid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOldOrdersAsUnpaidPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mark-old-orders-as-unpaid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] notify about paid orders whose framing window has expired and haven\'t been notified yet. optional query param: batchSize (default: 25). Run this every 5 minutes.
         * @param {number} [batchSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyFramingWindowExpiredPost: async (batchSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notify-framing-window-expired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (batchSize !== undefined) {
                localVarQueryParameter['batchSize'] = batchSize;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] set order with payment status processing to open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openProcessingOrdersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/open-processing-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary     [CronJob] create proforma financial reports for ended products in last 7 hours run this every 6 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proformaFinancialReportCreationForEndedEventsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/proforma-financial-report-creation-for-ended-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary     [CronJob] Recalculate Active Contracts\' Progress run this every 6 hours
         * @param {number} [numberOfContracts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateActiveContractsProgressPost: async (numberOfContracts?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recalculate-active-contracts-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numberOfContracts !== undefined) {
                localVarQueryParameter['numberOfContracts'] = numberOfContracts;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] send payment reminders to customer whom didn\'t pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPaymentRemindersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/send-payment-reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] sync a batch of unsynced partners to Odoo (mws.partner). Idempotent — safe to re-run; each invocation processes up to batchSize partners that do not yet have an OdooPartnerId.
         * @param {number} [batchSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPartnersToOdooPost: async (batchSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sync-partners-to-odoo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (batchSize !== undefined) {
                localVarQueryParameter['batchSize'] = batchSize;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger a sync for recent user/customer data. Customer data will be updated to match identity data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerEmailsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/update-customer-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the VAT status on addresses, based on the VAT number and the VIES API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVatStatusAddressesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/update-vat-status-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CronApi - functional programming interface
 */
export const CronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CronApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [CronJob] close pending fixed-price frame orders older than 24 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeAbandonedFixedPriceFrameOrdersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeAbandonedFixedPriceFrameOrdersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.closeAbandonedFixedPriceFrameOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] close open framing orders for which the framing window has closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeFramingOrdersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeFramingOrdersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.closeFramingOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] set orders older than a year that are open to closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeOldOrdersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeOldOrdersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.closeOldOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary     [CronJob] Order has been delivered after x days run this daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliverOrdersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliverOrdersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.deliverOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Cronjob] fetch current day exchange rates, daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchexchangeratesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchexchangeratesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.fetchexchangeratesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manages customers\' pre-authorizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managePreAuthorizationPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managePreAuthorizationPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.managePreAuthorizationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] mark old orders as unpaid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markOldOrdersAsUnpaidPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markOldOrdersAsUnpaidPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.markOldOrdersAsUnpaidPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] notify about paid orders whose framing window has expired and haven\'t been notified yet. optional query param: batchSize (default: 25). Run this every 5 minutes.
         * @param {number} [batchSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyFramingWindowExpiredPost(batchSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyFramingWindowExpiredPost(batchSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.notifyFramingWindowExpiredPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] set order with payment status processing to open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openProcessingOrdersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openProcessingOrdersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.openProcessingOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary     [CronJob] create proforma financial reports for ended products in last 7 hours run this every 6 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proformaFinancialReportCreationForEndedEventsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proformaFinancialReportCreationForEndedEventsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.proformaFinancialReportCreationForEndedEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary     [CronJob] Recalculate Active Contracts\' Progress run this every 6 hours
         * @param {number} [numberOfContracts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateActiveContractsProgressPost(numberOfContracts?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculateActiveContractsProgressPost(numberOfContracts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.recalculateActiveContractsProgressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] send payment reminders to customer whom didn\'t pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPaymentRemindersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPaymentRemindersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.sendPaymentRemindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] sync a batch of unsynced partners to Odoo (mws.partner). Idempotent — safe to re-run; each invocation processes up to batchSize partners that do not yet have an OdooPartnerId.
         * @param {number} [batchSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPartnersToOdooPost(batchSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPartnersToOdooPost(batchSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.syncPartnersToOdooPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger a sync for recent user/customer data. Customer data will be updated to match identity data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerEmailsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerEmailsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.updateCustomerEmailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates the VAT status on addresses, based on the VAT number and the VIES API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVatStatusAddressesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVatStatusAddressesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.updateVatStatusAddressesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CronApi - factory interface
 */
export const CronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CronApiFp(configuration)
    return {
        /**
         * 
         * @summary [CronJob] close pending fixed-price frame orders older than 24 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAbandonedFixedPriceFrameOrdersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.closeAbandonedFixedPriceFrameOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] close open framing orders for which the framing window has closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeFramingOrdersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.closeFramingOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] set orders older than a year that are open to closed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOldOrdersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.closeOldOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary     [CronJob] Order has been delivered after x days run this daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverOrdersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliverOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Cronjob] fetch current day exchange rates, daily
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchexchangeratesPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fetchexchangeratesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manages customers\' pre-authorizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managePreAuthorizationPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.managePreAuthorizationPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] mark old orders as unpaid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOldOrdersAsUnpaidPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markOldOrdersAsUnpaidPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] notify about paid orders whose framing window has expired and haven\'t been notified yet. optional query param: batchSize (default: 25). Run this every 5 minutes.
         * @param {CronApiNotifyFramingWindowExpiredPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyFramingWindowExpiredPost(requestParameters: CronApiNotifyFramingWindowExpiredPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notifyFramingWindowExpiredPost(requestParameters.batchSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] set order with payment status processing to open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openProcessingOrdersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.openProcessingOrdersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary     [CronJob] create proforma financial reports for ended products in last 7 hours run this every 6 hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proformaFinancialReportCreationForEndedEventsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.proformaFinancialReportCreationForEndedEventsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary     [CronJob] Recalculate Active Contracts\' Progress run this every 6 hours
         * @param {CronApiRecalculateActiveContractsProgressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateActiveContractsProgressPost(requestParameters: CronApiRecalculateActiveContractsProgressPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recalculateActiveContractsProgressPost(requestParameters.numberOfContracts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] send payment reminders to customer whom didn\'t pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPaymentRemindersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendPaymentRemindersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] sync a batch of unsynced partners to Odoo (mws.partner). Idempotent — safe to re-run; each invocation processes up to batchSize partners that do not yet have an OdooPartnerId.
         * @param {CronApiSyncPartnersToOdooPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPartnersToOdooPost(requestParameters: CronApiSyncPartnersToOdooPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncPartnersToOdooPost(requestParameters.batchSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger a sync for recent user/customer data. Customer data will be updated to match identity data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerEmailsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCustomerEmailsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the VAT status on addresses, based on the VAT number and the VIES API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVatStatusAddressesPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVatStatusAddressesPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notifyFramingWindowExpiredPost operation in CronApi.
 */
export interface CronApiNotifyFramingWindowExpiredPostRequest {
    readonly batchSize?: number
}

/**
 * Request parameters for recalculateActiveContractsProgressPost operation in CronApi.
 */
export interface CronApiRecalculateActiveContractsProgressPostRequest {
    readonly numberOfContracts?: number
}

/**
 * Request parameters for syncPartnersToOdooPost operation in CronApi.
 */
export interface CronApiSyncPartnersToOdooPostRequest {
    readonly batchSize?: number
}

/**
 * CronApi - object-oriented interface
 */
export class CronApi extends BaseAPI {
    /**
     * 
     * @summary [CronJob] close pending fixed-price frame orders older than 24 hours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public closeAbandonedFixedPriceFrameOrdersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).closeAbandonedFixedPriceFrameOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] close open framing orders for which the framing window has closed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public closeFramingOrdersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).closeFramingOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] set orders older than a year that are open to closed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public closeOldOrdersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).closeOldOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary     [CronJob] Order has been delivered after x days run this daily
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deliverOrdersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).deliverOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Cronjob] fetch current day exchange rates, daily
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchexchangeratesPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).fetchexchangeratesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manages customers\' pre-authorizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managePreAuthorizationPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).managePreAuthorizationPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] mark old orders as unpaid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markOldOrdersAsUnpaidPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).markOldOrdersAsUnpaidPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] notify about paid orders whose framing window has expired and haven\'t been notified yet. optional query param: batchSize (default: 25). Run this every 5 minutes.
     * @param {CronApiNotifyFramingWindowExpiredPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notifyFramingWindowExpiredPost(requestParameters: CronApiNotifyFramingWindowExpiredPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).notifyFramingWindowExpiredPost(requestParameters.batchSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] set order with payment status processing to open
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public openProcessingOrdersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).openProcessingOrdersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary     [CronJob] create proforma financial reports for ended products in last 7 hours run this every 6 hours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public proformaFinancialReportCreationForEndedEventsPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).proformaFinancialReportCreationForEndedEventsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary     [CronJob] Recalculate Active Contracts\' Progress run this every 6 hours
     * @param {CronApiRecalculateActiveContractsProgressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recalculateActiveContractsProgressPost(requestParameters: CronApiRecalculateActiveContractsProgressPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).recalculateActiveContractsProgressPost(requestParameters.numberOfContracts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] send payment reminders to customer whom didn\'t pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendPaymentRemindersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).sendPaymentRemindersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] sync a batch of unsynced partners to Odoo (mws.partner). Idempotent — safe to re-run; each invocation processes up to batchSize partners that do not yet have an OdooPartnerId.
     * @param {CronApiSyncPartnersToOdooPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncPartnersToOdooPost(requestParameters: CronApiSyncPartnersToOdooPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).syncPartnersToOdooPost(requestParameters.batchSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger a sync for recent user/customer data. Customer data will be updated to match identity data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomerEmailsPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).updateCustomerEmailsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the VAT status on addresses, based on the VAT number and the VIES API.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateVatStatusAddressesPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).updateVatStatusAddressesPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrenciesApi - axios parameter creator
 */
export const CurrenciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrenciesApi - functional programming interface
 */
export const CurrenciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currenciesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currenciesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrenciesApi.currenciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CurrenciesApi - factory interface
 */
export const CurrenciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrenciesApiFp(configuration)
    return {
        /**
         * 
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currenciesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrencyDto>> {
            return localVarFp.currenciesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrenciesApi - object-oriented interface
 */
export class CurrenciesApi extends BaseAPI {
    /**
     * 
     * @summary get all currencies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public currenciesGet(options?: RawAxiosRequestConfig) {
        return CurrenciesApiFp(this.configuration).currenciesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerAddressesApi - axios parameter creator
 */
export const CustomerAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesAddressIdStatusPatch: async (customerId: string, addressId: string, billing?: boolean, shipping?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('customersCustomerIdAddressesAddressIdStatusPatch', 'customerId', customerId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('customersCustomerIdAddressesAddressIdStatusPatch', 'addressId', addressId)
            const localVarPath = `/customers/{customerId}/addresses/{addressId}/status`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{addressId}', encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billing !== undefined) {
                localVarQueryParameter['billing'] = billing;
            }

            if (shipping !== undefined) {
                localVarQueryParameter['shipping'] = shipping;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerAddressesApi - functional programming interface
 */
export const CustomerAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCustomerIdAddressesAddressIdStatusPatch(customerId: string, addressId: string, billing?: boolean, shipping?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerAddressDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAddressesApi.customersCustomerIdAddressesAddressIdStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerAddressesApi - factory interface
 */
export const CustomerAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerAddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesAddressIdStatusPatch(requestParameters: CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerAddressDto> {
            return localVarFp.customersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customersCustomerIdAddressesAddressIdStatusPatch operation in CustomerAddressesApi.
 */
export interface CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest {
    /**
     * The id of the customer
     */
    readonly customerId: string

    /**
     * The id of the new billing/shipping address
     */
    readonly addressId: string

    /**
     * Set this address to the user\&#39;s billing address
     */
    readonly billing?: boolean

    /**
     * Set this address to the user\&#39;s shipping address
     */
    readonly shipping?: boolean
}

/**
 * CustomerAddressesApi - object-oriented interface
 */
export class CustomerAddressesApi extends BaseAPI {
    /**
     * 
     * @summary Set a user\'s address to their billing address and/or shipping address
     * @param {CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersCustomerIdAddressesAddressIdStatusPatch(requestParameters: CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return CustomerAddressesApiFp(this.configuration).customersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update customer business identifiers
         * @param {string} customerId 
         * @param {BusinessIdentifierRequestDto} businessIdentifierRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBusinessIdentifiersPatch: async (customerId: string, businessIdentifierRequestDto: BusinessIdentifierRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('customersCustomerIdBusinessIdentifiersPatch', 'customerId', customerId)
            // verify required parameter 'businessIdentifierRequestDto' is not null or undefined
            assertParamExists('customersCustomerIdBusinessIdentifiersPatch', 'businessIdentifierRequestDto', businessIdentifierRequestDto)
            const localVarPath = `/customers/{customerId}/business-identifiers`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(businessIdentifierRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update customer business identifiers
         * @param {string} customerId 
         * @param {BusinessIdentifierRequestDto} businessIdentifierRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersCustomerIdBusinessIdentifiersPatch(customerId: string, businessIdentifierRequestDto: BusinessIdentifierRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersCustomerIdBusinessIdentifiersPatch(customerId, businessIdentifierRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersCustomerIdBusinessIdentifiersPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Update customer business identifiers
         * @param {CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBusinessIdentifiersPatch(requestParameters: CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDto> {
            return localVarFp.customersCustomerIdBusinessIdentifiersPatch(requestParameters.customerId, requestParameters.businessIdentifierRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customersCustomerIdBusinessIdentifiersPatch operation in CustomersApi.
 */
export interface CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest {
    /**
     * 
     */
    readonly customerId: string

    /**
     * 
     */
    readonly businessIdentifierRequestDto: BusinessIdentifierRequestDto
}

/**
 * CustomersApi - object-oriented interface
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @summary Update customer business identifiers
     * @param {CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersCustomerIdBusinessIdentifiersPatch(requestParameters: CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersCustomerIdBusinessIdentifiersPatch(requestParameters.customerId, requestParameters.businessIdentifierRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExchangeRatesApi - axios parameter creator
 */
export const ExchangeRatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeratesCurrentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/exchangerates/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExchangeRatesApi - functional programming interface
 */
export const ExchangeRatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExchangeRatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeratesCurrentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentExchangeRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeratesCurrentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRatesApi.exchangeratesCurrentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExchangeRatesApi - factory interface
 */
export const ExchangeRatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExchangeRatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeratesCurrentGet(options?: RawAxiosRequestConfig): AxiosPromise<CurrentExchangeRatesResponse> {
            return localVarFp.exchangeratesCurrentGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExchangeRatesApi - object-oriented interface
 */
export class ExchangeRatesApi extends BaseAPI {
    /**
     * 
     * @summary Get current exchange rates to and from eur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exchangeratesCurrentGet(options?: RawAxiosRequestConfig) {
        return ExchangeRatesApiFp(this.configuration).exchangeratesCurrentGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalContractsApi - axios parameter creator
 */
export const InternalContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get contract by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalContractsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalContractsIdGet', 'id', id)
            const localVarPath = `/internal/contracts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalContractsApi - functional programming interface
 */
export const InternalContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get contract by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalContractsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalContractsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalContractsApi.internalContractsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalContractsApi - factory interface
 */
export const InternalContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalContractsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get contract by Id
         * @param {InternalContractsApiInternalContractsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalContractsIdGet(requestParameters: InternalContractsApiInternalContractsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContractDto> {
            return localVarFp.internalContractsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalContractsIdGet operation in InternalContractsApi.
 */
export interface InternalContractsApiInternalContractsIdGetRequest {
    readonly id: string
}

/**
 * InternalContractsApi - object-oriented interface
 */
export class InternalContractsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get contract by Id
     * @param {InternalContractsApiInternalContractsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalContractsIdGet(requestParameters: InternalContractsApiInternalContractsIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalContractsApiFp(this.configuration).internalContractsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalCustomersApi - axios parameter creator
 */
export const InternalCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer object by userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('internalCustomersUserUserIdGet', 'userId', userId)
            const localVarPath = `/internal/customers/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdSuspiciousBidInformationGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('internalCustomersUserUserIdSuspiciousBidInformationGet', 'userId', userId)
            const localVarPath = `/internal/customers/user/{userId}/suspicious-bid-information`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalCustomersApi - functional programming interface
 */
export const InternalCustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalCustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get customer object by userId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCustomersUserUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCustomersUserUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalCustomersApi.internalCustomersUserUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCustomersUserUserIdSuspiciousBidInformationGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCustomersUserUserIdSuspiciousBidInformationGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalCustomersApi.internalCustomersUserUserIdSuspiciousBidInformationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalCustomersApi - factory interface
 */
export const InternalCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalCustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get customer object by userId
         * @param {InternalCustomersApiInternalCustomersUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdGet(requestParameters: InternalCustomersApiInternalCustomersUserUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCustomerResponse> {
            return localVarFp.internalCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters: InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalCustomersUserUserIdGet operation in InternalCustomersApi.
 */
export interface InternalCustomersApiInternalCustomersUserUserIdGetRequest {
    readonly userId: string
}

/**
 * Request parameters for internalCustomersUserUserIdSuspiciousBidInformationGet operation in InternalCustomersApi.
 */
export interface InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest {
    /**
     * 
     */
    readonly userId: string
}

/**
 * InternalCustomersApi - object-oriented interface
 */
export class InternalCustomersApi extends BaseAPI {
    /**
     * 
     * @summary Get customer object by userId
     * @param {InternalCustomersApiInternalCustomersUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalCustomersUserUserIdGet(requestParameters: InternalCustomersApiInternalCustomersUserUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalCustomersApiFp(this.configuration).internalCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
     * @param {InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters: InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest, options?: RawAxiosRequestConfig) {
        return InternalCustomersApiFp(this.configuration).internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalOrdersApi - axios parameter creator
 */
export const InternalOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get full order details by id.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalOrdersOrderIdGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('internalOrdersOrderIdGet', 'orderId', orderId)
            const localVarPath = `/internal/orders/{orderId}`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalOrdersApi - functional programming interface
 */
export const InternalOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get full order details by id.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalOrdersOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalOrdersOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalOrdersApi.internalOrdersOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalOrdersApi - factory interface
 */
export const InternalOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get full order details by id.
         * @param {InternalOrdersApiInternalOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalOrdersOrderIdGet(requestParameters: InternalOrdersApiInternalOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.internalOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalOrdersOrderIdGet operation in InternalOrdersApi.
 */
export interface InternalOrdersApiInternalOrdersOrderIdGetRequest {
    readonly orderId: string
}

/**
 * InternalOrdersApi - object-oriented interface
 */
export class InternalOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Get full order details by id.
     * @param {InternalOrdersApiInternalOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalOrdersOrderIdGet(requestParameters: InternalOrdersApiInternalOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalOrdersApiFp(this.configuration).internalOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalPartnersApi - axios parameter creator
 */
export const InternalPartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersContractsGet: async (contracts?: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/partners/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contracts !== undefined) {
                localVarQueryParameter['contracts'] = contracts;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get partner by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalPartnersIdGet', 'id', id)
            const localVarPath = `/internal/partners/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalPartnersApi - functional programming interface
 */
export const InternalPartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalPartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPartnersContractsGet(contracts?: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfPartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPartnersContractsGet(contracts, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalPartnersApi.internalPartnersContractsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get partner by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPartnersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPartnersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalPartnersApi.internalPartnersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalPartnersApi - factory interface
 */
export const InternalPartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalPartnersApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] getting partners by contracts Ids
         * @param {InternalPartnersApiInternalPartnersContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersContractsGet(requestParameters: InternalPartnersApiInternalPartnersContractsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfPartnerDto> {
            return localVarFp.internalPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get partner by Id
         * @param {InternalPartnersApiInternalPartnersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersIdGet(requestParameters: InternalPartnersApiInternalPartnersIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.internalPartnersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalPartnersContractsGet operation in InternalPartnersApi.
 */
export interface InternalPartnersApiInternalPartnersContractsGetRequest {
    readonly contracts?: string

    readonly offSet?: number

    readonly pageSize?: number
}

/**
 * Request parameters for internalPartnersIdGet operation in InternalPartnersApi.
 */
export interface InternalPartnersApiInternalPartnersIdGetRequest {
    readonly id: string
}

/**
 * InternalPartnersApi - object-oriented interface
 */
export class InternalPartnersApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] getting partners by contracts Ids
     * @param {InternalPartnersApiInternalPartnersContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalPartnersContractsGet(requestParameters: InternalPartnersApiInternalPartnersContractsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalPartnersApiFp(this.configuration).internalPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get partner by Id
     * @param {InternalPartnersApiInternalPartnersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalPartnersIdGet(requestParameters: InternalPartnersApiInternalPartnersIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalPartnersApiFp(this.configuration).internalPartnersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalShippingOfficesApi - axios parameter creator
 */
export const InternalShippingOfficesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Internal] list shipping offices
         * @param {boolean} [isFtg] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesGet: async (isFtg?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/shipping-offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isFtg !== undefined) {
                localVarQueryParameter['isFtg'] = isFtg;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get shipping office by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalShippingOfficesIdGet', 'id', id)
            const localVarPath = `/internal/shipping-offices/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalShippingOfficesApi - functional programming interface
 */
export const InternalShippingOfficesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalShippingOfficesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Internal] list shipping offices
         * @param {boolean} [isFtg] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalShippingOfficesGet(isFtg?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalShippingOfficesGet(isFtg, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalShippingOfficesApi.internalShippingOfficesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get shipping office by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalShippingOfficesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingOfficeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalShippingOfficesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalShippingOfficesApi.internalShippingOfficesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalShippingOfficesApi - factory interface
 */
export const InternalShippingOfficesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalShippingOfficesApiFp(configuration)
    return {
        /**
         * 
         * @summary [Internal] list shipping offices
         * @param {InternalShippingOfficesApiInternalShippingOfficesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesGet(requestParameters: InternalShippingOfficesApiInternalShippingOfficesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfShippingOfficeDto> {
            return localVarFp.internalShippingOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get shipping office by Id
         * @param {InternalShippingOfficesApiInternalShippingOfficesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesIdGet(requestParameters: InternalShippingOfficesApiInternalShippingOfficesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShippingOfficeDto> {
            return localVarFp.internalShippingOfficesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalShippingOfficesGet operation in InternalShippingOfficesApi.
 */
export interface InternalShippingOfficesApiInternalShippingOfficesGetRequest {
    /**
     * 
     */
    readonly isFtg?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for internalShippingOfficesIdGet operation in InternalShippingOfficesApi.
 */
export interface InternalShippingOfficesApiInternalShippingOfficesIdGetRequest {
    readonly id: string
}

/**
 * InternalShippingOfficesApi - object-oriented interface
 */
export class InternalShippingOfficesApi extends BaseAPI {
    /**
     * 
     * @summary [Internal] list shipping offices
     * @param {InternalShippingOfficesApiInternalShippingOfficesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalShippingOfficesGet(requestParameters: InternalShippingOfficesApiInternalShippingOfficesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return InternalShippingOfficesApiFp(this.configuration).internalShippingOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get shipping office by Id
     * @param {InternalShippingOfficesApiInternalShippingOfficesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalShippingOfficesIdGet(requestParameters: InternalShippingOfficesApiInternalShippingOfficesIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalShippingOfficesApiFp(this.configuration).internalShippingOfficesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalVendorsApi - axios parameter creator
 */
export const InternalVendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get vendor by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalVendorsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalVendorsIdGet', 'id', id)
            const localVarPath = `/internal/vendors/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalVendorsApi - functional programming interface
 */
export const InternalVendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalVendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get vendor by Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalVendorsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalVendorsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalVendorsApi.internalVendorsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalVendorsApi - factory interface
 */
export const InternalVendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalVendorsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get vendor by Id
         * @param {InternalVendorsApiInternalVendorsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalVendorsIdGet(requestParameters: InternalVendorsApiInternalVendorsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<VendorDto> {
            return localVarFp.internalVendorsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalVendorsIdGet operation in InternalVendorsApi.
 */
export interface InternalVendorsApiInternalVendorsIdGetRequest {
    readonly id: string
}

/**
 * InternalVendorsApi - object-oriented interface
 */
export class InternalVendorsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get vendor by Id
     * @param {InternalVendorsApiInternalVendorsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalVendorsIdGet(requestParameters: InternalVendorsApiInternalVendorsIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalVendorsApiFp(this.configuration).internalVendorsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrdersApi - axios parameter creator
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary (RPC) close a framing order
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdClosePatch: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('ordersFramingExternalIdClosePatch', 'externalId', externalId)
            const localVarPath = `/orders/framing/{externalId}/close`
                .replace('{externalId}', encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (RPC) update or create a framing order by external id.
         * @param {string} externalId 
         * @param {CreateOrUpdateFramingOrderRequest} createOrUpdateFramingOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdPut: async (externalId: string, createOrUpdateFramingOrderRequest: CreateOrUpdateFramingOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('ordersFramingExternalIdPut', 'externalId', externalId)
            // verify required parameter 'createOrUpdateFramingOrderRequest' is not null or undefined
            assertParamExists('ordersFramingExternalIdPut', 'createOrUpdateFramingOrderRequest', createOrUpdateFramingOrderRequest)
            const localVarPath = `/orders/framing/{externalId}`
                .replace('{externalId}', encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateFramingOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [User] get order by id
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod] the payment method for payment
         * @param {string} [shippingAddressId] the shipping address for which the shipping costs need to be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdGet: async (orderId: string, xPlatformKey: string, paymentMethod?: string, shippingAddressId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdGet', 'orderId', orderId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersOrderIdGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/orders/{orderId}`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (shippingAddressId !== undefined) {
                localVarQueryParameter['shippingAddressId'] = shippingAddressId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary (RPC) close a framing order
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersFramingExternalIdClosePatch(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersFramingExternalIdClosePatch(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.ordersFramingExternalIdClosePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary (RPC) update or create a framing order by external id.
         * @param {string} externalId 
         * @param {CreateOrUpdateFramingOrderRequest} createOrUpdateFramingOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersFramingExternalIdPut(externalId: string, createOrUpdateFramingOrderRequest: CreateOrUpdateFramingOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersFramingExternalIdPut(externalId, createOrUpdateFramingOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.ordersFramingExternalIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [User] get order by id
         * @param {string} orderId 
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod] the payment method for payment
         * @param {string} [shippingAddressId] the shipping address for which the shipping costs need to be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersOrderIdGet(orderId: string, xPlatformKey: string, paymentMethod?: string, shippingAddressId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersOrderIdGet(orderId, xPlatformKey, paymentMethod, shippingAddressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.ordersOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary (RPC) close a framing order
         * @param {OrdersApiOrdersFramingExternalIdClosePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdClosePatch(requestParameters: OrdersApiOrdersFramingExternalIdClosePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderDto> {
            return localVarFp.ordersFramingExternalIdClosePatch(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (RPC) update or create a framing order by external id.
         * @param {OrdersApiOrdersFramingExternalIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdPut(requestParameters: OrdersApiOrdersFramingExternalIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDto> {
            return localVarFp.ordersFramingExternalIdPut(requestParameters.externalId, requestParameters.createOrUpdateFramingOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [User] get order by id
         * @param {OrdersApiOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdGet(requestParameters: OrdersApiOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfOrderDto> {
            return localVarFp.ordersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ordersFramingExternalIdClosePatch operation in OrdersApi.
 */
export interface OrdersApiOrdersFramingExternalIdClosePatchRequest {
    /**
     * 
     */
    readonly externalId: string
}

/**
 * Request parameters for ordersFramingExternalIdPut operation in OrdersApi.
 */
export interface OrdersApiOrdersFramingExternalIdPutRequest {
    /**
     * 
     */
    readonly externalId: string

    /**
     * 
     */
    readonly createOrUpdateFramingOrderRequest: CreateOrUpdateFramingOrderRequest
}

/**
 * Request parameters for ordersOrderIdGet operation in OrdersApi.
 */
export interface OrdersApiOrdersOrderIdGetRequest {
    /**
     * 
     */
    readonly orderId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * the payment method for payment
     */
    readonly paymentMethod?: string

    /**
     * the shipping address for which the shipping costs need to be calculated
     */
    readonly shippingAddressId?: string
}

/**
 * OrdersApi - object-oriented interface
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @summary (RPC) close a framing order
     * @param {OrdersApiOrdersFramingExternalIdClosePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersFramingExternalIdClosePatch(requestParameters: OrdersApiOrdersFramingExternalIdClosePatchRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).ordersFramingExternalIdClosePatch(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (RPC) update or create a framing order by external id.
     * @param {OrdersApiOrdersFramingExternalIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersFramingExternalIdPut(requestParameters: OrdersApiOrdersFramingExternalIdPutRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).ordersFramingExternalIdPut(requestParameters.externalId, requestParameters.createOrUpdateFramingOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [User] get order by id
     * @param {OrdersApiOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersOrderIdGet(requestParameters: OrdersApiOrdersOrderIdGetRequest, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).ordersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ParcelsApi - axios parameter creator
 */
export const ParcelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {string} [orderIds] Comma seperated list of order ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelsOrdersGet: async (orderIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parcels/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderIds !== undefined) {
                localVarQueryParameter['orderIds'] = orderIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParcelsApi - functional programming interface
 */
export const ParcelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParcelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {string} [orderIds] Comma seperated list of order ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parcelsOrdersGet(orderIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackingParcelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parcelsOrdersGet(orderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParcelsApi.parcelsOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParcelsApi - factory interface
 */
export const ParcelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParcelsApiFp(configuration)
    return {
        /**
         * 
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {ParcelsApiParcelsOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelsOrdersGet(requestParameters: ParcelsApiParcelsOrdersGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<TrackingParcelDto>> {
            return localVarFp.parcelsOrdersGet(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for parcelsOrdersGet operation in ParcelsApi.
 */
export interface ParcelsApiParcelsOrdersGetRequest {
    /**
     * Comma seperated list of order ids
     */
    readonly orderIds?: string
}

/**
 * ParcelsApi - object-oriented interface
 */
export class ParcelsApi extends BaseAPI {
    /**
     * 
     * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
     * @param {ParcelsApiParcelsOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public parcelsOrdersGet(requestParameters: ParcelsApiParcelsOrdersGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ParcelsApiFp(this.configuration).parcelsOrdersGet(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionsApi - axios parameter creator
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the payment fee for the requested payment
         * @param {string} orderId The id of the order
         * @param {string} [paymentMethod] The requested payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsFeesGet: async (orderId: string, paymentMethod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdPaymentsFeesGet', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/payments/fees`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the payment fee for the requested payment
         * @param {string} orderId The id of the order
         * @param {string} [paymentMethod] The requested payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersOrderIdPaymentsFeesGet(orderId: string, paymentMethod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFeeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersOrderIdPaymentsFeesGet(orderId, paymentMethod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.ordersOrderIdPaymentsFeesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionsApi - factory interface
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the payment fee for the requested payment
         * @param {TransactionsApiOrdersOrderIdPaymentsFeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsFeesGet(requestParameters: TransactionsApiOrdersOrderIdPaymentsFeesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentFeeDto> {
            return localVarFp.ordersOrderIdPaymentsFeesGet(requestParameters.orderId, requestParameters.paymentMethod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ordersOrderIdPaymentsFeesGet operation in TransactionsApi.
 */
export interface TransactionsApiOrdersOrderIdPaymentsFeesGetRequest {
    /**
     * The id of the order
     */
    readonly orderId: string

    /**
     * The requested payment method
     */
    readonly paymentMethod?: string
}

/**
 * TransactionsApi - object-oriented interface
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Get the payment fee for the requested payment
     * @param {TransactionsApiOrdersOrderIdPaymentsFeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersOrderIdPaymentsFeesGet(requestParameters: TransactionsApiOrdersOrderIdPaymentsFeesGetRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).ordersOrderIdPaymentsFeesGet(requestParameters.orderId, requestParameters.paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserOrdersApi - axios parameter creator
 */
export const UserOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [User] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet: async (xPlatformKey: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdCanBeFramedGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdCanBeFramedGet', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/can-be-framed`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdFramingsessionPost: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdFramingsessionPost', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}/framingsession`
                .replace('{orderId}', encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserOrdersApi - functional programming interface
 */
export const UserOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [User] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersGet(xPlatformKey: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersGet(xPlatformKey, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrdersApi.ordersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersOrderIdCanBeFramedGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersOrderIdCanBeFramedGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrdersApi.ordersOrderIdCanBeFramedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ordersOrderIdFramingsessionPost(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FramingSessionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ordersOrderIdFramingsessionPost(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserOrdersApi.ordersOrderIdFramingsessionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserOrdersApi - factory interface
 */
export const UserOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary [User] get paginated result of orders
         * @param {UserOrdersApiOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet(requestParameters: UserOrdersApiOrdersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfOrderDto> {
            return localVarFp.ordersGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {UserOrdersApiOrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdCanBeFramedGet(requestParameters: UserOrdersApiOrdersOrderIdCanBeFramedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.ordersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {UserOrdersApiOrdersOrderIdFramingsessionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdFramingsessionPost(requestParameters: UserOrdersApiOrdersOrderIdFramingsessionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FramingSessionDto> {
            return localVarFp.ordersOrderIdFramingsessionPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ordersGet operation in UserOrdersApi.
 */
export interface UserOrdersApiOrdersGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for ordersOrderIdCanBeFramedGet operation in UserOrdersApi.
 */
export interface UserOrdersApiOrdersOrderIdCanBeFramedGetRequest {
    /**
     * 
     */
    readonly orderId: string
}

/**
 * Request parameters for ordersOrderIdFramingsessionPost operation in UserOrdersApi.
 */
export interface UserOrdersApiOrdersOrderIdFramingsessionPostRequest {
    readonly orderId: string
}

/**
 * UserOrdersApi - object-oriented interface
 */
export class UserOrdersApi extends BaseAPI {
    /**
     * 
     * @summary [User] get paginated result of orders
     * @param {UserOrdersApiOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersGet(requestParameters: UserOrdersApiOrdersGetRequest, options?: RawAxiosRequestConfig) {
        return UserOrdersApiFp(this.configuration).ordersGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [User] Returns a boolean indicating whether framing for an order can be started
     * @param {UserOrdersApiOrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersOrderIdCanBeFramedGet(requestParameters: UserOrdersApiOrdersOrderIdCanBeFramedGetRequest, options?: RawAxiosRequestConfig) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [User] Fetches or creates a framing session for the specified order
     * @param {UserOrdersApiOrdersOrderIdFramingsessionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ordersOrderIdFramingsessionPost(requestParameters: UserOrdersApiOrdersOrderIdFramingsessionPostRequest, options?: RawAxiosRequestConfig) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdFramingsessionPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



